/* ==========================================================================
   Sound Event Detector - Legal & Compliance Translations Module
   Centralized Multilingual Translations for All 9 Legal Documents
   Languages: CS, EN, DE, ES, PT, AR
   ========================================================================== */

export const eulaData = {
  cs: {
    eyebrow: 'PRÁVNÍ DOKUMENTACE & LICENCE',
    title: 'Licenční smlouva s koncovým uživatelem (EULA)',
    subtitle: 'Licenční podmínky pro užívání softwarových produktů Sound Event Detector (SED), SEDTarget, SEDControl, SEDServer a souvisejících modulů společnosti JALUD Embedded s.r.o.',
    version: 'Verze 2026.2 (Aktualizováno v říjnu 2026)',
    tocTitle: 'Obsah licenční smlouvy',
    companyDetails: 'Poskytovatel: JALUD Embedded s.r.o., Nepomucká 1355/261, 326 00 Plzeň, Česká republika, IČO: 03056287',
    preamble: 'Tato licenční smlouva s koncovým uživatelem („EULA“) představuje právně závaznou dohodu mezi vámi (fyzickou nebo právnickou osobou jako „Nabyvatelem“, ať již přímo jako „Koncovým uživatelem“, nebo jako autorizovaným „Systémovým integrátorem či Distributorem“ dodávajícím řešení Koncovému uživateli) a společností JALUD Embedded s.r.o. („Poskytovatel“ nebo „JALUD“). Instalací, stažením, aktivací, nasazením nebo jiným užíváním softwaru JALUD potvrzujete, že jste se s těmito podmínkami seznámili a zavazujete se je dodržovat.',
    sections: [
      {
        id: 'eula-1',
        num: '1',
        title: 'Vymezení pojmů a předmět smlouvy',
        text: 'Softwarem se rozumí softwarové produkty JALUD, zejména Sound Event Detector (SED), SEDTarget, SEDControl, SEDServer, embedded balíčky ACAP (Axis Camera Application Platform), HEOP (Hikvision Embedded Open Platform), moduly pro kamery Hanwha, firmware SED Edge a další proprietární software, včetně veškerých aktualizací, neuronových modelů akustické detekce a doprovodné dokumentace. Předmětem této smlouvy je udělení nevýhradní licence k užívání Softwaru za podmínek zde stanovených. „Koncovým uživatelem“ se rozumí subjekt, který Software finálně provozuje pro vlastní vnitřní bezpečnostní a provozní potřeby. „Systémovým integrátorem / Distributorem“ se rozumí autorizovaný obchodní partner, který Software či hardware JALUD integruje do zákaznického řešení a postupuje licenci určenému Koncovému uživateli.'
      },
      {
        id: 'eula-2',
        num: '2',
        title: 'Udělení licence, rozsah užívání a převoditelnost přes integrátory',
        text: 'Poskytovatel uděluje Nabyvateli časově omezenou (v případě předplatného) nebo trvalou (v případě jednorázové perpetual licence), nevýhradní licenci k provozování Softwaru výhradně na schváleném počtu zařízení, kamer, serverů nebo procesorových jader stanovených v licenčním certifikátu nebo objednávce. Pro Koncového uživatele je licence určena výhradně pro jeho vnitřní obchodní a bezpečnostní potřeby a je nepřevoditelná na další subjekty bez předchozího písemného souhlasu Poskytovatele. Výjimka pro systémové integrátory a distribuční partnery: Autorizovaní systémoví integrátoři a distributoři, kteří pořizují Software nebo zařízení JALUD pro své zákazníky, jsou výslovně oprávněni licenci jednorázově převést (postoupit) na určeného Koncového uživatele v rámci realizace zakázky či prodeje řešení, za podmínky, že: (a) Koncový uživatel je před převodem prokazatelně seznámen s touto EULA a akceptuje ji; (b) integrátor si neponechá žádnou kopii Softwaru, aktivní licenci ani licenční klíč pro své vlastní další použití; a (c) licence vázaná na konkrétní hardware (např. MAC adresa kamery, sériové číslo zařízení SED) smí být převedena pouze společně s daným hardwarem. Jakýkoliv další přeprodej, druhotný převod či sublicencování Koncovým uživatelem bez předchozího písemného souhlasu JALUD je zakázán.'
      },
      {
        id: 'eula-3',
        num: '3',
        title: 'Asistivní technologie a lidský dohled',
        text: 'Software Sound Event Detector (SED) je asistivní analytický nástroj navržený k upozornění lidské obsluhy na výskyt specifických akustických událostí (např. střelba, výkřik, tříštění skla, sirény, průmyslové zvuky). Software nenahrazuje profesionální lidský úsudek, bezpečnostní složky, policii ani záchranné služby. Veškerá rozhodnutí o bezpečnostních zásazích, vyslání hlídek nebo aktivaci poplachových systémů musí činit kvalifikovaný lidský operátor.'
      },
      {
        id: 'eula-4',
        num: '4',
        title: 'Pravděpodobnostní povaha akustické AI a detekční limity',
        text: 'Akustická detekce založená na strojovém učení a neuronových sítích má z technické podstaty pravděpodobnostní charakter. Poskytovatel nezaručuje bezchybnou ani nepřetržitou detekci všech akustických událostí za všech okolností. Přesnost klasifikace může být ovlivněna akustickými vlastnostmi prostoru, dozvukem, okolním hlukem (vítr, déšť, doprava, stroje), fyzickými překážkami, kvalitou a umístěním mikrofonu a interferencemi. Mohou se vyskytnout falešně pozitivní i falešně negativní detekce.'
      },
      {
        id: 'eula-5',
        num: '5',
        title: 'Kritická prostředí a bezpečnostní výluky',
        text: 'Software není certifikován jako bezpečnostní komponenta odolná proti selhání (fail-safe) pro použití v prostředí s vysokým rizikem, kde selhání technologie může přímo vést k úmrtí, zranění osob nebo těžkým škodám na životním prostředí (např. řízení jaderných zařízení, systémů přímé podpory života, zbraňových systémů). Užívání v takových prostředích je na výlučné riziko Nabyvatele.'
      },
      {
        id: 'eula-6',
        num: '6',
        title: 'Závislost na hardwaru a platformách třetích stran',
        text: 'Provoz Softwaru může vyžadovat integraci s hardwarem a platformami třetích stran (např. kamery Axis, Hikvision, Hanwha, systémy správy videa Milestone XProtect, Genetec Security Center a síťovou infrastrukturu). Poskytovatel neodpovídá za výpadky, změny firmwaru, nekompatibilitu, vady hardwaru třetích stran ani selhání síťového přenosu, které jsou mimo přímou kontrolu Poskytovatele.'
      },
      {
        id: 'eula-7',
        num: '7',
        title: 'Instalace, akustická kalibrace a prostředí',
        text: 'Správná instalace mikrofonů, dodržení akustické přímé viditelnosti, nastavení citlivosti a ověření akustického pokrytí jsou nezbytné pro spolehlivou funkci. Nabyvatel odpovídá za instalaci v souladu s manuály Poskytovatele nebo za zajištění instalace certifikovaným partnerem. Změny v okolním prostředí (např. nová výstavba, instalace hlučných technologií) mohou vyžadovat rekalibraci.'
      },
      {
        id: 'eula-8',
        num: '8',
        title: 'Aktualizace, údržba a technická podpora',
        text: 'Poskytovatel může vydávat aktualizace Softwaru zahrnující bezpečnostní záplaty, optimalizace algoritmů nebo nové detekční modely. Poskytování podpory, aktualizací a servisních služeb se řídí samostatným dokumentem <a href="/support-and-maintenance" data-route="support-and-maintenance" style="color: var(--blue-primary); text-decoration: underline; font-weight: 600;">Podmínky podpory a údržby (Support & Maintenance Terms)</a>.'
      },
      {
        id: 'eula-9',
        num: '9',
        title: '30denní zkušební licence (Trial License)',
        text: 'Poskytovatel může Nabyvateli poskytnout časově omezenou zkušební licenci na dobu 30 dnů pro účely testování, ověření funkčnosti nebo Proof-of-Concept (PoC). Zkušební licence je určena výhradně pro neprodukční zkoušky a může mít technická či funkční omezení. Pokud není písemně sjednáno jinak, zkušební licence nezakládá nárok na vrácení plateb, kompenzaci škody ani garanci komerčního nasazení.'
      },
      {
        id: 'eula-10',
        num: '10',
        title: 'Duševní vlastnictví a zákaz zpětného inženýrství',
        text: 'Veškerá autorská práva, patenty, ochranné známky, obchodní tajemství, architektura neuronových sítí, datové sady a trénované modely zůstávají výhradním majetkem společnosti JALUD Embedded s.r.o. Nabyvatel nesmí Software dekompilovat, analyzovat reverzním inženýrstvím, modifikovat, extrahovat váhy neuronových modelů ani vytvářet odvozená díla bez předchozího písemného souhlasu.'
      },
      {
        id: 'eula-11',
        num: '11',
        title: 'Ochrana osobních údajů a soukromí',
        text: 'Zpracování dat při provozu Softwaru se řídí zásadami uvedenými v dokumentu <a href="/product-privacy" data-route="product-privacy" style="color: var(--blue-primary); text-decoration: underline; font-weight: 600;">Produktové soukromí a ochrana dat</a>. Software v lokální edge konfiguraci analyzuje zvuk v reálném čase v paměti RAM a lidskou řeč neukládá ani nenahrává. SED není navržen k identifikaci konkrétních mluvčích ani k provádění biometrické identifikace osob.'
      },
      {
        id: 'eula-12',
        num: '12',
        title: 'Oprávnění a povinnosti systémových integrátorů a distributorů',
        text: 'Certifikovaní partneři, systémoví integrátoři a distributoři jsou oprávněni dodávat, integrovat a převádět licence k Softwaru (včetně embedded licencí dodávaných na zařízeních SED a kamerách) třetím stranám – svým koncovým zákazníkům (Koncovým uživatelům). Integrátor nebo distributor je v takovém případě povinen: (a) zajistit, aby byl Koncový uživatel před zahájením užívání Softwaru prokazatelně seznámen s touto EULA a zavázal se ji dodržovat; (b) předat Koncovému uživateli veškerou povinnou dokumentaci, návody k obsluze a originální licenční certifikáty vystavené Poskytovatelem; (c) po předání řešení zákazníkovi nepoužívat licenční klíče pro jiné instalace a neponechávat si přístupová oprávnění k provozu Softwaru na vlastní účet; a (d) neposkytovat jménem JALUD žádné záruky ani SLA překračující oficiální podmínky Poskytovatele bez předchozího písemného schválení.'
      },
      {
        id: 'eula-13',
        num: '13',
        title: 'Vyloučení záruk a omezení odpovědnosti',
        text: 'Software je poskytován „tak, jak je“ a „jak je k dispozici“. V maximálním rozsahu povoleném platným právem Poskytovatel vylučuje jakékoli implicitní záruky prodejnosti či vhodnosti pro konkrétní účel. Celková souhrnná odpovědnost Poskytovatele za veškeré nároky vzniklé v souvislosti s touto smlouvou je omezena na částku skutečně zaplacenou Nabyvatelem za licenci k Softwaru v předchozích 12 měsících. Poskytovatel neodpovídá za nepřímé, náhodné či následné škody, ušlý zisk ani ztrátu dat.'
      },
      {
        id: 'eula-14',
        num: '14',
        title: 'Specifika pro veřejný sektor a samosprávy',
        text: 'Při nasazení v projektech Smart Cities, obecní policie nebo veřejné správy odpovídá Nabyvatel za dodržení příslušných veřejnoprávních předpisů o monitorování veřejných prostranství, informačních povinností vůči veřejnosti a posouzení vlivu na ochranu osobních údajů (DPIA).'
      },
      {
        id: 'eula-15',
        num: '15',
        title: 'Doba platnosti, ukončení a rozhodné právo',
        text: 'Tato smlouva nabývá účinnosti prvním použitím Softwaru a trvá po dobu platnosti licence. V případě závažného porušení podmínek Nabyvatelem je Poskytovatel oprávněn licenci okamžitě vypovědět. Tato smlouva se řídí právním řádem České republiky. Veškeré spory budou řešeny věcně a místně příslušnými soudy v Plzni, Česká republika.'
      }
    ],
    crossLinksTitle: 'Související právní dokumenty',
    crossLinks: [
      { route: 'terms-and-conditions', name: 'Obchodní podmínky (Terms & Conditions)', desc: 'Obchodní vztah, objednávky, platby a hardware' },
      { route: 'support-and-maintenance', name: 'Podmínky podpory a údržby', desc: 'Úrovně podpory, aktualizace AI a cílové reakční doby' },
      { route: 'product-privacy', name: 'Produktové soukromí a ochrana dat', desc: 'Technická architektura ochrany soukromí u SED' },
      { route: 'data-processing-agreement', name: 'Smlouva o zpracování údajů (DPA)', desc: 'Ujednání dle čl. 28 GDPR pro cloudové služby' }
    ]
  },
  en: {
    eyebrow: 'LEGAL AGREEMENTS & LICENSING',
    title: 'End User License Agreement (EULA)',
    subtitle: 'Standard software license terms for Sound Event Detector (SED), SEDTarget, SEDControl, SEDServer and associated edge modules by JALUD Embedded s.r.o.',
    version: 'Version 2026.2 (Updated October 2026)',
    tocTitle: 'Table of Contents',
    companyDetails: 'Licensor: JALUD Embedded s.r.o., Nepomucká 1355/261, 326 00 Plzeň, Czech Republic, Reg. ID: 03056287',
    preamble: 'This End User License Agreement ("EULA") is a legally binding agreement between you (an individual or legal entity, as "Licensee", whether acting directly as the "End User / End Customer" or as an authorized "Systems Integrator or Distributor" delivering the solution to an End Customer) and JALUD Embedded s.r.o. ("Licensor" or "JALUD"). By installing, downloading, activating, deploying, or otherwise using JALUD software, you acknowledge that you have read, understood, and agreed to be bound by these terms.',
    sections: [
      {
        id: 'eula-1',
        num: '1',
        title: 'Definitions and Subject Matter',
        text: 'Software refers to JALUD software solutions, specifically Sound Event Detector (SED), SEDTarget, SEDControl, SEDServer, ACAP (Axis Camera Application Platform) packages, HEOP (Hikvision Embedded Open Platform) applications, Hanwha camera integrations, SED Edge firmware, and other proprietary software modules, including updates, neural detection models, and documentation. "End User" or "End Customer" means the ultimate third-party entity operating the Software for its internal security and operational needs. "Systems Integrator / Distributor" means an authorized channel partner acquiring the Software or JALUD hardware for integration, delivery, and license transfer to a designated End Customer.'
      },
      {
        id: 'eula-2',
        num: '2',
        title: 'License Grant, Scope of Use, and Transferability via Integrators',
        text: 'Licensor grants Licensee a non-exclusive license (time-limited subscription or perpetual license, as set forth in the applicable license certificate or purchase order) to operate the Software solely on the designated number of devices, cameras, channels, servers, or processor cores authorized in the order. For the End Customer, the license is granted solely for its internal business, operational, and security purposes, and is non-transferable and non-sublicensable to subsequent parties without Licensor\'s prior written consent. Exception for Systems Integrators and Distributors: Authorized systems integrators, value-added resellers, and distributors procuring the Software or SED hardware for their clients are expressly authorized to transfer the license on a one-time basis to the designated End Customer in connection with project delivery or resale of the system, provided that: (a) the End Customer is formally notified of and accepts this EULA in full prior to commissioning; (b) the integrator/distributor retains no copies, active license keys, or operational instances of the transferred Software for itself; and (c) any license tied to specific hardware (e.g., camera MAC address or SED device serial number) is transferred strictly together with that designated physical hardware. Any further secondary transfer, resale, sublicensing, or timesharing by the End Customer without Licensor\'s prior written approval is strictly prohibited.'
      },
      {
        id: 'eula-3',
        num: '3',
        title: 'Assistive Technology and Human Oversight',
        text: 'Sound Event Detector (SED) is an assistive situational awareness and acoustic analytics tool designed to alert security and operational personnel to specific acoustic events (such as gunshots, screams, breaking glass, sirens, or industrial anomalies). The Software does not replace human judgment, certified alarm systems, law enforcement, or emergency services. All operational decisions, deployment of personnel, and triggering of physical responses must remain under the oversight of qualified human operators.'
      },
      {
        id: 'eula-4',
        num: '4',
        title: 'Probabilistic Nature of Acoustic AI and Detection Limits',
        text: 'Acoustic event detection driven by machine learning and deep neural networks is inherently probabilistic. Licensor does not warrant or represent that the Software will achieve error-free or uninterrupted detection under all environmental conditions. Classification accuracy is subject to acoustic environment properties, reverberation, ambient noise levels (wind, rain, road traffic, heavy machinery), physical acoustic obstructions, microphone quality and orientation, and electrical interference. False positives and false negatives may occur.'
      },
      {
        id: 'eula-5',
        num: '5',
        title: 'Critical Environments and Safety Exclusions',
        text: 'The Software is not fault-tolerant or fail-safe and is not designed, certified, or intended for use in high-risk or hazardous environments requiring fail-safe performance where failure could lead directly to death, personal injury, severe physical damage, or environmental catastrophe (e.g., nuclear facility control, aircraft navigation, life support systems, or weapons control). Any such deployment is strictly at Licensee’s sole risk.'
      },
      {
        id: 'eula-6',
        num: '6',
        title: 'Hardware Dependencies and Third-Party Platforms',
        text: 'Operation of the Software may rely on interoperability with third-party hardware and platforms, including network cameras (Axis, Hikvision, Hanwha), Video Management Systems (VMS such as Milestone XProtect or Genetec Security Center), network switches, and audio sensors. Licensor is not responsible for hardware defects, third-party firmware revisions, API changes, or network communication failures beyond Licensor’s direct control.'
      },
      {
        id: 'eula-7',
        num: '7',
        title: 'Installation, Acoustic Calibration, and Environment',
        text: 'Proper physical installation of microphones, maintenance of acoustic line-of-sight, correct input gain calibration, and verification of coverage zones are essential for optimal operation. Licensee is responsible for ensuring installation follows Licensor’s official deployment manuals or is conducted by a certified systems integrator. Environmental alterations (such as new architectural structures or nearby construction) may necessitate system recalibration.'
      },
      {
        id: 'eula-8',
        num: '8',
        title: 'Updates, Maintenance, and Support',
        text: 'Licensor may periodically release software updates, security patches, algorithm enhancements, and revised neural sound models. Technical support, update entitlements, and maintenance services are governed by the dedicated <a href="/support-and-maintenance" data-route="support-and-maintenance" style="color: var(--blue-primary); text-decoration: underline; font-weight: 600;">Support & Maintenance Terms</a>.'
      },
      {
        id: 'eula-9',
        num: '9',
        title: '30-Day Trial License (Proof of Concept)',
        text: 'Licensor may provide Licensee with a temporary 30-day trial license for Sound Event Detector for testing, evaluation, or Proof-of-Concept (PoC) purposes. Trial licenses are temporary and may be subject to technical, device, or operational restrictions. Unless explicitly agreed in writing, a trial license is provided solely for evaluation, does not constitute a commercial production license, and carries no entitlement to refunds or financial remedies.'
      },
      {
        id: 'eula-10',
        num: '10',
        title: 'Intellectual Property and Reverse Engineering Prohibitions',
        text: 'All copyrights, patents, trade secrets, trademarks, algorithmic architectures, neural network weights, training datasets, and proprietary software code remain the exclusive intellectual property of JALUD Embedded s.r.o. Licensee shall not decompile, disassemble, reverse engineer, extract model weights, modify, adapt, or create derivative works of the Software without express prior written consent.'
      },
      {
        id: 'eula-11',
        num: '11',
        title: 'Privacy and Data Protection',
        text: 'Data handling and privacy practices relating to the Software are governed by the <a href="/product-privacy" data-route="product-privacy" style="color: var(--blue-primary); text-decoration: underline; font-weight: 600;">Product Privacy & Data Protection</a> policy. In standard edge deployment, the Software processes audio strictly in volatile RAM and discards continuous ambient speech without recording. SED is not designed to identify individual speakers or perform biometric identification of persons.'
      },
      {
        id: 'eula-12',
        num: '12',
        title: 'Integrator and Distributor Rights and Obligations',
        text: 'Certified distributors, systems integrators, and resellers are authorized to deploy, integrate, and transfer licenses for the Software (including edge licenses embedded in SED units and network cameras) to third-party clients (End Customers). In doing so, the integrator or distributor is obligated to: (a) ensure that the End Customer receives, reviews, and formally accepts this EULA prior to commissioning the Software; (b) deliver all official JALUD user documentation, installation guidelines, and license certificates to the End Customer; (c) cease all internal use of the transferred license upon project handover and not reuse license credentials across multiple sites or customers; and (d) make no representations, warranties, or SLA commitments on behalf of JALUD that exceed the official published terms without Licensor\'s prior written authorization.'
      },
      {
        id: 'eula-13',
        num: '13',
        title: 'Disclaimer of Warranties and Limitation of Liability',
        text: 'To the maximum extent permitted by applicable law, the Software is provided "AS IS" and "AS AVAILABLE" without warranties of any kind, whether express, implied, or statutory. In no event shall Licensor’s aggregate liability arising out of or related to this agreement exceed the total license fees actually paid by Licensee for the affected Software in the preceding twelve (12) months. Licensor shall not be liable for indirect, incidental, punitive, or consequential damages, loss of profits, or data loss.'
      },
      {
        id: 'eula-14',
        num: '14',
        title: 'Public Sector and Municipal Deployments',
        text: 'When deployed in public spaces, Smart Cities, or municipal safety projects, Licensee is solely responsible for compliance with statutory notice requirements, public monitoring regulations, surveillance signage, and Data Protection Impact Assessments (DPIA).'
      },
      {
        id: 'eula-15',
        num: '15',
        title: 'Term, Termination, and Governing Law',
        text: 'This EULA is effective upon installation or first use of the Software and continues until terminated. Licensor may terminate the license immediately upon material breach by Licensee. This agreement is governed by the laws of the Czech Republic, excluding its conflict-of-law rules and the UN Convention on Contracts for the International Sale of Goods (CISG). Any legal action shall be submitted to the competent courts in Plzeň, Czech Republic.'
      }
    ],
    crossLinksTitle: 'Related Legal Documents',
    crossLinks: [
      { route: 'terms-and-conditions', name: 'Terms & Conditions', desc: 'Commercial relationship, orders, payment terms, and hardware warranty' },
      { route: 'support-and-maintenance', name: 'Support & Maintenance Terms', desc: 'Support channels, AI model updates, and target response times' },
      { route: 'product-privacy', name: 'Product Privacy & Data Protection', desc: 'Technical edge privacy architecture and data governance' },
      { route: 'data-processing-agreement', name: 'Data Processing Agreement (DPA)', desc: 'Standard GDPR Art. 28 terms for cloud-connected services' }
    ]
  },
  de: {
    eyebrow: 'RECHTSDOKUMENTATION & LIZENZEN',
    title: 'Endbenutzer-Lizenzvereinbarung (EULA)',
    subtitle: 'Standard-Lizenzbedingungen für Sound Event Detector (SED), SEDTarget, SEDControl, SEDServer und Edge-Module der JALUD Embedded s.r.o.',
    version: 'Version 2026.2 (Aktualisiert im Oktober 2026)',
    tocTitle: 'Inhaltsverzeichnis',
    companyDetails: 'Lizenzgeber: JALUD Embedded s.r.o., Nepomucká 1355/261, 326 00 Plzeň, Tschechische Republik, Id-Nr.: 03056287',
    preamble: 'Diese Endbenutzer-Lizenzvereinbarung („EULA“) ist eine rechtsverbindliche Vereinbarung zwischen Ihnen (einer natürlichen oder juristischen Person als „Lizenznehmer“, sei es direkt als „Endkunde / Endnutzer“ oder als autorisierter „Systemintegrator oder Distributor“, der die Lösung an einen Endkunden liefert) und der JALUD Embedded s.r.o. („Lizenzgeber“ oder „JALUD“). Durch die Installation, den Download, die Aktivierung oder die sonstige Nutzung der Software erklären Sie sich mit diesen Bedingungen einverstanden.',
    sections: [
      {
        id: 'eula-1',
        num: '1',
        title: 'Begriffsbestimmungen und Vertragsgegenstand',
        text: 'Software bezeichnet die Softwarelösungen von JALUD, insbesondere Sound Event Detector (SED), SEDTarget, SEDControl, SEDServer, ACAP- und HEOP-Kamerapakete, Hanwha-Module, SED Edge-Firmware sowie zugehörige neuronale Erkennungsmodelle und Dokumentationen. „Endkunde“ bezeichnet die Stelle, welche die Software für eigene betriebliche und sicherheitsbezogene Zwecke betreibt. „Systemintegrator / Distributor“ bezeichnet einen autorisierten Partner, der die Software oder JALUD-Hardware in Kundenprojekte integriert und die Lizenz an den vorgesehenen Endkunden überträgt.'
      },
      {
        id: 'eula-2',
        num: '2',
        title: 'Lizenzgewährung, Nutzungsumfang und Übertragbarkeit über Integratoren',
        text: 'Der Lizenzgeber gewährt dem Lizenznehmer eine nicht-exklusive Lizenz (im Rahmen eines Abonnements oder als unbefristete Dauerlizenz) zur Nutzung der Software auf der vertraglich vereinbarten Anzahl von Geräten, Kameras, Servern oder Prozessorkernen. Für den Endkunden ist die Lizenz ausschließlich für eigene interne Sicherheits- und Betriebszwecke bestimmt und ohne vorherige schriftliche Zustimmung des Lizenzgebers nicht auf Dritte übertragbar oder unterlizenzierbar. Ausnahme für Systemintegratoren und Vertriebspartner: Autorisierte Systemintegratoren und Distributoren, die Software oder JALUD-Geräte für ihre Kunden erwerben, sind ausdrücklich berechtigt, die Lizenz im Rahmen der Projektrealisierung bzw. des Weiterverkaufs einmalig an den benannten Endkunden zu übertragen, vorausgesetzt: (a) der Endkunde akzeptiert diese EULA vor der Inbetriebnahme nachweislich in vollem Umfang; (b) der Integrator/Distributor behält keine Kopien, aktiven Lizenzschlüssel oder Betriebsinstanzen der übertragenen Software für sich; und (c) an spezifische Hardware gebundene Lizenzen (z. B. Kamera-MAC-Adresse oder SED-Seriennummer) werden ausschließlich zusammen mit der betreffenden Hardware übertragen. Jede weitere Weiterübertragung oder Unterlizenzierung durch den Endkunden ist ohne vorherige schriftliche Genehmigung von JALUD untersagt.'
      },
      {
        id: 'eula-3',
        num: '3',
        title: 'Assistenztechnologie und menschliche Aufsicht',
        text: 'Sound Event Detector (SED) ist ein akustisches Assistenzsystem, das darauf ausgelegt ist, Sicherheitspersonal auf bestimmte akustische Ereignisse (z. B. Schüsse, Schreie, Glasbruch, Sirenen) hinzuweisen. Die Software ersetzt weder professionelles Urteilsvermögen noch Notfalldienste. Alle Einsatzentscheidungen müssen durch menschliches Personal getroffen werden.'
      },
      {
        id: 'eula-4',
        num: '4',
        title: 'Wahrscheinlichkeitscharakter akustischer KI',
        text: 'Akustische KI-Erkennung basiert auf physikalischen und stochastischen Verfahren. Der Lizenzgeber gewährleistet keine fehlerfreie oder unterbrechungsfreie Erkennung unter allen Umweltbedingungen. Hall, Nebengeräusche, Wind oder physische Hindernisse können die Erkennung beeinflussen. Falsch-positive und falsch-negative Ereignisse können auftreten.'
      },
      {
        id: 'eula-5',
        num: '5',
        title: 'Kritische Umgebungen und Sicherheitsausschlüsse',
        text: 'Die Software ist nicht ausfallsicher (fail-safe) konzipiert und nicht für Umgebungen zertifiziert, in denen ein Funktionsausfall zu Tod, Körperverletzung oder schweren Umweltschäden führen kann.'
      },
      {
        id: 'eula-6',
        num: '6',
        title: 'Drittanbieter-Hardware und Plattformen',
        text: 'Der Betrieb der Software setzt Schnittstellen zu Kamerasystemen (Axis, Hikvision, Hanwha) und VMS-Plattformen (Milestone, Genetec) voraus. Der Lizenzgeber haftet nicht für Hardwareausfälle oder Softwareänderungen von Drittanbietern.'
      },
      {
        id: 'eula-7',
        num: '7',
        title: 'Installation und akustische Kalibrierung',
        text: 'Eine ordnungsgemäße Mikrofoninstallation und akustische Sichtlinie sind für den zuverlässigen Betrieb erforderlich. Der Lizenznehmer ist für die fachgerechte Montage und Einhaltung der Installationshandbücher verantwortlich.'
      },
      {
        id: 'eula-8',
        num: '8',
        title: 'Aktualisierungen und Support',
        text: 'Softwareaktualisierungen und technische Unterstützungsleistungen richten sich nach den <a href="/support-and-maintenance" data-route="support-and-maintenance" style="color: var(--blue-primary); text-decoration: underline; font-weight: 600;">Bedingungen für Support und Wartung</a>.'
      },
      {
        id: 'eula-9',
        num: '9',
        title: '30-Tage-Testlizenz (Trial License)',
        text: 'Der Lizenzgeber kann eine zeitlich befristete 30-Tage-Testlizenz zu Evaluierungs- und PoC-Zwecken bereitstellen. Testlizenzen dienen ausschließlich der Evaluierung, begründen keine Geld-zurück-Garantie und berechtigen nicht zum Produktiveinsatz.'
      },
      {
        id: 'eula-10',
        num: '10',
        title: 'Geistiges Eigentum und Reverse Engineering',
        text: 'Alle Urheberrechte, Algorithmen und neuronalen Modelle verbleiben im ausschließlichen Eigentum von JALUD Embedded s.r.o. Dekompilierung, Reverse Engineering und Modellextraktion sind untersagt.'
      },
      {
        id: 'eula-11',
        num: '11',
        title: 'Datenschutz und Privatsphäre',
        text: 'Datenschutzaspekte werden in der Richtlinie <a href="/product-privacy" data-route="product-privacy" style="color: var(--blue-primary); text-decoration: underline; font-weight: 600;">Produktdatenschutz</a> geregelt. SED verarbeitet Audiosignale flüchtig im Arbeitsspeicher und zeichnet Gespräche nicht auf. SED ist nicht darauf ausgelegt, einzelne Sprecher zu identifizieren oder biometrische Erkennung durchzuführen.'
      },
      {
        id: 'eula-12',
        num: '12',
        title: 'Rechte und Pflichten von Systemintegratoren und Distributoren',
        text: 'Zertifizierte Systemintegratoren und Vertriebspartner sind berechtigt, Softwarelizenzen (einschließlich eingebetteter Lizenzen auf SED-Geräten und Netzwerkkameras) an Endkunden zu liefern, zu installieren und zu übertragen. Hierbei sind Integratoren und Distributoren verpflichtet: (a) sicherzustellen, dass der Endkunde vor Inbetriebnahme nachweislich über diese EULA informiert wird und diese akzeptiert; (b) dem Endkunden sämtliche Dokumentationen, Installationsanleitungen und Lizenzzertifikate von JALUD auszuhändigen; (c) die eigene Nutzung der übertragenen Lizenz nach Projektübergabe vollständig einzustellen und Lizenzschlüssel nicht für weitere Installationen wiederzuverwenden; und (d) keine über die offiziellen JALUD-Garantien oder SLAs hinausgehenden Zusicherungen im Namen von JALUD ohne vorherige schriftliche Genehmigung abzugeben.'
      },
      {
        id: 'eula-13',
        num: '13',
        title: 'Gewährleistungsausschluss und Haftungsbeschränkung',
        text: 'Die Haftung des Lizenzgebers ist im gesetzlich zulässigen Maß auf die in den letzten 12 Monaten für die betroffene Software gezahlte Lizenzgebühr begrenzt. Eine Haftung für mittelbare Schäden oder entgangenen Gewinn ist ausgeschlossen.'
      },
      {
        id: 'eula-14',
        num: '14',
        title: 'Öffentlicher Sektor und Kommunen',
        text: 'Beim Einsatz im öffentlichen Raum obliegt dem Lizenznehmer die Einhaltung öffentlich-rechtlicher Überwachungsvorschriften und Informationspflichten.'
      },
      {
        id: 'eula-15',
        num: '15',
        title: 'Laufzeit, Kündigung und anwendbares Recht',
        text: 'Diese Vereinbarung unterliegt dem Recht der Tschechischen Republik. Gerichtsstand für alle Streitigkeiten ist Plzeň, Tschechische Republik.'
      }
    ],
    crossLinksTitle: 'Zugehörige Rechtsdokumente',
    crossLinks: [
      { route: 'terms-and-conditions', name: 'Allgemeine Geschäftsbedingungen', desc: 'Kommerzielle Bedingungen, Bestellungen und Hardware-Garantie' },
      { route: 'support-and-maintenance', name: 'Support- und Wartungsbedingungen', desc: 'Support-Level, KI-Aktualisierungen und Ziel-Reaktionszeiten' },
      { route: 'product-privacy', name: 'Produktdatenschutz & Datensicherheit', desc: 'Technische Privacy-by-Design Architektur von SED' },
      { route: 'data-processing-agreement', name: 'Auftragsverarbeitungsvertrag (AVV)', desc: 'Standardbedingungen gemäß Art. 28 DSGVO' }
    ]
  },
  es: {
    eyebrow: 'DOCUMENTACIÓN LEGAL & LICENCIAS',
    title: 'Acuerdo de Licencia de Usuario Final (EULA)',
    subtitle: 'Términos de licencia de software para Sound Event Detector (SED), SEDTarget, SEDControl, SEDServer y módulos edge de JALUD Embedded s.r.o.',
    version: 'Versión 2026.2 (Actualizada en octubre de 2026)',
    tocTitle: 'Índice de contenidos',
    companyDetails: 'Licenciante: JALUD Embedded s.r.o., Nepomucká 1355/261, 326 00 Plzeň, República Checa, NIF: 03056287',
    preamble: 'Este Acuerdo de Licencia de Usuario Final ("EULA") es un contrato vinculante entre usted (persona física o jurídica como "Licenciatario", ya sea directamente como "Cliente Final / Usuario Final" o como "Integrador de Sistemas o Distribuidor" autorizado que entrega la solución al Cliente Final) y JALUD Embedded s.r.o. ("Licenciante" o "JALUD"). Al instalar, descargar, activar o utilizar el software, usted acepta cumplir estos términos.',
    sections: [
      {
        id: 'eula-1',
        num: '1',
        title: 'Definiciones y objeto del acuerdo',
        text: 'Software se refiere a las soluciones de software de JALUD, incluidos Sound Event Detector (SED), SEDTarget, SEDControl, SEDServer, paquetes edge para cámaras (ACAP, HEOP, Hanwha), firmware SED Edge, modelos de detección acústica y documentación. "Cliente Final" es la entidad que opera el Software para sus necesidades internas de seguridad. "Integrador de Sistemas / Distribuidor" es el socio autorizado que adquiere el Software o hardware para su integración, despliegue y transferencia al Cliente Final designado.'
      },
      {
        id: 'eula-2',
        num: '2',
        title: 'Concesión de licencia, alcance y transferibilidad a través de integradores',
        text: 'El Licenciante otorga al Licenciatario una licencia no exclusiva (por suscripción o perpetua) para utilizar el Software en el número contratado de dispositivos, cámaras, servidores o núcleos. Para el Cliente Final, la licencia se concede exclusivamente para sus operaciones internas y no es transferible ni sublicenciable a terceros sin consentimiento previo por escrito del Licenciante. Excepción para integradores de sistemas y distribuidores: Los integradores de sistemas y distribuidores autorizados que adquieran el Software o dispositivos JALUD para sus clientes están expresamente facultados para transferir la licencia por una sola vez al Cliente Final designado en el marco de la ejecución del proyecto o venta de la solución, siempre que: (a) el Cliente Final reciba y acepte formalmente este EULA antes de la puesta en servicio; (b) el integrador no conserve copias, claves de licencia activas ni accesos para su uso propio; y (c) las licencias vinculadas a hardware específico (como dirección MAC o número de serie SED) se transfieran únicamente junto con el hardware correspondiente. Queda prohibida cualquier reventa secundaria, transferencia posterior o sublicenciamiento por parte del Cliente Final sin autorización previa de JALUD.'
      },
      {
        id: 'eula-3',
        num: '3',
        title: 'Tecnología asistencial y supervisión humana',
        text: 'Sound Event Detector (SED) es una herramienta analítica asistencial destinada a alertar al personal de seguridad sobre eventos acústicos específicos (disparos, gritos, rotura de cristales, sirenas). El Software no sustituye el juicio humano ni los servicios de emergencia. Toda decisión operativa debe ser tomada por operadores humanos cualificados.'
      },
      {
        id: 'eula-4',
        num: '4',
        title: 'Carácter probabilístico de la IA acústica',
        text: 'La detección acústica basada en redes neuronales es probabilística por naturaleza técnica. El Licenciante no garantiza una detección infalible ni ininterrumpida en todas las condiciones. La reverberación, el ruido ambiental (viento, lluvia, tráfico) y los obstáculos físicos pueden afectar el rendimiento. Pueden producirse falsos positivos y falsos negativos.'
      },
      {
        id: 'eula-5',
        num: '5',
        title: 'Entornos críticos y exclusiones de seguridad',
        text: 'El Software no está diseñado a prueba de fallos (fail-safe) ni certificado para entornos de alto riesgo donde un fallo pueda provocar muerte o daños personales.'
      },
      {
        id: 'eula-6',
        num: '6',
        title: 'Dependencia de hardware de terceros',
        text: 'El Software se integra con cámaras (Axis, Hikvision, Hanwha) y sistemas VMS (Milestone, Genetec). El Licenciante no se hace responsable de defectos de hardware de terceros o fallos de red.'
      },
      {
        id: 'eula-7',
        num: '7',
        title: 'Instalación y calibración acústica',
        text: 'La correcta instalación y la línea visual acústica son esenciales para un funcionamiento óptimo. El Licenciatario es responsable de cumplir las guías oficiales de instalación.'
      },
      {
        id: 'eula-8',
        num: '8',
        title: 'Actualizaciones y soporte',
        text: 'Las actualizaciones y el soporte se rigen por los <a href="/support-and-maintenance" data-route="support-and-maintenance" style="color: var(--blue-primary); text-decoration: underline; font-weight: 600;">Términos de Soporte y Mantenimiento</a>.'
      },
      {
        id: 'eula-9',
        num: '9',
        title: 'Licencia de prueba de 30 días (Trial License)',
        text: 'El Licenciante puede conceder una licencia de prueba temporal de 30 días para evaluación y PoC. Las licencias de prueba no constituyen una licencia de producción y no dan derecho a reembolso ni compensación.'
      },
      {
        id: 'eula-10',
        num: '10',
        title: 'Propiedad intelectual y prohibición de ingeniería inversa',
        text: 'Todos los derechos de autor, patentes, algoritmos y pesos neuronales son propiedad exclusiva de JALUD Embedded s.r.o. Queda prohibida la descompilación o ingeniería inversa.'
      },
      {
        id: 'eula-11',
        num: '11',
        title: 'Privacidad y protección de datos',
        text: 'Regulado en <a href="/product-privacy" data-route="product-privacy" style="color: var(--blue-primary); text-decoration: underline; font-weight: 600;">Privacidad del Producto</a>. SED procesa audio en memoria RAM volátil sin almacenar conversaciones. SED no está diseñado para identificar hablantes individuales ni para realizar identificación biométrica de personas.'
      },
      {
        id: 'eula-12',
        num: '12',
        title: 'Derechos y obligaciones de integradores y distribuidores',
        text: 'Los distribuidores e integradores de sistemas certificados están autorizados a suministrar, integrar y transferir licencias del Software (incluidas las licencias edge integradas en dispositivos SED y cámaras) a clientes finales (Usuarios Finales). El integrador o distribuidor está obligado a: (a) asegurarse de que el Cliente Final acepte formalmente este EULA antes de la puesta en marcha; (b) entregar al Cliente Final toda la documentación técnica, manuales y certificados de licencia emitidos por JALUD; (c) cesar todo uso de la licencia transferida tras la entrega y no reutilizar claves en otros proyectos; y (d) no otorgar garantías ni SLAs superiores a los oficiales de JALUD sin consentimiento previo por escrito.'
      },
      {
        id: 'eula-13',
        num: '13',
        title: 'Exclusión de garantías y límite de responsabilidad',
        text: 'La responsabilidad total acumulada del Licenciante queda limitada al importe abonado en los últimos 12 meses por la licencia afectada.'
      },
      {
        id: 'eula-14',
        num: '14',
        title: 'Sector público y municipios',
        text: 'En proyectos municipales, el Licenciatario es responsable de cumplir la normativa de videovigilancia y avisos públicos.'
      },
      {
        id: 'eula-15',
        num: '15',
        title: 'Duración y legislación aplicable',
        text: 'Este acuerdo se rige por las leyes de la República Checa. Cualquier litigio se someterá a los tribunales competentes de Plzeň, República Checa.'
      }
    ],
    crossLinksTitle: 'Documentos legales relacionados',
    crossLinks: [
      { route: 'terms-and-conditions', name: 'Términos y Condiciones', desc: 'Relación comercial, pedidos, facturación y garantía de hardware' },
      { route: 'support-and-maintenance', name: 'Términos de Soporte y Mantenimiento', desc: 'Niveles de soporte, actualizaciones de IA y tiempos objetivo de respuesta' },
      { route: 'product-privacy', name: 'Privacidad del Producto y Protección de Datos', desc: 'Arquitectura técnica de privacidad en el edge de SED' },
      { route: 'data-processing-agreement', name: 'Acuerdo de Encargo de Tratamiento (DPA)', desc: 'Términos del Art. 28 RGPD para servicios en la nube' }
    ]
  },
  pt: {
    eyebrow: 'DOCUMENTAÇÃO LEGAL & LICENCIAMENTO',
    title: 'Contrato de Licença de Utilizador Final (EULA)',
    subtitle: 'Termos de licenciamento de software para Sound Event Detector (SED), SEDTarget, SEDControl, SEDServer e módulos da JALUD Embedded s.r.o.',
    version: 'Versão 2026.2 (Atualizada em outubro de 2026)',
    tocTitle: 'Índice do contrato',
    companyDetails: 'Licenciante: JALUD Embedded s.r.o., Nepomucká 1355/261, 326 00 Plzeň, República Checa, NIF: 03056287',
    preamble: 'Este Contrato de Licença de Utilizador Final ("EULA") constitui um acordo vinculativo entre o utilizador (pessoa singular ou coletiva na qualidade de "Licenciado", quer atue diretamente como "Cliente Final / Utilizador Final" quer como "Integrador de Sistemas ou Distribuidor" autorizado que fornece a solução ao Cliente Final) e a JALUD Embedded s.r.o. ("Licenciante" ou "JALUD"). A instalação ou utilização do Software implica a aceitação integral destes termos.',
    sections: [
      {
        id: 'eula-1',
        num: '1',
        title: 'Definições e Objeto',
        text: 'Software refere-se aos produtos da JALUD, nomeadamente Sound Event Detector (SED), SEDTarget, SEDControl, SEDServer, aplicações ACAP/HEOP/Hanwha, firmware SED Edge, respetivos modelos neuronais e documentação. "Cliente Final" designa a entidade que opera o Software para as suas próprias necessidades operacionais e de segurança. "Integrador de Sistemas / Distribuidor" designa o parceiro autorizado que adquire o Software ou hardware para integração, instalação e transmissão da licença ao Cliente Final.'
      },
      {
        id: 'eula-2',
        num: '2',
        title: 'Concessão de Licença, Âmbito e Transmissibilidade através de Integradores',
        text: 'O Licenciante concede ao Licenciado uma licença não exclusiva (temporária por subscrição ou perpétua) para operar o Software no número autorizado de dispositivos, canais de câmara ou servidores. Para o Cliente Final, a licença destina-se exclusivamente às suas operações internas e não é transmissível nem sublicenciável sem consentimento prévio por escrito. Exceção para Integradores de Sistemas e Distribuidores: Os integradores e distribuidores autorizados que adquiram o Software ou dispositivos JALUD para os seus clientes estão expressamente autorizados a transmitir a licença uma única vez ao Cliente Final designado no âmbito do fornecimento do projeto, desde que: (a) o Cliente Final aceite formalmente este EULA antes da entrada em funcionamento; (b) o integrador não retenha cópias, chaves de licença ativas ou instâncias em execução para si; e (c) as licenças vinculadas a hardware específico (como endereço MAC da câmara ou número de série SED) sejam transmitidas estritamente com o referido hardware. Qualquer revenda secundária ou sublicenciamento posterior pelo Cliente Final sem consentimento da JALUD é estritamente proibida.'
      },
      {
        id: 'eula-3',
        num: '3',
        title: 'Tecnologia Assistiva e Supervisão Humana',
        text: 'O Sound Event Detector (SED) é uma ferramenta assistiva para alertar operadores humanos sobre eventos sonoros específicos. O Software não substitui os serviços de emergência nem o discernimento humano. As decisões finais competem a operadores humanos qualificados.'
      },
      {
        id: 'eula-4',
        num: '4',
        title: 'Natureza Probabilística da IA Acústica',
        text: 'A deteção acústica através de redes neuronais possui natureza probabilística. O Licenciante não garante uma deteção infalível ou ininterrupta em todas as condições acústicas e meteorológicas.'
      },
      {
        id: 'eula-5',
        num: '5',
        title: 'Ambientes Críticos e Exclusões',
        text: 'O Software não é concebido à prova de falhas (fail-safe) nem certificado para ambientes de alto risco onde falhas possam provocar morte ou danos corporais.'
      },
      {
        id: 'eula-6',
        num: '6',
        title: 'Hardware e Plataformas de Terceiros',
        text: 'O Software integra-se com câmaras (Axis, Hikvision, Hanwha) e sistemas VMS (Milestone, Genetec). O Licenciante não se responsabiliza por falhas de hardware de terceiros ou de redes de comunicação.'
      },
      {
        id: 'eula-7',
        num: '7',
        title: 'Instalação e Calibração Acústica',
        text: 'O correto posicionamento dos microfones e o respeito pelos manuais de instalação são essenciais para assegurar a precisão do sistema.'
      },
      {
        id: 'eula-8',
        num: '8',
        title: 'Atualizações e Suporte',
        text: 'Serviços de suporte e atualizações são regidos pelos <a href="/support-and-maintenance" data-route="support-and-maintenance" style="color: var(--blue-primary); text-decoration: underline; font-weight: 600;">Termos de Suporte e Manutenção</a>.'
      },
      {
        id: 'eula-9',
        num: '9',
        title: 'Licença de Demonstração de 30 Dias (Trial License)',
        text: 'A JALUD pode disponibilizar uma licença de teste de 30 dias para avaliação e PoC. A licença de teste não constitui compromisso de produção e os valores são não reembolsáveis.'
      },
      {
        id: 'eula-10',
        num: '10',
        title: 'Propriedade Intelectual e Engenharia Inversa',
        text: 'Todos os direitos de propriedade intelectual, códigos e modelos de IA pertencem exclusivamente à JALUD Embedded s.r.o. A engenharia inversa e a extração de modelos são expressamente proibidas.'
      },
      {
        id: 'eula-11',
        num: '11',
        title: 'Privacidade e Proteção de Dados',
        text: 'Em conformidade com a política de <a href="/product-privacy" data-route="product-privacy" style="color: var(--blue-primary); text-decoration: underline; font-weight: 600;">Privacidade do Produto</a>. O SED processa o som localmente na RAM e descarta conversas de voz humana. O SED não foi concebido para identificar oradores individuais nem efetuar identificação biométrica de pessoas.'
      },
      {
        id: 'eula-12',
        num: '12',
        title: 'Direitos e Obrigações dos Integradores e Distribuidores',
        text: 'Os integradores de sistemas e distribuidores certificados estão autorizados a fornecer, instalar e transmitir licenças do Software (incluindo licenças integradas em unidades SED e câmaras de rede) a clientes finais terceiros (Clientes Finais). Nesse âmbito, o integrador ou distribuidor obriga-se a: (a) assegurar que o Cliente Final toma conhecimento e aceita formalmente este EULA antes da colocação em serviço; (b) entregar ao Cliente Final a documentação técnica oficial, manuais e certificados de licença da JALUD; (c) cessar toda a utilização interna da licença transmitida após a entrega da instalação; e (d) não assumir garantias ou SLAs em nome da JALUD que excedam as condições oficiais publicadas.'
      },
      {
        id: 'eula-13',
        num: '13',
        title: 'Limitação de Responsabilidade',
        text: 'A responsabilidade total do Licenciante é limitada ao montante das taxas de licença pagas nos 12 meses anteriores relativamente ao Software em causa.'
      },
      {
        id: 'eula-14',
        num: '14',
        title: 'Setor Público e Municípios',
        text: 'A instalação em espaços públicos requer o cumprimento das normas legais relativas à sinalização e impacto sobre dados pessoais (DPIA).'
      },
      {
        id: 'eula-15',
        num: '15',
        title: 'Vigência e Lei Aplicável',
        text: 'Este contrato é regido pela lei da República Checa, sendo competentes os tribunais da comarca de Plzeň, República Checa.'
      }
    ],
    crossLinksTitle: 'Documentos legais associados',
    crossLinks: [
      { route: 'terms-and-conditions', name: 'Termos e Condições', desc: 'Relações comerciais, encomendas, pagamentos e garantia de hardware' },
      { route: 'support-and-maintenance', name: 'Termos de Suporte e Manutenção', desc: 'Níveis de suporte, atualizações e tempos-alvo de resposta' },
      { route: 'product-privacy', name: 'Privacidade do Produto e Proteção de Dados', desc: 'Arquitetura técnica de privacidade local do SED' },
      { route: 'data-processing-agreement', name: 'Acordo de Processamento de Dados (DPA)', desc: 'Termos do Art. 28 do RGPD para soluções cloud' }
    ]
  },
  ar: {
    eyebrow: 'الوثائق القانونية والتراخيص',
    title: 'اتفاقية ترخيص المستخدم النهائي (EULA)',
    subtitle: 'شروط ترخيص برمجيات كاشف الأحداث الصوتية (SED) و SEDTarget و SEDControl و SEDServer ووحدات المعالجة الطرفية من شركة JALUD Embedded s.r.o.',
    version: 'الإصدار 2026.2 (محدّث في أكتوبر 2026)',
    tocTitle: 'فهرس بنود الاتفاقية',
    companyDetails: 'المرخص: JALUD Embedded s.r.o.، العنوان: Nepomucká 1355/261, 326 00 Plzeň، الجمهورية التشيكية، السجل التجاري: 03056287',
    preamble: 'تمثل اتفاقية ترخيص المستخدم النهائي هذه ("EULA") عقداً ملزماً قانونياً بينك (بصفتك شخصاً طبيعياً أو اعتبارياً بوصفك "المرخص له"، سواء أكنت "المستخدم النهائي / العميل النهائي" مباشرة أو "مدمج أنظمة أو موزعاً معتمداً" يورد الحل للعميل النهائي) وشركة JALUD Embedded s.r.o. ("المرخص" أو "JALUD"). إن تثبيت برمجيات JALUD أو تنزيلها أو تفعيلها أو استخدامها يعني قراءتك لهذه الشروط وموافقتك التامة على الالتزام بها.',
    sections: [
      {
        id: 'eula-1',
        num: '١',
        title: 'التعريفات ومحل الاتفاقية',
        text: 'يُقصد بالبرمجيات حلول شركة JALUD البرمجية وخاصة Sound Event Detector (SED) و SEDTarget و SEDControl و SEDServer وحزم كاميرات ACAP و HEOP و Hanwha وبرمجيات SED Edge والنماذج العصبية والوثائق التقنية. ويقصد بـ "العميل النهائي" الجهة التي تشغل البرمجيات لأغراضها الأمنية والتشغيلية الداخلية. ويقصد بـ "مدمج الأنظمة / الموزع" الشريك المعتمد الذي يقتني البرمجيات أو أجهزة JALUD لدمجها وتوريدها ونقل ترخيصها إلى العميل النهائي المحدد.'
      },
      {
        id: 'eula-2',
        num: '٢',
        title: 'منح الترخيص ونطاق الاستخدام وقابلية النقل عبر المدمجين',
        text: 'يمنح المرخص للمرخص له ترخيصاً غير حصري (عبر اشتراك محدد المدة أو ترخيص دائم) لتشغيل البرمجيات على عدد الأجهزة أو القنوات أو الخوادم المحدد في أمر الشراء أو شهادة الترخيص. بالنسبة للعميل النهائي، يُمنح الترخيص حصرياً لأغراضه التشغيلية والأمنية الداخلية، ولا يجوز له نقل الترخيص أو ترخيصه من الباطن لأي طرف آخر دون موافقة خطية مسبقة من المرخص. استثناء لمدمجي الأنظمة وشركاء التوزيع: يُصرح صراحة لمدمجي الأنظمة والموزعين المعتمدين الذين يشترون البرمجيات أو أجهزة JALUD لصالح عملائهم بنقل الترخيص لمرة واحدة إلى العميل النهائي المحدد في سياق تنفيذ المشروع أو بيع الحل، شريطة: (أ) إخطار العميل النهائي رسمياً وقبوله الكامل لاتفاقية EULA هذه قبل بدء التشغيل؛ (ب) ألا يحتفظ المدمج أو الموزع بأي نسخ أو مفاتيح ترخيص نشطة لاستخدامه الخاص؛ و (ج) أن يتم نقل التراخيص المرتبطة بعتاد محدد (مثل عنوان MAC للكاميرا أو الرقم التسلسلي لجهاز SED) مقترنة بذات العتاد الفعلي فقط. يحظر تماماً أي إعادة بيع ثانوية أو ترخيص من الباطن من قبل العميل النهائي دون موافقة خطية مسبقة من JALUD.'
      },
      {
        id: 'eula-3',
        num: '٣',
        title: 'التقنية المساعدة والإشراف البشري',
        text: 'يعد نظام SED أداة تحليلية مساعدة تهدف إلى تنبيه المشغلين البشريين عند وقوع أصوات محددة (كالطلقات النارية، والصراخ، وتكسر الزجاج، والصفارات). لا تحل البرمجية محل التقدير البشري أو أجهزة الطوارئ، ويجب أن تبقى كافة قرارات التدخل بيد المشغلين البشريين المؤهلين.'
      },
      {
        id: 'eula-4',
        num: '٤',
        title: 'الطبيعة الاحتمالية للذكاء الاصطناعي الصوتي',
        text: 'يعتمد التحليل الصوتي عبر الشبكات العصبية على طبيعة احتمالية بطبيعته الهندسية. لا يضمن المرخص كشفاً خالياً من الأخطاء لكافة الأحداث الصوتية في جميع الظروف البيئية والصوتية. قد تؤثر الضوضاء أو الصدى أو الحواجز المادية في الكشف، وقد تحدث إيجابيات أو سلبيات كاذبة.'
      },
      {
        id: 'eula-5',
        num: '٥',
        title: 'البيئات الحرجة واستثناءات السلامة',
        text: 'البرمجيات ليست مصممة لتكون آمنة من الفشل الحرج (fail-safe) في البيئات شديدة الخطورة التي قد يؤدي فيها الخلل التقني مباشرة إلى الوفاة أو الإصابة الجسدية.'
      },
      {
        id: 'eula-6',
        num: '٦',
        title: 'الاعتماد على عتاد ومنصات الطرف الثالث',
        text: 'يتطلب تشغيل النظام التكامل مع كاميرات (Axis, Hikvision, Hanwha) وأنظمة إدارة الفيديو (Milestone, Genetec). لا يتحمل المرخص المسؤولية عن عيوب عتاد الطرف الثالث أو انقطاع شبكات الاتصال.'
      },
      {
        id: 'eula-7',
        num: '٧',
        title: 'التثبيت والمعايرة الصوتية والبيئة المحيطة',
        text: 'يعد التثبيت السليم للميكروفونات وتوفير خط الرؤية الصوتي المباشر أمراً ضرورياً للعمل الدقيق. يتحمل المرخص له مسؤولية التثبيت وفقاً للأدلة الإرشادية المعتمدة.'
      },
      {
        id: 'eula-8',
        num: '٨',
        title: 'التحديثات والصيانة والدعم الفني',
        text: 'تخضع خدمات الصيانة والدعم الفني وتحديثات النماذج العصبية لوثيقة <a href="/support-and-maintenance" data-route="support-and-maintenance" style="color: var(--blue-primary); text-decoration: underline; font-weight: 600;">شروط الدعم والصيانة</a>.'
      },
      {
        id: 'eula-9',
        num: '٩',
        title: 'الترخيص التجريبي لمدة 30 يوماً (Trial License)',
        text: 'يجوز لشركة JALUD منح ترخيص تجريبي مؤقت لمدة 30 يوماً لأغراض التقييم واختبار إثبات المفهوم (PoC). لا يمثل الترخيص التجريبي ترخيصاً إنتاجياً تجارياً ولا يتضمن أي ضمان لاسترداد الأموال.'
      },
      {
        id: 'eula-10',
        num: '١٠',
        title: 'الملكية الفكرية وحظر الهندسة العكسية',
        text: 'تبقى كافة حقوق الملكية الفكرية وبراءات الاختراع والرموز البرمجية وأوزان النماذج العصبية ملكاً حصرياً لشركة JALUD Embedded s.r.o.، ويحظر تماماً إجراء الهندسة العكسية أو استخراج الأوزان.'
      },
      {
        id: 'eula-11',
        num: '١١',
        title: 'الخصوصية وحماية البيانات',
        text: 'تخضع معالجة البيانات لوثيقة <a href="/product-privacy" data-route="product-privacy" style="color: var(--blue-primary); text-decoration: underline; font-weight: 600;">خصوصية المنتج وحماية البيانات</a>. يعالج النظام الصوت محلياً في ذاكرة RAM المؤقتة دون تسجيل أو تخزين لأحاديث البشر. لم يُصمم نظام SED للتعرف على هوية المتحدثين أو إجراء التحديد البيومتري للأشخاص.'
      },
      {
        id: 'eula-12',
        num: '١٢',
        title: 'حقوق والتزامات مدمجي الأنظمة والموزعين',
        text: 'يُصرح للموزعين ومدمجي الأنظمة المعتمدين بتوريد وتثبيت ونقل تراخيص البرمجيات (بما في ذلك التراخيص الطرفية المدمجة في أجهزة SED وكاميرات الشبكة) إلى العملاء النهائيين (المستخدمين النهائيين). ويتعين على مدمج الأنظمة أو الموزع في هذا السياق: (أ) ضمان إطلاع العميل النهائي على هذه الاتفاقية وقبوله لها رسمياً قبل بدء التشغيل؛ (ب) تسليم كافة الوثائق الرسمية وأدلة التثبيت وشهادات الترخيص الصادرة عن JALUD إلى العميل النهائي؛ (ج) التوقف عن أي استخدام للترخيص المنقول بعد تسليم المشروع وعدم إعادة استخدام مفاتيح الترخيص في مشاريع أخرى؛ و (د) عدم تقديم أي ضمانات أو اتفاقيات مستوى خدمة (SLA) تتجاوز الشروط الرسمية المعلنة من JALUD دون إذن خطي مسبق.'
      },
      {
        id: 'eula-13',
        num: '١٣',
        title: 'إخلاء الضمانات وحدود المسؤولية',
        text: 'تقتصر المسؤولية الإجمالية للمرخص على المبالغ المدفوعة فعلياً من المرخص له مقابل ترخيص البرمجيات المعنية خلال الاثني عشر (12) شهراً السابقة للمطالبة.'
      },
      {
        id: 'eula-14',
        num: '١٤',
        title: 'القطاع العام والبلديات',
        text: 'عند تشغيل النظام في المرافق والمدن الذكية، يتحمل المرخص له مسؤولية الامتثال للقوانين واللوائح المتعلقة بمراقبة الأماكن العامة ووضع اللوحات التنبيهية.'
      },
      {
        id: 'eula-15',
        num: '١٥',
        title: 'مدة الاتفاقية وإنهاؤها والقانون الحاكم',
        text: 'تخضع هذه الاتفاقية وتفسر وفقاً لقوانين الجمهورية التشيكية، وتخضع النزاعات للاختصاص القضائي الحصري للمحاكم المختصة في مدينة بلزن (Plzeň)، الجمهورية التشيكية.'
      }
    ],
    crossLinksTitle: 'الوثائق القانونية ذات الصلة',
    crossLinks: [
      { route: 'terms-and-conditions', name: 'الشروط والأحكام التجارية', desc: 'العلاقة التجارية، والطلبات، وشروط الدفع وضمان الأجهزة' },
      { route: 'support-and-maintenance', name: 'شروط الدعم والصيانة', desc: 'مستويات الدعم، وتحديثات نماذج الذكاء الاصطناعي، وأوقات الاستجابة المستهدفة' },
      { route: 'product-privacy', name: 'خصوصية المنتج وحماية البيانات', desc: 'البنية الهندسية لحماية الخصوصية الطرفية في نظام SED' },
      { route: 'data-processing-agreement', name: 'اتفاقية معالجة البيانات (DPA)', desc: 'شروط المادة 28 من اللائحة العامة لحماية البيانات (GDPR) للخدمات السحابية' }
    ]
  }
,
  it: {
    "eyebrow": "DOCUMENTAZIONE LEGALE E LICENZE",
    "title": "Contratto di Licenza con l'Utente Finale (EULA)",
    "subtitle": "Termini di licenza per l'uso dei prodotti software Sound Event Detector (SED), SEDTarget, SEDControl, SEDServer e dei relativi moduli edge di JALUD Embedded s.r.o.",
    "version": "Versione 2026.2 (Aggiornata a ottobre 2026)",
    "tocTitle": "Indice del Contratto di Licenza",
    "companyDetails": "Licenziante: JALUD Embedded s.r.o., Nepomucká 1355/261, 326 00 Plzeň, Repubblica Ceca, IČO: 03056287",
    "preamble": "Il presente Contratto di Licenza con l'Utente Finale (\"EULA\") costituisce un accordo legalmente vincolante tra l'utente (persona fisica o giuridica in veste di \"Licenziatario\", sia direttamente come \"Cliente Finale / Utente Finale\", sia come \"Integratore di Sistemi o Distributore\" autorizzato che fornisce la soluzione al Cliente Finale) e la società JALUD Embedded s.r.o. (\"Licenziante\" o \"JALUD\"). Installando, scaricando, attivando o utilizzando il software JALUD, il Licenziatario conferma di aver compreso e accetta integralmente i presenti termini.",
    "sections": [
      {
        "id": "eula-1",
        "num": "1",
        "title": "Definizioni e Oggetto del Contratto",
        "text": "Per \"Software\" si intendono i prodotti software JALUD, in particolare Sound Event Detector (SED), SEDTarget, SEDControl, SEDServer, i pacchetti embedded ACAP (Axis Camera Application Platform), HEOP (Hikvision Embedded Open Platform), i moduli per telecamere Hanwha, il firmware SED Edge, inclusi aggiornamenti, modelli neurali e documentazione. Per \"Cliente Finale\" o \"Utente Finale\" si intende l'entità terza che gestisce il Software per le proprie esigenze operative e di sicurezza interne. Per \"Integratore di Sistemi / Distributore\" si intende il partner autorizzato che acquista il Software o l'hardware JALUD per l'integrazione, l'installazione e il trasferimento della licenza al Cliente Finale designato."
      },
      {
        "id": "eula-2",
        "num": "2",
        "title": "Concessione della Licenza, Ambito d'Uso e Trasferibilità tramite Integratori",
        "text": "Il Licenziante concede al Licenziatario una licenza non esclusiva (a tempo determinato in abbonamento o perpetua) per eseguire il Software unicamente sul numero approvato di dispositivi, telecamere, server o core indicati nel certificato di licenza o ordine di acquisto. Per il Cliente Finale, la licenza è concessa esclusivamente per le proprie esigenze interne di sicurezza e operative, ed è non trasferibile e non sublicenziabile a terzi senza il previo consenso scritto del Licenziante. Eccezione per Integratori di Sistemi e Distributori: Gli integratori di sistemi e i distributori autorizzati che acquistano il Software o i dispositivi JALUD per i propri clienti sono espressamente autorizzati a trasferire la licenza una tantum al Cliente Finale designato nell'ambito dell'esecuzione del progetto o della fornitura della soluzione, a condizione che: (a) il Cliente Finale sia formalmente informato e accetti integralmente i presenti termini EULA prima della messa in servizio; (b) l'integratore/distributore non trattenga per sé alcuna copia, chiave di licenza attiva o istanza del Software trasferito; e (c) qualsiasi licenza associata a un hardware specifico (ad es. indirizzo MAC della telecamera o numero di serie del dispositivo SED) sia trasferita rigorosamente insieme all'hardware fisico designato. È fatto espresso divieto di qualsiasi ulteriore rivendita, secondo trasferimento o sublicenza da parte del Cliente Finale senza la preventiva approvazione scritta di JALUD."
      },
      {
        "id": "eula-3",
        "num": "3",
        "title": "Tecnologia Assistiva e Supervisione Umana",
        "text": "Il Software Sound Event Detector (SED) è uno strumento analitico assistivo progettato per avvisare gli operatori umani del verificarsi di eventi acustici specifici (ad es. spari, urla, rottura vetri, sirene, rumori industriali). Il Software non sostituisce il giudizio umano professionale, le forze di polizia, i servizi di soccorso o il personale di emergenza. Tutte le decisioni relative a interventi di sicurezza, invio di pattuglie o attivazione di protocolli di emergenza devono essere prese da un operatore umano qualificato."
      },
      {
        "id": "eula-4",
        "num": "4",
        "title": "Natura Probabilistica dell'AI Acustica e Limiti di Rilevamento",
        "text": "Il rilevamento acustico basato sull'apprendimento automatico e su reti neurali ha una natura intrinsecamente probabilistica. Il Licenziante non garantisce un rilevamento privo di errori o ininterrotto di tutti gli eventi acustici in qualsiasi circostanza. L'accuratezza della classificazione può essere influenzata da acustica ambientale, riverbero, rumore di fondo (vento, pioggia, traffico, macchinari), ostacoli fisici, qualità e orientamento del microfono e interferenze. Possono verificarsi sia falsi positivi che falsi negativi."
      },
      {
        "id": "eula-5",
        "num": "5",
        "title": "Ambienti ad Alto Rischio ed Esclusioni di Sicurezza (Fail-Safe)",
        "text": "Il Software non è certificato come componente di sicurezza fail-safe per l'impiego in ambienti ad alto rischio in cui un guasto tecnologico possa condurre direttamente a morte, lesioni personali gravi o catastrofi ambientali (es. controllo di impianti nucleari, sistemi di supporto vitale, sistemi d'arma). L'uso del Software in tali contesti è a esclusivo rischio del Licenziatario."
      },
      {
        "id": "eula-6",
        "num": "6",
        "title": "Dipendenza da Hardware e Piattaforme di Terze Parti",
        "text": "Il funzionamento del Software può richiedere l'integrazione con hardware e piattaforme di terze parti (es. telecamere Axis, Hikvision, Hanwha, sistemi VMS Milestone XProtect, Genetec Security Center e infrastruttura di rete). Il Licenziante declina ogni responsabilità per interruzioni di servizio, modifiche firmware, incompatibilità, difetti hardware di terzi o guasti di rete al di fuori del controllo diretto del Licenziante."
      },
      {
        "id": "eula-7",
        "num": "7",
        "title": "Installazione, Calibrazione Acustica e Ambiente Operativo",
        "text": "Una corretta installazione dei microfoni, il rispetto della linea di vista acustica, la corretta regolazione della sensibilità e la verifica della copertura acustica sono requisiti indispensabili per un funzionamento affidabile. Il Licenziatario è responsabile dell'installazione conforme ai manuali del Licenziante o dell'affidamento a partner certificati. Modifiche ambientali rilevanti (nuove costruzioni, introduzione di macchinari rumorosi) possono richiedere una ricalibrazione acustica."
      },
      {
        "id": "eula-8",
        "num": "8",
        "title": "Restrizioni d'Uso e Integrità del Codice",
        "text": "Il Licenziatario non può: decompilare, disassemblare, decodificare o tentare di ricavare il codice sorgente o i pesi dei modelli neurali del Software; noleggiare, concedere in leasing o distribuire il Software a terzi non autorizzati; rimuovere o alterare avvisi di copyright, marchi o identificatori di licenza; utilizzare il Software per addestrare modelli di intelligenza artificiale concorrenti."
      },
      {
        "id": "eula-9",
        "num": "9",
        "title": "Diritti di Proprietà Intellettuale e Riservatezza",
        "text": "Tutti i diritti di proprietà intellettuale, brevetti, marchi registrati (incluso il marchio EUIPO n. 018598475), segreti commerciali e modelli neurali incorporati nel Software rimangono di esclusiva proprietà di JALUD Embedded s.r.o. La presente EULA concede un diritto d'uso limitato e non trasferisce alcun diritto di proprietà sul Software."
      },
      {
        "id": "eula-10",
        "num": "10",
        "title": "Protezione dei Dati, Privacy e Trattamento Audio",
        "text": "Il Software è progettato secondo i principi di Privacy by Design. Il flusso audio in ingresso viene analizzato in memoria volatile (RAM) mediante finestre temporali rotanti e scartato immediatamente senza memorizzazione continua su disco fisso. Non viene eseguito alcun riconoscimento vocale del contenuto parlato né profilazione biometrica. L'eventuale generazione di brevi snippet di verifica (max 1,5s) è configurabile esclusivamente dall'amministratore del sistema secondo la propria policy di sicurezza."
      },
      {
        "id": "eula-11",
        "num": "11",
        "title": "Conformità all'Export e Normative Internazionali",
        "text": "Il Licenziatario si impegna a rispettare tutte le leggi applicabili sul controllo delle esportazioni e sanzioni internazionali emanate dall'Unione Europea, dalla Repubblica Ceca, dagli Stati Uniti e da altri organismi competenti. Il Software non può essere esportato o riesportato verso destinazioni soggette a embargo o a individui ed entità inserite in liste sanzionatorie."
      },
      {
        "id": "eula-12",
        "num": "12",
        "title": "Diritti e Obblighi di Integratori di Sistemi e Distributori",
        "text": "I distributori certificati e gli integratori di sistemi sono autorizzati a fornire, installare e trasferire le licenze del Software (incluse le licenze embedded fornite con le unità SED e le telecamere) a clienti finali terzi (Utenti Finali). L'integratore o distributore ha l'obbligo contrattuale di: (a) garantire che il Cliente Finale riceva, esamini e accetti formalmente i presenti termini EULA prima della messa in servizio del sistema; (b) consegnare al Cliente Finale tutta la documentazione tecnica ufficiale, i manuali di installazione e i certificati di licenza rilasciati da JALUD; (c) cessare qualsiasi uso interno della licenza trasferita una volta consegnato il progetto e non riutilizzare le chiavi di licenza su altre installazioni; e (d) non rilasciare dichiarazioni, garanzie o impegni SLA per conto di JALUD che vadano oltre i termini ufficiali pubblicati senza previa autorizzazione scritta."
      },
      {
        "id": "eula-13",
        "num": "13",
        "title": "Esclusione di Garanzie e Limitazione di Responsabilità",
        "text": "Nella misura massima consentita dalla legge applicabile, il Software viene fornito \"COSÌ COM'È\" e \"COME DISPONIBILE\" senza garanzie di alcun tipo, espresse o implicite. La responsabilità complessiva del Licenziante per qualsiasi reclamo derivante dal presente contratto sarà limitata all'importo effettivamente pagato dal Licenziatario per la licenza Software interessata nei dodici (12) mesi precedenti. Il Licenziante declina ogni responsabilità per danni indiretti, perdita di profitti, interruzione di attività o perdita di dati."
      },
      {
        "id": "eula-14",
        "num": "14",
        "title": "Distribuzione nel Settore Pubblico e Sicurezza Municipale",
        "text": "In caso di installazione in spazi pubblici, piazze municipali o progetti Smart City, il Licenziatario è l'unico responsabile del rispetto dei requisiti di trasparenza, dell'apposizione dell'adeguata cartellonistica informativa di videosorveglianza/monitoraggio e dell'esecuzione della Valutazione d'Impatto sulla Protezione dei Dati (DPIA) ai sensi del GDPR."
      },
      {
        "id": "eula-15",
        "num": "15",
        "title": "Durata, Risoluzione e Giurisdizione Competente",
        "text": "Il presente accordo entra in vigore all'installazione o al primo utilizzo del Software e rimane efficace fino alla risoluzione. Il Licenziante ha facoltà di risolvere la licenza con effetto immediato in caso di violazione materiale da parte del Licenziatario. Il contratto è regolato dalle leggi della Repubblica Ceca, con esclusione delle norme di conflitto e della Convenzione di Vienna (CISG). Qualsiasi controversia sarà devoluta alla giurisdizione esclusiva del tribunale competente di Plzeň, Repubblica Ceca."
      }
    ],
    "crossLinksTitle": "Documenti Legali Correlati",
    "crossLinks": [
      {
        "route": "terms-and-conditions",
        "name": "Termini e Condizioni Generali",
        "desc": "Rapporto commerciale, ordini, condizioni di pagamento e garanzia hardware"
      },
      {
        "route": "support-and-maintenance",
        "name": "Termini di Supporto Tecnico e Manutenzione",
        "desc": "Canali di assistenza, aggiornamenti modelli AI e tempi SLA di risposta"
      },
      {
        "route": "product-privacy",
        "name": "Privacy del Prodotto e Protezione dei Dati",
        "desc": "Architettura tecnica edge per la tutela della riservatezza e conformità GDPR"
      },
      {
        "route": "data-processing-agreement",
        "name": "Accordo sul Trattamento dei Dati (DPA)",
        "desc": "Termini contrattuali standard ex Art. 28 GDPR per servizi cloud connessi"
      }
    ]
  }
};


export const termsData = {
  cs: {
    eyebrow: 'OBCHODNÍ A SMLUVNÍ PODMÍNKY',
    title: 'Obchodní podmínky',
    subtitle: 'Všeobecné obchodní podmínky pro nákup hardwaru, poskytování softwarových licencí a profesionálních služeb společnosti JALUD Embedded s.r.o.',
    version: 'Verze 2026.1 (Účinnost od 1. ledna 2026)',
    tocTitle: 'Obsah obchodních podmínek',
    companyDetails: 'Prodávající / Dodavatel: JALUD Embedded s.r.o., Nepomucká 1355/261, 326 00 Plzeň, Česká republika, IČO: 03056287',
    preamble: 'Tyto Všeobecné obchodní podmínky („Podmínky“) upravují obchodní vztahy, dodávky hardwarových zařízení, poskytování licencí k softwaru a souvisejících služeb mezi společností JALUD Embedded s.r.o. („Dodavatel“ nebo „JALUD“) a kupujícím či odběratelem („Zákazník“ nebo „Kupující“). Odchylná ujednání v písemné smlouvě, nabídce nebo závazné objednávce mají přednost před těmito Podmínkami.',
    sections: [
      {
        id: 'tc-1',
        num: '1',
        title: 'Základní informace a vymezení pojmů',
        text: 'Dodavatelem je JALUD Embedded s.r.o., se sídlem Nepomucká 1355/261, 326 00 Plzeň, IČO: 03056287, zapsaná v obchodním rejstříku vedeném Krajským soudem v Plzni. Zákazníkem je právnická nebo fyzická osoba podnikající, která s Dodavatelem uzavírá kupní smlouvu či smlouvu o poskytování služeb v rámci své podnikatelské činnosti (B2B).'
      },
      {
        id: 'tc-2',
        num: '2',
        title: 'Nabídky, objednávky a uzavření smlouvy',
        text: 'Cenové nabídky Dodavatele jsou nezávazné, pokud v nich není výslovně uvedena doba platnosti (standardně 30 dní od vystavení). Smlouva je uzavřena okamžikem písemného potvrzení objednávky Zákazníka Dodavatelem nebo odesláním zálohové faktury. Odesláním objednávky Zákazník potvrzuje, že se seznámil s těmito Podmínkami a bez výhrad s nimi souhlasí.'
      },
      {
        id: 'tc-3',
        num: '3',
        title: 'Ceny, fakturace a platební podmínky',
        text: 'Veškeré ceny v nabídkách a cenících jsou uvedeny v CZK nebo EUR a jsou bez DPH a celních poplatků, není-li výslovně uvedeno jinak. Splatnost daňových dokladů (faktur) činí 14 dnů od data vystavení, není-li dohodnuto jinak. V případě prodlení s úhradou je Dodavatel oprávněn účtovat úrok z prodlení ve výši 0,05 % z dlužné částky za každý den prodlení a pozastavit plnění dalších dodávek či technické podpory.'
      },
      {
        id: 'tc-4',
        num: '4',
        title: 'Dodání hardwaru a výhrada vlastnictví',
        text: 'Dodávky hardwaru (akustické senzory, jednotky Sound Event Detector, příslušenství) jsou realizovány dle doložky Incoterms 2020 Ex Works (Plzeň) nebo DAP (místo určení), dle ujednání v objednávce. Vlastnické právo k dodanému hardwaru přechází na Zákazníka až okamžikem úplného zaplacení kupní ceny. Nebezpečí škody na věci přechází předáním zboží prvnímu dopravci.'
      },
      {
        id: 'tc-5',
        num: '5',
        title: 'Softwarové licence a předplatné',
        text: 'Užívání veškerého softwaru JALUD (Sound Event Detector, SEDTarget, SEDControl, SEDServer, ACAP, HEOP a embedded firmware) se řídí samostatnou <a href="/eula" data-route="eula" style="color: var(--blue-primary); text-decoration: underline; font-weight: 600;">Licenční smlouvou s koncovým uživatelem (EULA)</a>. Software je licencován, nikoliv prodáván. V případě časově omezeného předplatného (subscription) se licence automaticky obnovuje na další období, pokud Zákazník písemně nevypoví předplatné minimálně 30 dní před koncem aktuálního zúčtovacího období.'
      },
      {
        id: 'tc-6',
        num: '6',
        title: 'Technická podpora a servisní služby',
        text: 'Podmínky poskytování technické podpory, aktualizací detekčních modelů a cílové reakční doby jsou definovány v dokumentu <a href="/support-and-maintenance" data-route="support-and-maintenance" style="color: var(--blue-primary); text-decoration: underline; font-weight: 600;">Podmínky podpory a údržby (Support & Maintenance Terms)</a>. Garantované časy řešení a smluvní SLA vyžadují uzavření individuální servisní smlouvy.'
      },
      {
        id: 'tc-7',
        num: '7',
        title: 'Záruka na hardware a reklamace (RMA)',
        text: 'Dodavatel poskytuje na dodaný hardware záruku za jakost v délce 24 měsíců od data dodání, není-li v nabídce sjednáno jinak. Reklamace vad se uplatňují písemně prostřednictvím postupu RMA (Return Merchandise Authorization). Záruka se nevztahuje na opotřebení způsobené běžným užíváním, vady způsobené neodbornou instalací, vniknutím kapalin, přepětím, mechanickým poškozením nebo neautorizovaným zásahem do hardwaru.'
      },
      {
        id: 'tc-8',
        num: '8',
        title: '30denní zkušební licence (Proof of Concept)',
        text: 'JALUD může poskytnout 30denní zkušební licenci na Sound Event Detector pro účely vyhodnocení, testování nebo ověření konceptu (PoC). Zkušební licence jsou dočasné a mohou podléhat technickým, funkčním či přístrojovým omezením. Není-li písemně dohodnuto jinak, zkušební licence slouží výhradně k evaluaci a nepředstavuje produkční licenci a poplatky jsou nevratné.'
      },
      {
        id: 'tc-9',
        num: '9',
        title: 'Omezení odpovědnosti za škodu',
        text: 'V maximálním rozsahu povoleném platnými právními předpisy neodpovídá Dodavatel za žádné nepřímé, vedlejší, následné škody, ušlý zisk, ztrátu očekávaných úspor, přerušení provozu ani ztrátu dat Zákazníka. Celková souhrnná odpovědnost Dodavatele za veškeré škody vzniklé z jedné či více souvisejících událostí je omezena na částku, kterou Zákazník skutečně uhradil Dodavateli za dotčené plnění v předchozích 12 měsících.'
      },
      {
        id: 'tc-10',
        num: '10',
        title: 'Vyšší moc a ukončení smlouvy',
        text: 'Žádná ze stran neodpovídá za prodlení způsobené okolnostmi vylučujícími odpovědnost (vyšší moc – např. přírodní katastrofy, válka, pandemie, embarga, výpadky globálních dodavatelských řetězců čipů). Každá ze stran je oprávněna od smlouvy odstoupit při podstatném porušení smlouvy druhou stranou, pokud náprava nebyla zjednána ani do 30 dnů od písemné výzvy.'
      },
      {
        id: 'tc-11',
        num: '11',
        title: 'Rozhodné právo a řešení sporů',
        text: 'Veškeré právní vztahy založené těmito Podmínkami se řídí právním řádem České republiky, s vyloučením kolizních norem a Úmluvy OSN o smlouvách o mezinárodní koupi zboží (CISG). Veškeré spory, které se nepodaří vyřešit smírnou cestou, budou předloženy k rozhodnutí věcně a místně příslušným soudům v Plzni, Česká republika.'
      }
    ],
    crossLinksTitle: 'Související právní dokumenty',
    crossLinks: [
      { route: 'eula', name: 'Licenční smlouva EULA', desc: 'Podmínky užívání softwaru SED a licenční ujednání' },
      { route: 'support-and-maintenance', name: 'Podmínky podpory a údržby', desc: 'Technická podpora, aktualizace modelů a cílové reakční doby' },
      { route: 'privacy-policy', name: 'Zásady ochrany osobních údajů', desc: 'Nakládání s kontaktními údaji zákazníků' },
      { route: 'product-privacy', name: 'Produktové soukromí a ochrana dat', desc: 'Technické principy ochrany soukromí u SED' }
    ]
  },
  en: {
    eyebrow: 'COMMERCIAL TERMS & POLICIES',
    title: 'Terms & Conditions',
    subtitle: 'Standard commercial terms and conditions for hardware purchasing, software licensing, and professional services from JALUD Embedded s.r.o.',
    version: 'Version 2026.1 (Effective January 1, 2026)',
    tocTitle: 'Table of Contents',
    companyDetails: 'Seller / Supplier: JALUD Embedded s.r.o., Nepomucká 1355/261, 326 00 Plzeň, Czech Republic, Reg. ID: 03056287',
    preamble: 'These General Terms & Conditions ("Terms") govern all commercial relationships, hardware sales, software license provisions, and professional services between JALUD Embedded s.r.o. ("Supplier" or "JALUD") and the business purchaser or client ("Customer"). Specific stipulations set forth in an executed written contract, formal quotation, or confirmed purchase order take precedence over these Terms.',
    sections: [
      {
        id: 'tc-1',
        num: '1',
        title: 'Basic Information and Definitions',
        text: 'The Supplier is JALUD Embedded s.r.o., with registered office at Nepomucká 1355/261, 326 00 Plzeň, Czech Republic, Company ID: 03056287. The Customer is an enterprise, legal entity, or sole proprietor entering into a business-to-business (B2B) contractual relationship with Supplier.'
      },
      {
        id: 'tc-2',
        num: '2',
        title: 'Quotations, Purchase Orders, and Contract Formation',
        text: 'Price quotations provided by Supplier are non-binding unless an explicit validity period is specified (typically 30 calendar days). A binding contract is formed upon written confirmation of Customer’s purchase order by Supplier or upon issuance of an advance invoice. Placement of an order confirms Customer’s agreement to these Terms.'
      },
      {
        id: 'tc-3',
        num: '3',
        title: 'Pricing, Invoicing, and Payment Terms',
        text: 'All prices quoted in price lists or proposals are in CZK or EUR and exclude Value Added Tax (VAT) and import duties. Invoices are payable within 14 calendar days from the invoice date unless negotiated otherwise. Default interest of 0.05% per day of delay may be charged on overdue amounts, and Supplier may suspend pending deliveries or technical support during payment defaults.'
      },
      {
        id: 'tc-4',
        num: '4',
        title: 'Hardware Delivery and Retention of Title',
        text: 'Hardware shipments (acoustic sensors, Sound Event Detector edge units, mounting accessories) are conducted under Incoterms 2020 Ex Works (Plzeň) or DAP (named destination) as specified. Full title and ownership of delivered hardware remain with Supplier until complete payment of the purchase price. Risk of loss passes to Customer upon handover to the initial carrier.'
      },
      {
        id: 'tc-5',
        num: '5',
        title: 'Software Licensing and Subscriptions',
        text: 'Use of all JALUD software (Sound Event Detector, SEDTarget, SEDControl, SEDServer, ACAP, HEOP, and embedded firmware) is strictly governed by the <a href="/eula" data-route="eula" style="color: var(--blue-primary); text-decoration: underline; font-weight: 600;">End User License Agreement (EULA)</a>. Software is licensed, not sold. Subscriptions automatically renew for successive terms unless either party provides written notice of non-renewal at least 30 calendar days prior to renewal.'
      },
      {
        id: 'tc-6',
        num: '6',
        title: 'Technical Support and Maintenance',
        text: 'Technical support tiers, update schedules, and target response times are governed by the <a href="/support-and-maintenance" data-route="support-and-maintenance" style="color: var(--blue-primary); text-decoration: underline; font-weight: 600;">Support & Maintenance Terms</a>. Binding financial SLAs and guaranteed resolution windows require a separately executed Service Level Agreement.'
      },
      {
        id: 'tc-7',
        num: '7',
        title: 'Hardware Warranty and RMA Claims',
        text: 'Supplier warrants delivered hardware against defects in materials and workmanship for twenty-four (24) months from delivery date, unless stated otherwise in writing. Defect claims must be initiated via the Return Merchandise Authorization (RMA) procedure. Warranties do not cover damage caused by improper installation, power surges, water ingress, physical shock, or unauthorized disassembly.'
      },
      {
        id: 'tc-8',
        num: '8',
        title: '30-Day Trial License (Proof of Concept)',
        text: 'JALUD may provide a 30-day trial license for Sound Event Detector for evaluation, testing or proof-of-concept purposes. Trial licenses are temporary and may be subject to technical, functional, device or deployment limitations. Unless otherwise agreed in writing, a trial license is intended for evaluation purposes and does not constitute a production license and is non-refundable.'
      },
      {
        id: 'tc-9',
        num: '9',
        title: 'Limitation of Liability',
        text: 'To the maximum extent permitted by applicable law, Supplier shall not be liable for any indirect, consequential, punitive, or special damages, lost profits, lost revenue, business interruption, or loss of data. Supplier’s aggregate cumulative liability under or relating to this agreement shall not exceed the total fees actually paid by Customer to Supplier in the twelve (12) months preceding the claim.'
      },
      {
        id: 'tc-10',
        num: '10',
        title: 'Force Majeure and Termination',
        text: 'Neither party shall be liable for non-performance or delay caused by Force Majeure events beyond reasonable control (natural disasters, war, pandemics, trade embargoes, global semiconductor supply interruptions). Either party may terminate upon 30 days’ written notice if a material breach remains uncured.'
      },
      {
        id: 'tc-11',
        num: '11',
        title: 'Governing Law and Dispute Resolution',
        text: 'All legal relations governed by these Terms are subject to the laws of the Czech Republic, excluding its conflict-of-law principles and the CISG. Any dispute arising out of or in connection with these Terms shall be submitted to the exclusive jurisdiction of the competent courts in Plzeň, Czech Republic.'
      }
    ],
    crossLinksTitle: 'Related Legal Documents',
    crossLinks: [
      { route: 'eula', name: 'End User License Agreement (EULA)', desc: 'Software licensing terms and operational responsibilities' },
      { route: 'support-and-maintenance', name: 'Support & Maintenance Terms', desc: 'Support channels, AI updates, and target response times' },
      { route: 'privacy-policy', name: 'General Privacy Policy', desc: 'Data handling for website and business contacts' },
      { route: 'product-privacy', name: 'Product Privacy & Data Protection', desc: 'Technical edge privacy architecture of SED' }
    ]
  },
  de: {
    eyebrow: 'ALLGEMEINE GESCHÄFTSBEDINGUNGEN',
    title: 'Allgemeine Geschäftsbedingungen (AGB)',
    subtitle: 'Geschäfts- und Lieferbedingungen für Hardware, Softwarelizenzen und Supportleistungen der JALUD Embedded s.r.o.',
    version: 'Version 2026.1 (Gültig ab 1. Januar 2026)',
    tocTitle: 'Inhaltsverzeichnis',
    companyDetails: 'Lieferant: JALUD Embedded s.r.o., Nepomucká 1355/261, 326 00 Plzeň, Tschechische Republik, Id-Nr.: 03056287',
    preamble: 'Diese Allgemeinen Geschäftsbedingungen („AGB“) regeln die Geschäftsbeziehungen zwischen der JALUD Embedded s.r.o. („Lieferant“) und gewerblichen Kunden („Kunde“) für Hardware, Software und Dienstleistungen.',
    sections: [
      {
        id: 'tc-1',
        num: '1',
        title: 'Grundlegende Informationen und Definitionen',
        text: 'Lieferant ist JALUD Embedded s.r.o., Plzeň, Tschechische Republik. Verträge werden ausschließlich mit Unternehmern im Rahmen von B2B-Geschäftsbeziehungen geschlossen.'
      },
      {
        id: 'tc-2',
        num: '2',
        title: 'Angebote, Bestellungen und Vertragsschluss',
        text: 'Angebote sind unverbindlich, sofern nicht ausdrücklich befristet. Der Vertrag kommt durch schriftliche Auftragsbestätigung oder Anzahlungsrechnung zustande.'
      },
      {
        id: 'tc-3',
        num: '3',
        title: 'Preise und Zahlungsbedingungen',
        text: 'Alle Preise verstehen sich netto zzgl. gesetzlicher USt. Zahlungsziel beträgt 14 Tage ab Rechnungsdatum. Bei Zahlungsverzug fallen Verzugszinsen in Höhe von 0,05 % pro Tag an.'
      },
      {
        id: 'tc-4',
        num: '4',
        title: 'Lieferung von Hardware und Eigentumsvorbehalt',
        text: 'Lieferungen erfolgen gemäß Incoterms 2020 Ex Works (Plzeň) oder DAP. Die gelieferte Ware bleibt bis zur vollständigen Bezahlung im Eigentum des Lieferanten.'
      },
      {
        id: 'tc-5',
        num: '5',
        title: 'Softwarelizenzen und Abonnements',
        text: 'Die Nutzung von Software richtet sich nach der <a href="/eula" data-route="eula" style="color: var(--blue-primary); text-decoration: underline; font-weight: 600;">Endbenutzer-Lizenzvereinbarung (EULA)</a>. Software wird lizenziert, nicht verkauft. Abonnements verlängern sich automatisch, wenn sie nicht 30 Tage vor Ablauf gekündigt werden.'
      },
      {
        id: 'tc-6',
        num: '6',
        title: 'Technischer Support und Wartung',
        text: 'Supportleistungen und Reaktionszeiten richten sich nach den <a href="/support-and-maintenance" data-route="support-and-maintenance" style="color: var(--blue-primary); text-decoration: underline; font-weight: 600;">Support- und Wartungsbedingungen</a>.'
      },
      {
        id: 'tc-7',
        num: '7',
        title: 'Hardware-Gewährleistung und RMA',
        text: 'Die Gewährleistungsfrist für Hardware beträgt 24 Monate ab Lieferung. Reklamationen erfolgen über das RMA-Verfahren. Ausgeschlossen sind Schäden durch unsachgemäße Behandlung oder Überspannung.'
      },
      {
        id: 'tc-8',
        num: '8',
        title: '30-Tage-Testlizenz (Trial License)',
        text: 'JALUD kann eine 30-tägige Testlizenz für Sound Event Detector zu Evaluierungs-, Test- oder PoC-Zwecken bereitstellen. Testlizenzen dienen ausschließlich der Evaluierung und begründen keine Produktionslizenz und Lizenzgebühren sind nicht erstattungsfähig.'
      },
      {
        id: 'tc-9',
        num: '9',
        title: 'Haftungsbeschränkung',
        text: 'Die Gesamthaftung ist auf die vom Kunden in den letzten 12 Monaten gezahlte Vergütung beschränkt. Die Haftung für indirekte Schäden oder entgangenen Gewinn ist ausgeschlossen.'
      },
      {
        id: 'tc-10',
        num: '10',
        title: 'Höhere Gewalt und Kündigung',
        text: 'Höhere Gewalt entbindet die Parteien von Leistungspflichten während der Dauer des Ereignisses.'
      },
      {
        id: 'tc-11',
        num: '11',
        title: 'Anwendbares Recht und Gerichtsstand',
        text: 'Es gilt das Recht der Tschechischen Republik unter Ausschluss des UN-Kaufrechts (CISG). Ausschließlicher Gerichtsstand ist Plzeň, Tschechische Republik.'
      }
    ],
    crossLinksTitle: 'Zugehörige Dokumente',
    crossLinks: [
      { route: 'eula', name: 'Endbenutzer-Lizenzvereinbarung (EULA)', desc: 'Software-Lizenzbedingungen' },
      { route: 'support-and-maintenance', name: 'Support- und Wartungsbedingungen', desc: 'Technischer Support und Reaktionszeiten' },
      { route: 'privacy-policy', name: 'Allgemeine Datenschutzerklärung', desc: 'Datenschutz für Webseiten- und Geschäftskontakte' },
      { route: 'product-privacy', name: 'Produktdatenschutz', desc: 'Technische Datenschutz-Architektur von SED' }
    ]
  },
  es: {
    eyebrow: 'TÉRMINOS Y CONDICIONES COMERCIALES',
    title: 'Términos y Condiciones',
    subtitle: 'Condiciones generales de contratación para hardware, licencias de software y servicios de JALUD Embedded s.r.o.',
    version: 'Versión 2026.1 (Vigente a partir del 1 de enero de 2026)',
    tocTitle: 'Índice de términos',
    companyDetails: 'Proveedor: JALUD Embedded s.r.o., Nepomucká 1355/261, 326 00 Plzeň, República Checa, NIF: 03056287',
    preamble: 'Estos Términos y Condiciones regulan las relaciones comerciales y venta de hardware y licencias entre JALUD Embedded s.r.o. ("Proveedor") y clientes comerciales ("Cliente").',
    sections: [
      {
        id: 'tc-1',
        num: '1',
        title: 'Información general y definiciones',
        text: 'El Proveedor es JALUD Embedded s.r.o. Contratos suscritos exclusivamente en ámbito B2B con empresas o profesionales.'
      },
      {
        id: 'tc-2',
        num: '2',
        title: 'Ofertas, pedidos y formalización',
        text: 'Las ofertas son válidas durante 30 días salvo indicación expresa. El contrato se perfecciona con la confirmación del pedido por el Proveedor.'
      },
      {
        id: 'tc-3',
        num: '3',
        title: 'Precios y condiciones de pago',
        text: 'Precios netos sin IVA. Plazo estándar de pago de 14 días desde factura. Intereses de demora del 0,05 % diario sobre importes vencidos.'
      },
      {
        id: 'tc-4',
        num: '4',
        title: 'Entrega de hardware y reserva de dominio',
        text: 'Envíos según Incoterms 2020 Ex Works o DAP. La propiedad de los equipos se transmite tras el pago íntegro del precio.'
      },
      {
        id: 'tc-5',
        num: '5',
        title: 'Licencias de software y suscripciones',
        text: 'El uso del software se rige por el <a href="/eula" data-route="eula" style="color: var(--blue-primary); text-decoration: underline; font-weight: 600;">Acuerdo de Licencia (EULA)</a>. Las suscripciones se renuevan automáticamente salvo preaviso de 30 días.'
      },
      {
        id: 'tc-6',
        num: '6',
        title: 'Soporte técnico y mantenimiento',
        text: 'Regulado por los <a href="/support-and-maintenance" data-route="support-and-maintenance" style="color: var(--blue-primary); text-decoration: underline; font-weight: 600;">Términos de Soporte y Mantenimiento</a>.'
      },
      {
        id: 'tc-7',
        num: '7',
        title: 'Garantía de hardware y devoluciones (RMA)',
        text: 'Garantía de 24 meses sobre defectos de fabricación de hardware. Tramitación mediante procedimiento RMA.'
      },
      {
        id: 'tc-8',
        num: '8',
        title: 'Licencia de prueba de 30 días (PoC)',
        text: 'JALUD puede proporcionar una licencia de prueba de 30 días para evaluación y PoC. Las licencias de prueba no constituyen una licencia de producción y no son reembolsables.'
      },
      {
        id: 'tc-9',
        num: '9',
        title: 'Límite de responsabilidad',
        text: 'Responsabilidad agregada máxima limitada al importe abonado por el Cliente en los 12 meses anteriores. Exclusión de lucro cesante y daños indirectos.'
      },
      {
        id: 'tc-10',
        num: '10',
        title: 'Fuerza mayor y resolución',
        text: 'Causas de fuerza mayor exoneran de cumplimiento durante su duración.'
      },
      {
        id: 'tc-11',
        num: '11',
        title: 'Legislación y fuero judicial',
        text: 'Rige la legislación de la República Checa. Fuero exclusivo en los tribunales de Plzeň, República Checa.'
      }
    ],
    crossLinksTitle: 'Documentos relacionados',
    crossLinks: [
      { route: 'eula', name: 'Acuerdo de Licencia EULA', desc: 'Términos de software' },
      { route: 'support-and-maintenance', name: 'Términos de Soporte', desc: 'Mantenimiento y respuesta' },
      { route: 'privacy-policy', name: 'Política de Privacidad General', desc: 'Tratamiento de contactos comerciales' },
      { route: 'product-privacy', name: 'Privacidad del Producto', desc: 'Arquitectura técnica de SED' }
    ]
  },
  pt: {
    eyebrow: 'TERMOS E CONDIÇÕES COMERCIAIS',
    title: 'Termos e Condições',
    subtitle: 'Condições gerais comerciais de venda de hardware, licenciamento de software e prestação de serviços da JALUD Embedded s.r.o.',
    version: 'Versão 2026.1 (Em vigor desde 1 de janeiro de 2026)',
    tocTitle: 'Índice de termos',
    companyDetails: 'Fornecedor: JALUD Embedded s.r.o., Nepomucká 1355/261, 326 00 Plzeň, República Checa, NIF: 03056287',
    preamble: 'Estes Termos e Condições Gerais regulam as relações contratuais de fornecimento de equipamentos e software da JALUD Embedded s.r.o. ("Fornecedor") com clientes empresariais ("Cliente").',
    sections: [
      {
        id: 'tc-1',
        num: '1',
        title: 'Informações e Definições',
        text: 'Fornecedor: JALUD Embedded s.r.o., Plzeň, República Checa. Contratos celebrados em ambiente estritamente B2B.'
      },
      {
        id: 'tc-2',
        num: '2',
        title: 'Propostas e Celebração do Contrato',
        text: 'Propostas válidas por 30 dias. Contrato formalizado com a confirmação da encomenda ou fatura proforma.'
      },
      {
        id: 'tc-3',
        num: '3',
        title: 'Preços e Condições de Pagamento',
        text: 'Preços líquidos sem IVA. Prazo de vencimento a 14 dias a contar da fatura. Juros de mora de 0,05 % por dia de atraso.'
      },
      {
        id: 'tc-4',
        num: '4',
        title: 'Entrega e Reserva de Propriedade',
        text: 'Incoterms 2020 Ex Works ou DAP. Reserva de propriedade sobre o hardware até integral liquidação do valor faturado.'
      },
      {
        id: 'tc-5',
        num: '5',
        title: 'Licenciamento de Software e Subscrições',
        text: 'O uso de software rege-se pelo <a href="/eula" data-route="eula" style="color: var(--blue-primary); text-decoration: underline; font-weight: 600;">Contrato EULA</a>. Renovações automáticas salvo cancelamento prévio de 30 dias.'
      },
      {
        id: 'tc-6',
        num: '6',
        title: 'Apoio Técnico e Manutenção',
        text: 'Regulado pelos <a href="/support-and-maintenance" data-route="support-and-maintenance" style="color: var(--blue-primary); text-decoration: underline; font-weight: 600;">Termos de Suporte e Manutenção</a>.'
      },
      {
        id: 'tc-7',
        num: '7',
        title: 'Garantia de Hardware e Processo de RMA',
        text: 'Garantia de 24 meses sobre defeitos de fabrico de hardware com processo via RMA.'
      },
      {
        id: 'tc-8',
        num: '8',
        title: 'Licença de Teste de 30 Dias (PoC)',
        text: 'A JALUD pode disponibilizar uma licença de teste de 30 dias para avaliação. A licença de teste não constitui licença de produção e os pagamentos não são reembolsáveis.'
      },
      {
        id: 'tc-9',
        num: '9',
        title: 'Limitação de Responsabilidade',
        text: 'Responsabilidade máxima limitada aos valores faturados nos últimos 12 meses. Exclusão de danos indiretos e lucros cessantes.'
      },
      {
        id: 'tc-10',
        num: '10',
        title: 'Força Maior e Rescisão',
        text: 'Exoneração de responsabilidade em caso de eventos de força maior.'
      },
      {
        id: 'tc-11',
        num: '11',
        title: 'Legislação e Foro Competente',
        text: 'Lei checa aplicável. Foro comarca de Plzeň, República Checa.'
      }
    ],
    crossLinksTitle: 'Documentos associados',
    crossLinks: [
      { route: 'eula', name: 'Contrato de Licença EULA', desc: 'Termos de licenciamento de software' },
      { route: 'support-and-maintenance', name: 'Termos de Suporte', desc: 'Assistência técnica e tempos de resposta' },
      { route: 'privacy-policy', name: 'Política de Privacidade Geral', desc: 'Tratamento de dados no website' },
      { route: 'product-privacy', name: 'Privacidade do Produto', desc: 'Arquitetura técnica do SED' }
    ]
  },
  ar: {
    eyebrow: 'الشروط والأحكام التجارية',
    title: 'الشروط والأحكام العامة',
    subtitle: 'الشروط التجارية العامة لشراء الأجهزة وترخيص البرمجيات والخدمات من شركة JALUD Embedded s.r.o.',
    version: 'الإصدار 2026.1 (يسري اعتباراً من 1 يناير 2026)',
    tocTitle: 'فهرس الشروط التجارية',
    companyDetails: 'المورد: JALUD Embedded s.r.o.، العنوان: Nepomucká 1355/261, 326 00 Plzeň، الجمهورية التشيكية، السجل: 03056287',
    preamble: 'تحكم هذه الشروط والأحكام العامة العلاقات التجارية ومبيعات الأجهزة وتراخيص البرمجيات بين شركة JALUD Embedded s.r.o. ("المورد") والعملاء التجاريين ("العميل").',
    sections: [
      {
        id: 'tc-1',
        num: '١',
        title: 'المعلومات الأساسية والتعريفات',
        text: 'المورد هو JALUD Embedded s.r.o. في الجمهورية التشيكية. تقتصر العقود على التعاملات بين الشركات والمؤسسات (B2B).'
      },
      {
        id: 'tc-2',
        num: '٢',
        title: 'عروض الأسعار وأوامر الشراء وإبرام العقد',
        text: 'عروض الأسعار صالحة لمدة 30 يوماً. ينعقد العقد بتأكيد أمر الشراء كتابياً من المورد.'
      },
      {
        id: 'tc-3',
        num: '٣',
        title: 'الأسعار وشروط السداد',
        text: 'الأسعار صافية بدون ضريبة القيمة المضافة. مدة السداد 14 يوماً من تاريخ الفاتورة مع فرض فائدة تأخير قدرها 0.05% يومياً عند التخلف عن السداد.'
      },
      {
        id: 'tc-4',
        num: '٤',
        title: 'تسليم الأجهزة والاحتفاظ بالملكية',
        text: 'الشحن وفقاً لشروط Incoterms 2020 Ex Works أو DAP. تظل ملكية الأجهزة للمورد حتى سداد كامل الثمن.'
      },
      {
        id: 'tc-5',
        num: '٥',
        title: 'تراخيص البرمجيات والاشتراكات',
        text: 'يخضع استخدام البرمجيات لوثيقة <a href="/eula" data-route="eula" style="color: var(--blue-primary); text-decoration: underline; font-weight: 600;">اتفاقية ترخيص المستخدم النهائي (EULA)</a>. تتجدد الاشتراكات تلقائياً ما لم يتم الإخطار بعدم التجديد قبل 30 يوماً.'
      },
      {
        id: 'tc-6',
        num: '٦',
        title: 'الدعم الفني والصيانة',
        text: 'تخضع خدمات الدعم لوثيقة <a href="/support-and-maintenance" data-route="support-and-maintenance" style="color: var(--blue-primary); text-decoration: underline; font-weight: 600;">شروط الدعم والصيانة</a>.'
      },
      {
        id: 'tc-7',
        num: '٧',
        title: 'ضمان الأجهزة والمطالبات (RMA)',
        text: 'ضمان عتاد الأجهزة لمدة 24 شهراً من تاريخ التسليم عبر إجراءات ترخيص إعادة المواد (RMA).'
      },
      {
        id: 'tc-8',
        num: '٨',
        title: 'الترخيص التجريبي لمدة 30 يوماً (PoC)',
        text: 'يجوز لشركة JALUD منح ترخيص تجريبي لمدة 30 يوماً لأغراض التقييم واختبار إثبات المفهوم. لا يمثل الترخيص التجريبي ترخيصاً إنتاجياً ورسوم التراخيص غير قابلة للاسترداد.'
      },
      {
        id: 'tc-9',
        num: '٩',
        title: 'حدود المسؤولية',
        text: 'تقتصر المسؤولية الإجمالية على المبالغ المدفوعة خلال الـ 12 شهراً السابقة للمطالبة مع استبعاد الأضرار غير المباشرة وفوات الأرباح.'
      },
      {
        id: 'tc-10',
        num: '١٠',
        title: 'القوة القاهرة وإنهاء العقد',
        text: 'تعفي أحداث القوة القاهرة الطرفين من الالتزامات طوال فترة سريانها.'
      },
      {
        id: 'tc-11',
        num: '١١',
        title: 'القانون الحاكم والاختصاص القضائي',
        text: 'تسري قوانين الجمهورية التشيكية، ويكون الاختصاص القضائي لمحاكم مدينة بلزن (Plzeň) في الجمهورية التشيكية.'
      }
    ],
    crossLinksTitle: 'الوثائق القانونية ذات الصلة',
    crossLinks: [
      { route: 'eula', name: 'اتفاقية ترخيص المستخدم النهائي EULA', desc: 'شروط استخدام البرمجيات والترخيص' },
      { route: 'support-and-maintenance', name: 'شروط الدعم والصيانة', desc: 'مستويات الدعم الفني وأوقات الاستجابة' },
      { route: 'privacy-policy', name: 'سياسة الخصوصية العامة', desc: 'معالجة بيانات العملاء والموقع' },
      { route: 'product-privacy', name: 'خصوصية المنتج', desc: 'البنية التقنية لحماية الخصوصية في نظام SED' }
    ]
  }
,
  it: {
    "eyebrow": "TERMINI COMMERCIALI E FORNITURA",
    "title": "Termini e Condizioni Generali di Vendita e Fornitura",
    "subtitle": "Condizioni generali di fornitura per hardware Sound Event Detector, licenze software e servizi associati di JALUD Embedded s.r.o.",
    "version": "Versione 2026.1 (In vigore dal 1° gennaio 2026)",
    "tocTitle": "Indice dei Termini e Condizioni",
    "companyDetails": "Fornitore: JALUD Embedded s.r.o., Nepomucká 1355/261, 326 00 Plzeň, Repubblica Ceca, IČO: 03056287",
    "preamble": "I presenti Termini e Condizioni Generali (\"Condizioni Generali\" o \"GTC\") disciplinano tutti i rapporti commerciali, le offerte, gli ordini e i contratti per la fornitura di dispositivi hardware, licenze software Sound Event Detector (SED) e servizi correlati forniti da JALUD Embedded s.r.o. a clienti aziendali, distributori, integratori di sistemi ed enti pubblici.",
    "sections": [
      {
        "id": "terms-1",
        "num": "1",
        "title": "Disposizioni Generali e Ambito di Applicazione",
        "text": "Le presenti Condizioni Generali si applicano a tutti i contratti di vendita e fornitura stipulati tra JALUD Embedded s.r.o. (\"Fornitore\" o \"JALUD\") e il cliente (\"Acquirente\" o \"Cliente\"). Condizioni divergenti o contrastanti dell'Acquirente non troveranno applicazione se non espressamente accettate per iscritto dal Fornitore."
      },
      {
        "id": "terms-2",
        "num": "2",
        "title": "Formazione del Contratto e Ordini",
        "text": "Le proposte commerciali e i listini prezzi del Fornitore non costituiscono offerte vincolanti ma inviti a proporre. Il contratto si intende perfezionato esclusivamente al ricevimento della conferma d'ordine scritta da parte di JALUD o al momento della consegna della merce o delle chiavi di licenza software."
      },
      {
        "id": "terms-3",
        "num": "3",
        "title": "Prezzi, Condizioni di Pagamento e Riserva di Proprietà",
        "text": "Tutti i prezzi sono espressi in EUR o CZK al netto dell'IVA e dei dazi doganali. Salvo diverso accordo scritto, il pagamento delle fatture deve avvenire entro 14 giorni dalla data di emissione. L'hardware consegnato rimane di esclusiva proprietà di JALUD fino all'integrale pagamento del prezzo pattuito (riserva di proprietà)."
      },
      {
        "id": "terms-4",
        "num": "4",
        "title": "Consegna, Spedizione e Trasferimento del Rischio",
        "text": "La consegna dei prodotti hardware avviene franco fabbrica (Incoterms 2020: EXW Pilsen, Rep. Ceca) se non diversamente concordato. Il rischio di perdita o danneggiamento della merce si trasferisce all'Acquirente al momento della consegna al primo vettore."
      },
      {
        "id": "terms-5",
        "num": "5",
        "title": "Fornitura di Licenze Software e Integrazione",
        "text": "Le licenze software SED (versioni per telecamere ACAP, HEOP, Hanwha o versioni SED Server) vengono consegnate elettronicamente tramite chiavi di licenza o portale di attivazione. L'uso del software è disciplinato in via esclusiva dal relativo Contratto di Licenza con l'Utente Finale (EULA)."
      },
      {
        "id": "terms-6",
        "num": "6",
        "title": "Garanzia Hardware, Ispezione e Reclami",
        "text": "Il Fornitore garantisce che l'hardware SED è privo di difetti di fabbricazione per un periodo di 24 mesi dalla consegna. L'Acquirente ha l'obbligo di ispezionare la merce all'arrivo e denunciare eventuali difetti apparenti entro 5 giorni lavorativi. La garanzia non copre danni causati da errata installazione, sovratensioni o manomissioni."
      },
      {
        "id": "terms-7",
        "num": "7",
        "title": "Diritti di Proprietà Intellettuale e Riservatezza",
        "text": "Tutti i diritti di proprietà industriale, brevetti, know-how e marchi (marchio registrato EUIPO n. 018598475) rimangono di esclusiva titolarità di JALUD. Le parti si impegnano a mantenere la massima riservatezza sulle informazioni tecniche e commerciali scambiate."
      },
      {
        "id": "terms-8",
        "num": "8",
        "title": "Limitazione di Responsabilità e Forza Maggiore",
        "text": "La responsabilità risarcitoria del Fornitore è limitata al valore netto della commessa o fornitura che ha dato origine al danno. Nessuna delle parti sarà responsabile per inadempimenti dovuti a cause di forza maggiore (guerre, calamità naturali, interruzioni delle catene di approvvigionamento globali)."
      },
      {
        "id": "terms-9",
        "num": "9",
        "title": "Canali di Distribuzione e Obblighi dei Partner",
        "text": "I distributori e integratori partner si impegnano a commercializzare i prodotti SED rispettando le linee guida del marchio, fornendo supporto di primo livello ai clienti finali e sottoponendo agli utenti la documentazione contrattuale e la EULA di JALUD."
      },
      {
        "id": "terms-10",
        "num": "10",
        "title": "Conformità Normativa ed Export Control",
        "text": "Le parti si impegnano al rigoroso rispetto delle normative anticorruzione, delle sanzioni internazionali UE/ONU e della legislazione sul controllo delle esportazioni di beni a duplice uso o tecnologie avanzate."
      },
      {
        "id": "terms-11",
        "num": "11",
        "title": "Legge Applicabile, Foro Competente e Disposizioni Finali",
        "text": "Le presenti Condizioni Generali sono regolate dal diritto materiale della Repubblica Ceca con espressa esclusione della Convenzione delle Nazioni Unite sui contratti di vendita internazionale di merci (CISG). Per qualsiasi controversia sarà competente in via esclusiva il Foro di Plzeň, Repubblica Ceca."
      }
    ],
    "crossLinksTitle": "Documenti Legali Correlati",
    "crossLinks": [
      {
        "route": "eula",
        "name": "Licenza Utente Finale (EULA)",
        "desc": "Termini di licenza per l'uso del software SED su telecamere e server"
      },
      {
        "route": "support-and-maintenance",
        "name": "Termini di Supporto e Manutenzione",
        "desc": "SLA, livelli di servizio, aggiornamenti firmware e tempi di risposta"
      },
      {
        "route": "privacy-policy",
        "name": "Informativa sulla Privacy",
        "desc": "Trattamento dei dati personali dei partner commerciali e visitatori web"
      },
      {
        "route": "policy-ims",
        "name": "Politica IMS (ISO 9001 e ISO 27001)",
        "desc": "Standard aziendali di qualità e sicurezza delle informazioni"
      }
    ]
  }
};


export const privacyData = {
  cs: {
    eyebrow: 'OCHRANA OSOBNÍCH ÚDAJŮ & GDPR',
    title: 'Zásady ochrany osobních údajů',
    subtitle: 'Informace o zpracování osobních údajů společností JALUD Embedded s.r.o. v roli Správce údajů při návštěvě webu, obchodní komunikaci a poptávkách.',
    version: 'Verze 2026.1 (Účinnost od 1. ledna 2026)',
    tocTitle: 'Obsah zásad ochrany soukromí',
    companyDetails: 'Správce osobních údajů: JALUD Embedded s.r.o., Nepomucká 1355/261, 326 00 Plzeň, Česká republika, IČO: 03056287',
    preamble: 'Společnost JALUD Embedded s.r.o. („Správce“ nebo „JALUD“) klade maximální důraz na ochranu vašeho soukromí a osobních údajů v souladu s Nařízením Evropského parlamentu a Rady (EU) 2016/679 (GDPR) a zákonem č. 110/2019 Sb., o zpracování osobních údajů. Tyto zásady popisují, jak shromažďujeme a chráníme osobní údaje návštěvníků našich webových stránek, obchodních partnerů a poptávajících.',
    productNoticeBadge: 'Oddělení od produktových dat SED',
    productNoticeText: 'Tyto zásady se vztahují výhradně na provoz webu, poptávkové formuláře a obchodní vztahy, kde je JALUD Správcem údajů. <strong>Zásady pro akustická data a provoz senzorů Sound Event Detector (SED) jsou samostatně upraveny v dokumentu <a href="/product-privacy" data-route="product-privacy" style="color: #15803d; text-decoration: underline; font-weight: 700;">Produktové soukromí a ochrana dat</a>.</strong>',
    sections: [
      {
        id: 'priv-1',
        num: '1',
        title: 'Správce osobních údajů a kontaktní údaje',
        text: 'Správcem osobních údajů je společnost JALUD Embedded s.r.o., se sídlem Nepomucká 1355/261, 326 00 Plzeň, IČO: 03056287. V záležitostech ochrany osobních údajů nás můžete kontaktovat na e-mailu: <span class="sed-obf-email" data-u="aW5mbw==" data-d="amFsdWQtZW1iZWRkZWQuY29t" data-t="aW5mb0BqYWx1ZC1lbWJlZGRlZC5jb20=" style="color: var(--blue-primary); text-decoration: none; font-weight: 600;"><span class="sed-obf-fallback">info [at] jalud-embedded.com</span></span> nebo poštou na adrese sídla.'
      },
      {
        id: 'priv-2',
        num: '2',
        title: 'Rozsah a kategorie zpracovávaných osobních údajů',
        text: 'Zpracováváme pouze údaje nezbytné pro daný účel: (a) <strong>Identifikační a kontaktní údaje:</strong> jméno, příjmení, pracovní pozice, název společnosti, e-mailová adresa, telefonní číslo, IČO/DIČ; (b) <strong>Údaje z komunikace:</strong> obsah zpráv odeslaných přes poptávkové či kontaktní formuláře nebo e-mail; (c) <strong>Technické údaje o návštěvě webu:</strong> anonymizovaná IP adresa, typ prohlížeče, protokolové záznamy a údaje z analytických cookies (při udělení souhlasu).'
      },
      {
        id: 'priv-3',
        num: '3',
        title: 'Účely zpracování a právní základy dle GDPR',
        text: `Osobní údaje zpracováváme na základě následujících právních titulů:
          <ul style="margin: 0.75rem 0 0 1.25rem; padding: 0;">
            <li style="margin-bottom: 0.5rem;"><strong>Vyřízení poptávky a předsmluvní jednání (čl. 6 odst. 1 písm. b) GDPR):</strong> Zpracování údajů z formulářů za účelem vypracování cenové nabídky či odpovědi na dotaz.</li>
            <li style="margin-bottom: 0.5rem;"><strong>Plnění smlouvy (čl. 6 odst. 1 písm. b) GDPR):</strong> Dodávky hardwaru, poskytování softwarových licencí a technické podpory.</li>
            <li style="margin-bottom: 0.5rem;"><strong>Plnění zákonných povinností (čl. 6 odst. 1 písm. c) GDPR):</strong> Vedení účetnictví, archivace daňových dokladů dle zákona o DPH a zákona o účetnictví.</li>
            <li style="margin-bottom: 0.5rem;"><strong>Oprávněný zájem (čl. 6 odst. 1 písm. f) GDPR):</strong> Ochrana bezpečnosti webových stránek, obhajoba právních nároků a B2B komunikace se stávajícími zákazníky.</li>
            <li style="margin-bottom: 0.5rem;"><strong>Souhlas (čl. 6 odst. 1 písm. a) GDPR):</strong> Používání analytických a měřicích souborů cookie prostřednictvím cookie lišty.</li>
          </ul>`
      },
      {
        id: 'priv-4',
        num: '4',
        title: 'Doba uchovávání osobních údajů',
        text: 'Osobní údaje uchováváme po dobu nezbytnou k naplnění daného účelu: dotazy a poptávky po dobu trvání komunikace a následně maximálně 3 roky; smluvní a fakturační dokumentaci po dobu 10 let následujících po roce, ve kterém plnění proběhlo (dle daňových předpisů); analytická data webu dle nastavení cookies (viz <a href="/cookie-policy" data-route="cookie-policy" style="color: var(--blue-primary); text-decoration: underline; font-weight: 600;">Zásady cookies</a>).'
      },
      {
        id: 'priv-5',
        num: '5',
        title: 'Příjemci osobních údajů a zpracovatelé',
        text: 'Osobní údaje nepředáváme neoprávněným třetím stranám ani je neprodáváme. Přístup k údajům mají pouze pověření zaměstnanci a prověření smluvní zpracovatelé: poskytovatelé webhostingu a cloudových serverů v EU, poskytovatelé CRM a e-mailových systémů, daňoví a právní poradci. Se všemi zpracovateli máme uzavřeny smlouvy o zpracování údajů dle čl. 28 GDPR.'
      },
      {
        id: 'priv-6',
        num: '6',
        title: 'Předávání údajů mimo EU / EHP',
        text: 'Veškerá primární infrastruktura společnosti JALUD se nachází v Evropské unii. Pokud by výjimečně došlo k předání údajů mimo Evropský hospodářský prostor (např. při využití globálních analytických nástrojů), děje se tak výhradně na základě rozhodnutí Evropské komise o odpovídající ochraně nebo standardních smluvních doložek (SCC).'
      },
      {
        id: 'priv-7',
        num: '7',
        title: 'Vaše práva jako subjektu údajů dle GDPR',
        text: `Podle GDPR máte následující práva, která můžete uplatnit na našich kontaktních adresách:
          <ul style="margin: 0.75rem 0 0 1.25rem; padding: 0;">
            <li style="margin-bottom: 0.4rem;"><strong>Právo na přístup k údajům (čl. 15 GDPR):</strong> Získat potvrzení, zda údaje zpracováváme, a jejich kopii.</li>
            <li style="margin-bottom: 0.4rem;"><strong>Právo na opravu (čl. 16 GDPR):</strong> Žádat opravu nepřesných nebo doplnění neúplných údajů.</li>
            <li style="margin-bottom: 0.4rem;"><strong>Právo na výmaz („právo být zapomenut“ – čl. 17 GDPR):</strong> Žádat smazání údajů, pokud pominul účel nebo byl odvolán souhlas.</li>
            <li style="margin-bottom: 0.4rem;"><strong>Právo na omezení zpracování (čl. 18 GDPR):</strong> Omezit zpracování po dobu řešení námitek či sporné přesnosti.</li>
            <li style="margin-bottom: 0.4rem;"><strong>Právo na přenositelnost údajů (čl. 20 GDPR):</strong> Získat údaje ve strukturovaném formátu.</li>
            <li style="margin-bottom: 0.4rem;"><strong>Právo vznést námitku (čl. 21 GDPR):</strong> Právo namítat proti zpracování založenému na oprávněném zájmu.</li>
            <li style="margin-bottom: 0.4rem;"><strong>Právo odvolat souhlas:</strong> Kdykoli bez vlivu na zákonnost předchozího zpracování.</li>
          </ul>`
      },
      {
        id: 'priv-8',
        num: '8',
        title: 'Právo podat stížnost u dozorového úřadu',
        text: 'Pokud se domníváte, že při zpracování vašich osobních údajů došlo k porušení právních předpisů, máte právo podat stížnost u příslušného dozorového úřadu: <strong>Úřad pro ochranu osobních údajů (ÚOOÚ)</strong>, se sídlem Pplk. Sochora 27, 170 00 Praha 7, e-mail: posta@uoou.gov.cz, web: <a href="https://www.uoou.gov.cz" target="_blank" rel="noopener noreferrer" style="color: var(--blue-primary); text-decoration: underline;">www.uoou.gov.cz</a>.'
      },
      {
        id: 'priv-9',
        num: '9',
        title: 'Soubory cookie a nastavení soukromí',
        text: 'Naše webové stránky používají technické cookies nezbytné pro fungování a volitelné analytické cookies pro měření návštěvnosti. Podrobné informace o jednotlivých typech cookies naleznete na stránce <a href="/cookie-policy" data-route="cookie-policy" style="color: var(--blue-primary); text-decoration: underline; font-weight: 600;">Zásady používání cookies</a>. Své preference můžete kdykoliv změnit pomocí tlačítka Nastavení cookies v zápatí.'
      }
    ],
    crossLinksTitle: 'Související právní dokumentace',
    crossLinks: [
      { route: 'product-privacy', name: 'Produktové soukromí a ochrana dat', desc: 'Technické soukromí u SED (zpracování v RAM, nulové nahrávání řeči)' },
      { route: 'cookie-policy', name: 'Zásady cookies', desc: 'Detailní přehled cookies, LocalStorage a Google Analytics' },
      { route: 'data-processing-agreement', name: 'Smlouva o zpracování údajů (DPA)', desc: 'Podmínky pro cloudové a hostované služby' },
      { route: 'terms-and-conditions', name: 'Obchodní podmínky', desc: 'Všeobecné obchodní podmínky nákupu a licencí' }
    ]
  },
  en: {
    eyebrow: 'DATA PRIVACY & GDPR COMPLIANCE',
    title: 'Privacy Policy',
    subtitle: 'Information regarding the processing of personal data by JALUD Embedded s.r.o. as a Data Controller during website visits, commercial correspondence, and business inquiries.',
    version: 'Version 2026.1 (Effective January 1, 2026)',
    tocTitle: 'Table of Contents',
    companyDetails: 'Data Controller: JALUD Embedded s.r.o., Nepomucká 1355/261, 326 00 Plzeň, Czech Republic, Reg. ID: 03056287',
    preamble: 'JALUD Embedded s.r.o. ("Data Controller" or "JALUD") is deeply committed to protecting personal data in full compliance with Regulation (EU) 2016/679 of the European Parliament and of the Council (General Data Protection Regulation or GDPR) and applicable national data protection laws. This Privacy Policy explains how personal data relating to website visitors, potential clients, and business partners is collected, used, and safeguarded.',
    productNoticeBadge: 'Separation from SED Sensor Product Data',
    productNoticeText: 'This Privacy Policy strictly applies to website visits, contact form inquiries, and corporate B2B relations where JALUD acts as a Data Controller. <strong>Data governance, technical edge audio processing, and privacy-by-design principles for Sound Event Detector (SED) products are governed separately under the dedicated <a href="/product-privacy" data-route="product-privacy" style="color: #15803d; text-decoration: underline; font-weight: 700;">Product Privacy & Data Protection</a> page.</strong>',
    sections: [
      {
        id: 'priv-1',
        num: '1',
        title: 'Data Controller and Contact Details',
        text: 'The Data Controller responsible for your personal data is JALUD Embedded s.r.o., registered office at Nepomucká 1355/261, 326 00 Plzeň, Czech Republic, ID: 03056287. For inquiries regarding data protection, please contact us via email at: <span class="sed-obf-email" data-u="aW5mbw==" data-d="amFsdWQtZW1iZWRkZWQuY29t" data-t="aW5mb0BqYWx1ZC1lbWJlZGRlZC5jb20=" style="color: var(--blue-primary); text-decoration: none; font-weight: 600;"><span class="sed-obf-fallback">info [at] jalud-embedded.com</span></span> or by physical mail to our registered address.'
      },
      {
        id: 'priv-2',
        num: '2',
        title: 'Categories of Personal Data Processed',
        text: 'We process only the minimum personal data strictly necessary: (a) <strong>Identification and contact details:</strong> name, surname, job role, company name, corporate email address, telephone number, and tax ID; (b) <strong>Communication data:</strong> content of messages submitted via inquiry forms, demo requests, or correspondence; (c) <strong>Technical browsing data:</strong> anonymized IP addresses, browser user agent strings, access timestamps, and analytical cookie telemetry (upon consent).'
      },
      {
        id: 'priv-3',
        num: '3',
        title: 'Purposes and Legal Grounds for Processing',
        text: `We process personal data under the following legitimate grounds defined in GDPR Article 6:
          <ul style="margin: 0.75rem 0 0 1.25rem; padding: 0;">
            <li style="margin-bottom: 0.5rem;"><strong>Inquiry Handling & Pre-contractual Relations (Art. 6(1)(b) GDPR):</strong> Responding to demo requests, quotations, and commercial inquiries.</li>
            <li style="margin-bottom: 0.5rem;"><strong>Contract Performance (Art. 6(1)(b) GDPR):</strong> Fulfilling purchase orders, supplying hardware, and licensing software.</li>
            <li style="margin-bottom: 0.5rem;"><strong>Statutory Legal Compliance (Art. 6(1)(c) GDPR):</strong> Retaining tax and accounting records mandated by corporate financial legislation.</li>
            <li style="margin-bottom: 0.5rem;"><strong>Legitimate Business Interests (Art. 6(1)(f) GDPR):</strong> Ensuring website security, establishing or defending legal claims, and managing corporate B2B communications.</li>
            <li style="margin-bottom: 0.5rem;"><strong>Consent (Art. 6(1)(a) GDPR):</strong> Analytics and audience measurement cookies accepted via our cookie consent banner.</li>
          </ul>`
      },
      {
        id: 'priv-4',
        num: '4',
        title: 'Data Retention Periods',
        text: 'Personal data is retained only for as long as necessary: business inquiries and correspondence are retained for up to three (3) years following the conclusion of discussions; accounting documents and tax invoices are retained for ten (10) years in accordance with statutory accounting requirements; web analytics cookies are retained according to the parameters specified in our <a href="/cookie-policy" data-route="cookie-policy" style="color: var(--blue-primary); text-decoration: underline; font-weight: 600;">Cookie Policy</a>.'
      },
      {
        id: 'priv-5',
        num: '5',
        title: 'Recipients and Sub-processors',
        text: 'We do not sell, rent, or trade your personal data. Personal data may only be accessed by authorized personnel and trusted technical service providers operating under strict data processing agreements pursuant to GDPR Article 28, including cloud server hosting in the EU, CRM software providers, and certified accounting and legal advisers.'
      },
      {
        id: 'priv-6',
        num: '6',
        title: 'International Data Transfers',
        text: 'Our primary IT systems and databases are hosted within the European Union / European Economic Area (EU/EEA). In the limited event that auxiliary technical providers transfer data outside the EEA, transfers are conducted strictly under European Commission Adequacy Decisions or Standard Contractual Clauses (SCCs).'
      },
      {
        id: 'priv-7',
        num: '7',
        title: 'Your Rights as a Data Subject under GDPR',
        text: `Under GDPR Chapter III, you have the following enforceable rights:
          <ul style="margin: 0.75rem 0 0 1.25rem; padding: 0;">
            <li style="margin-bottom: 0.4rem;"><strong>Right of Access (Art. 15 GDPR):</strong> Confirmation of processing and copies of your personal data.</li>
            <li style="margin-bottom: 0.4rem;"><strong>Right to Rectification (Art. 16 GDPR):</strong> Correction of inaccurate or incomplete personal records.</li>
            <li style="margin-bottom: 0.4rem;"><strong>Right to Erasure ("Right to be Forgotten" – Art. 17 GDPR):</strong> Deletion of data where processing grounds no longer exist.</li>
            <li style="margin-bottom: 0.4rem;"><strong>Right to Restriction of Processing (Art. 18 GDPR):</strong> Temporary limitation of processing during legal disputes.</li>
            <li style="margin-bottom: 0.4rem;"><strong>Right to Data Portability (Art. 20 GDPR):</strong> Receiving your data in a structured, machine-readable format.</li>
            <li style="margin-bottom: 0.4rem;"><strong>Right to Object (Art. 21 GDPR):</strong> Right to object to processing based on legitimate business interests.</li>
            <li style="margin-bottom: 0.4rem;"><strong>Right to Withdraw Consent:</strong> Revoking cookie or communication consent at any time without retroactive penalty.</li>
          </ul>`
      },
      {
        id: 'priv-8',
        num: '8',
        title: 'Right to Lodge a Complaint with a Supervisory Authority',
        text: 'You have the right to lodge a complaint with your competent national data protection authority. In the Czech Republic, the lead supervisory body is the <strong>Office for Personal Data Protection (Úřad pro ochranu osobních údajů – ÚOOÚ)</strong>, Pplk. Sochora 27, 170 00 Praha 7, Czech Republic, email: posta@uoou.gov.cz, website: <a href="https://www.uoou.gov.cz" target="_blank" rel="noopener noreferrer" style="color: var(--blue-primary); text-decoration: underline;">www.uoou.gov.cz</a>.'
      },
      {
        id: 'priv-9',
        num: '9',
        title: 'Cookies and Tracking Management',
        text: 'Our website uses strictly necessary technical cookies to enable secure navigation and optional analytics cookies to assess site performance. Detailed cookie classifications and retention terms can be reviewed in our <a href="/cookie-policy" data-route="cookie-policy" style="color: var(--blue-primary); text-decoration: underline; font-weight: 600;">Cookie Policy</a>. You can adjust your consent choices at any time via the Cookie Settings trigger in the site footer.'
      }
    ],
    crossLinksTitle: 'Related Legal Framework',
    crossLinks: [
      { route: 'product-privacy', name: 'Product Privacy & Data Protection', desc: 'Acoustic sensor privacy, edge computing, and zero speech storage' },
      { route: 'cookie-policy', name: 'Cookie Policy', desc: 'Detailed breakdown of cookies, LocalStorage, and Google Analytics' },
      { route: 'data-processing-agreement', name: 'Data Processing Agreement (DPA)', desc: 'Standard GDPR Art. 28 terms for cloud and support services' },
      { route: 'terms-and-conditions', name: 'Terms & Conditions', desc: 'General commercial terms for hardware sales and software licenses' }
    ]
  },
  de: {
    eyebrow: 'DATENSCHUTZ & DSGVO-KONFORMITÄT',
    title: 'Datenschutzerklärung',
    subtitle: 'Informationen zur Verarbeitung personenbezogener Daten durch die JALUD Embedded s.r.o. als Verantwortlicher bei Websitebesuchen, Anfragen und Geschäftskontakten.',
    version: 'Version 2026.1 (Gültig ab 1. Januar 2026)',
    tocTitle: 'Inhaltsverzeichnis',
    companyDetails: 'Verantwortlicher: JALUD Embedded s.r.o., Nepomucká 1355/261, 326 00 Plzeň, Tschechische Republik, Id-Nr.: 03056287',
    preamble: 'Die JALUD Embedded s.r.o. („Verantwortlicher“ oder „JALUD“) schützt Ihre personenbezogenen Daten in voller Übereinstimmung mit der Datenschutz-Grundverordnung (DSGVO). Diese Datenschutzerklärung beschreibt die Verarbeitung von Daten von Webseitenbesuchern und Geschäftspartnern.',
    productNoticeBadge: 'Trennung von den Sensordaten der SED-Produkte',
    productNoticeText: 'Diese Erklärung gilt ausschließlich für Webseitenbesuche, Anfragen und B2B-Kundenkontakte. <strong>Die Grundsätze für akustische Daten und Sensoren des Sound Event Detectors (SED) werden gesondert auf der Seite <a href="/product-privacy" data-route="product-privacy" style="color: #15803d; text-decoration: underline; font-weight: 700;">Produktdatenschutz</a> geregelt.</strong>',
    sections: [
      {
        id: 'priv-1',
        num: '1',
        title: 'Verantwortlicher und Kontaktdaten',
        text: 'Verantwortlich ist JALUD Embedded s.r.o., Plzeň, Tschechische Republik. Kontakt: <span class="sed-obf-email" data-u="aW5mbw==" data-d="amFsdWQtZW1iZWRkZWQuY29t" data-t="aW5mb0BqYWx1ZC1lbWJlZGRlZC5jb20=" style="color: var(--blue-primary); text-decoration: none; font-weight: 600;"><span class="sed-obf-fallback">info [at] jalud-embedded.com</span></span>.'
      },
      {
        id: 'priv-2',
        num: '2',
        title: 'Kategorien verarbeiteter Daten',
        text: 'Verarbeitet werden Kontaktdaten (Name, E-Mail, Telefon, Unternehmen), Kommunikationsinhalte aus Kontaktformularen sowie technische Zugriffs- und Cookiedaten.'
      },
      {
        id: 'priv-3',
        num: '3',
        title: 'Zwecke und Rechtsgrundlagen nach Art. 6 DSGVO',
        text: 'Verarbeitung zur Bearbeitung von Anfragen (Art. 6 Abs. 1 lit. b), Vertragserfüllung (Art. 6 Abs. 1 lit. b), Erfüllung rechtlicher Pflichten (Art. 6 Abs. 1 lit. c), berechtigtem Interesse (Art. 6 Abs. 1 lit. f) und Einwilligung bei Analyse-Cookies (Art. 6 Abs. 1 lit. a).'
      },
      {
        id: 'priv-4',
        num: '4',
        title: 'Speicherdauer',
        text: 'Anfragen bis zu 3 Jahre nach Abschluss; steuerliche Buchhaltungsbelege 10 Jahre; Cookies gemäß den Festlegungen der Cookie-Richtlinie.'
      },
      {
        id: 'priv-5',
        num: '5',
        title: 'Empfänger und Auftragsverarbeiter',
        text: 'Daten werden nicht verkauft. Zugriff haben ausschließlich weisungsgebundene IT- und Hostingdienstleister innerhalb der EU.'
      },
      {
        id: 'priv-6',
        num: '6',
        title: 'Internationale Datenübermittlung',
        text: 'Die Verarbeitung erfolgt innerhalb der EU/EWR. Etwaige Übermittlungen in Drittländer erfolgen nur unter Vorliegen von Standardvertragsklauseln.'
      },
      {
        id: 'priv-7',
        num: '7',
        title: 'Ihre Rechte nach der DSGVO',
        text: 'Sie haben das Recht auf Auskunft (Art. 15), Berichtigung (Art. 16), Löschung (Art. 17), Einschränkung (Art. 18), Datenübertragbarkeit (Art. 20) und Widerspruch (Art. 21).'
      },
      {
        id: 'priv-8',
        num: '8',
        title: 'Beschwerderecht bei der Aufsichtsbehörde',
        text: 'Beschwerden können bei der Datenschutzbehörde (Úřad pro ochranu osobních údajů, ÚOOÚ, Prag) oder Ihrer nationalen Aufsichtsbehörde eingereicht werden.'
      },
      {
        id: 'priv-9',
        num: '9',
        title: 'Cookies und Präferenzen',
        text: 'Details zu eingesetzten Cookies finden Sie in der <a href="/cookie-policy" data-route="cookie-policy" style="color: var(--blue-primary); text-decoration: underline; font-weight: 600;">Cookie-Richtlinie</a>.'
      }
    ],
    crossLinksTitle: 'Zugehörige Dokumente',
    crossLinks: [
      { route: 'product-privacy', name: 'Produktdatenschutz & Datensicherheit', desc: 'Edge-Architektur und keine Sprachaufzeichnung bei SED' },
      { route: 'cookie-policy', name: 'Cookie-Richtlinie', desc: 'Detaillierte Übersicht über Web-Cookies' },
      { route: 'data-processing-agreement', name: 'Auftragsverarbeitungsvertrag (AVV)', desc: 'Vertragsbedingungen für Cloud-Dienste' },
      { route: 'terms-and-conditions', name: 'Allgemeine Geschäftsbedingungen', desc: 'Kommerzielle Bedingungen' }
    ]
  },
  es: {
    eyebrow: 'PROTECCIÓN DE DATOS & RGPD',
    title: 'Política de Privacidad',
    subtitle: 'Información sobre el tratamiento de datos personales por parte de JALUD Embedded s.r.o. como Responsable del Tratamiento.',
    version: 'Versión 2026.1 (Vigente a partir del 1 de enero de 2026)',
    tocTitle: 'Índice de privacidad',
    companyDetails: 'Responsable del Tratamiento: JALUD Embedded s.r.o., Nepomucká 1355/261, 326 00 Plzeň, República Checa, NIF: 03056287',
    preamble: 'JALUD Embedded s.r.o. ("Responsable") garantiza la protección de sus datos personales conforme al Reglamento General de Protección de Datos (RGPD).',
    productNoticeBadge: 'Diferenciación de los datos del producto SED',
    productNoticeText: 'Esta política rige para la web y relaciones comerciales. <strong>La gobernanza de datos acústicos de los sensores Sound Event Detector (SED) se detalla en <a href="/product-privacy" data-route="product-privacy" style="color: #15803d; text-decoration: underline; font-weight: 700;">Privacidad del Producto</a>.</strong>',
    sections: [
      {
        id: 'priv-1',
        num: '1',
        title: 'Responsable del tratamiento y contacto',
        text: 'JALUD Embedded s.r.o., Plzeň, República Checa. Email de contacto: <span class="sed-obf-email" data-u="aW5mbw==" data-d="amFsdWQtZW1iZWRkZWQuY29t" data-t="aW5mb0BqYWx1ZC1lbWJlZGRlZC5jb20=" style="color: var(--blue-primary); text-decoration: none; font-weight: 600;"><span class="sed-obf-fallback">info [at] jalud-embedded.com</span></span>.'
      },
      {
        id: 'priv-2',
        num: '2',
        title: 'Datos tratados',
        text: 'Datos de contacto comercial (nombre, correo, empresa), mensajes de formularios y registros de navegación técnica.'
      },
      {
        id: 'priv-3',
        num: '3',
        title: 'Fines y bases jurídicas',
        text: 'Atención de solicitudes (Art. 6.1.b), ejecución de contratos (Art. 6.1.b), obligaciones fiscales (Art. 6.1.c), interés legítimo (Art. 6.1.f) y consentimiento para cookies analíticas (Art. 6.1.a).'
      },
      {
        id: 'priv-4',
        num: '4',
        title: 'Plazos de conservación',
        text: 'Consultas hasta 3 años; facturación 10 años conforme a la normativa fiscal; cookies según su vigencia técnica.'
      },
      {
        id: 'priv-5',
        num: '5',
        title: 'Destinatarios de datos',
        text: 'No se ceden datos a terceros para fines comerciales. Proveedores de servicios cloud en la UE actúan como encargados.'
      },
      {
        id: 'priv-6',
        num: '6',
        title: 'Transferencias internacionales',
        text: 'Los datos se alojan en la UE/EEE bajo cláusulas contractuales tipo en caso de herramientas auxiliares.'
      },
      {
        id: 'priv-7',
        num: '7',
        title: 'Derechos del interesado',
        text: 'Derechos de acceso, rectificación, supresión, limitación, portabilidad y oposición conforme a los artículos 15 a 22 del RGPD.'
      },
      {
        id: 'priv-8',
        num: '8',
        title: 'Reclamación ante la autoridad de control',
        text: 'Puede presentar una reclamación ante la autoridad checa (ÚOOÚ) o la Agencia Española de Protección de Datos (AEPD).'
      },
      {
        id: 'priv-9',
        num: '9',
        title: 'Cookies',
        text: 'Consulte nuestra <a href="/cookie-policy" data-route="cookie-policy" style="color: var(--blue-primary); text-decoration: underline; font-weight: 600;">Política de Cookies</a> para gestionar sus preferencias.'
      }
    ],
    crossLinksTitle: 'Documentos relacionados',
    crossLinks: [
      { route: 'product-privacy', name: 'Privacidad del Producto', desc: 'Tratamiento en edge sin almacenamiento de voz' },
      { route: 'cookie-policy', name: 'Política de Cookies', desc: 'Detalles de cookies analíticas y técnicas' },
      { route: 'data-processing-agreement', name: 'Acuerdo de Encargo de Tratamiento', desc: 'Términos para servicios cloud' },
      { route: 'terms-and-conditions', name: 'Términos y Condiciones', desc: 'Condiciones comerciales generales' }
    ]
  },
  pt: {
    eyebrow: 'PROTEÇÃO DE DADOS & RGPD',
    title: 'Política de Privacidade',
    subtitle: 'Informações sobre o tratamento de dados pessoais pela JALUD Embedded s.r.o. na qualidade de Responsável pelo Tratamento.',
    version: 'Versão 2026.1 (Em vigor desde 1 de janeiro de 2026)',
    tocTitle: 'Índice de privacidade',
    companyDetails: 'Responsável pelo Tratamento: JALUD Embedded s.r.o., Nepomucká 1355/261, 326 00 Plzeň, República Checa, NIF: 03056287',
    preamble: 'A JALUD Embedded s.r.o. ("Responsável") assegura a proteção e confidencialidade dos seus dados nos termos do Regulamento Geral sobre a Proteção de Dados (RGPD).',
    productNoticeBadge: 'Distinção dos dados dos sensores SED',
    productNoticeText: 'Esta política aplica-se ao website e pedidos comerciais. <strong>As regras de dados acústicos dos sensores SED estão descritas em <a href="/product-privacy" data-route="product-privacy" style="color: #15803d; text-decoration: underline; font-weight: 700;">Privacidade do Produto</a>.</strong>',
    sections: [
      {
        id: 'priv-1',
        num: '1',
        title: 'Responsável e Contactos',
        text: 'JALUD Embedded s.r.o., Plzeň, República Checa. Email: <span class="sed-obf-email" data-u="aW5mbw==" data-d="amFsdWQtZW1iZWRkZWQuY29t" data-t="aW5mb0BqYWx1ZC1lbWJlZGRlZC5jb20=" style="color: var(--blue-primary); text-decoration: none; font-weight: 600;"><span class="sed-obf-fallback">info [at] jalud-embedded.com</span></span>.'
      },
      {
        id: 'priv-2',
        num: '2',
        title: 'Dados Pessoais Recolhidos',
        text: 'Dados de contacto profissional (nome, email, telefone, empresa), pedidos via formulário e cookies analíticos consentidos.'
      },
      {
        id: 'priv-3',
        num: '3',
        title: 'Finalidades e Fundamentos de Licitude',
        text: 'Diligências pré-contratuais (Art. 6.º, n.º 1, al. b), contratos (Art. 6.º, n.º 1, al. b), obrigações legais (Art. 6.º, n.º 1, al. c), interesse legítimo (Art. 6.º, n.º 1, al. f) e consentimento (Art. 6.º, n.º 1, al. a).'
      },
      {
        id: 'priv-4',
        num: '4',
        title: 'Prazos de Conservação',
        text: 'Pedidos comerciais por 3 anos; documentos fiscais por 10 anos segundo a legislação checa.'
      },
      {
        id: 'priv-5',
        num: '5',
        title: 'Destinatários e Subcontratantes',
        text: 'Apenas subcontratantes de alojamento cloud sediados na UE no âmbito de contratos conformes ao Art. 28 do RGPD.'
      },
      {
        id: 'priv-6',
        num: '6',
        title: 'Transferências Internacionais',
        text: 'Dados armazenados no espaço UE/EEE com salvaguardas adequadas.'
      },
      {
        id: 'priv-7',
        num: '7',
        title: 'Direitos dos Titulares',
        text: 'Direitos de acesso, retificação, apagamento, limitação, portabilidade e oposição nos termos dos Artigos 15 a 22 do RGPD.'
      },
      {
        id: 'priv-8',
        num: '8',
        title: 'Reclamação à Autoridade de Controlo',
        text: 'Direito a reclamar junto da ÚOOÚ na Chéquia ou da autoridade de proteção de dados do seu país de residência.'
      },
      {
        id: 'priv-9',
        num: '9',
        title: 'Cookies',
        text: 'Gestão de cookies disponível na <a href="/cookie-policy" data-route="cookie-policy" style="color: var(--blue-primary); text-decoration: underline; font-weight: 600;">Política de Cookies</a>.'
      }
    ],
    crossLinksTitle: 'Documentos associados',
    crossLinks: [
      { route: 'product-privacy', name: 'Privacidade do Produto', desc: 'Processamento de áudio local no SED' },
      { route: 'cookie-policy', name: 'Política de Cookies', desc: 'Detalhes dos cookies e rastreadores' },
      { route: 'data-processing-agreement', name: 'Acordo de Processamento de Dados', desc: 'Termos para serviços cloud' },
      { route: 'terms-and-conditions', name: 'Termos e Condições', desc: 'Condições gerais de venda e fornecimento' }
    ]
  },
  ar: {
    eyebrow: 'حماية البيانات واللائحة العامة GDPR',
    title: 'سياسة الخصوصية العامة',
    subtitle: 'معلومات حول معالجة البيانات الشخصية من قبل شركة JALUD Embedded s.r.o. بصفتها متحكماً في البيانات عند تصفح الموقع والتعاملات التجارية.',
    version: 'الإصدار 2026.1 (يسري اعتباراً من 1 يناير 2026)',
    tocTitle: 'فهرس بنود الخصوصية',
    companyDetails: 'متحكم البيانات: JALUD Embedded s.r.o.، العنوان: Nepomucká 1355/261, 326 00 Plzeň، الجمهورية التشيكية، السجل: 03056287',
    preamble: 'تلتزم شركة JALUD Embedded s.r.o. ("المتحكم") بحماية خصوصيتك وبياناتك الشخصية وفقاً للائحة العامة لحماية البيانات (GDPR) في الاتحاد الأوروبي.',
    productNoticeBadge: 'الفصل عن بيانات مستشعرات منتج SED',
    productNoticeText: 'تنطبق هذه السياسة على الموقع والاتصالات التجارية فقط. <strong>تخضع معالجة البيانات الصوتية لأجهزة كاشف الأحداث الصوتية (SED) لوثيقة <a href="/product-privacy" data-route="product-privacy" style="color: #15803d; text-decoration: underline; font-weight: 700;">خصوصية المنتج وحماية البيانات</a>.</strong>',
    sections: [
      {
        id: 'priv-1',
        num: '١',
        title: 'متحكم البيانات وبيانات التواصل',
        text: 'المتحكم هو JALUD Embedded s.r.o. في الجمهورية التشيكية. البريد الإلكتروني: <span class="sed-obf-email" data-u="aW5mbw==" data-d="amFsdWQtZW1iZWRkZWQuY29t" data-t="aW5mb0BqYWx1ZC1lbWJlZGRlZC5jb20=" style="color: var(--blue-primary); text-decoration: none; font-weight: 600;"><span class="sed-obf-fallback">info [at] jalud-embedded.com</span></span>.'
      },
      {
        id: 'priv-2',
        num: '٢',
        title: 'فئات البيانات الشخصية المعالجة',
        text: 'بيانات التواصل (الاسم، البريد، جهة العمل)، ومحتوى الرسائل والاستفسارات، وبيانات التصفح التقنية وملفات تعريف الارتباط.'
      },
      {
        id: 'priv-3',
        num: '٣',
        title: 'الأغراض والأسس القانونية',
        text: 'الرد على الاستفسارات وطلبات العروض، وتنفيذ العقود، والامتثال الضريبي، والمصلحة المشروعة، والموافقة لملفات تعريف الارتباط التحليلية.'
      },
      {
        id: 'priv-4',
        num: '٤',
        title: 'فترات الاحتفاظ بالبيانات',
        text: 'استفسارات العملاء حتى 3 سنوات، والوثائق المحاسبية والضريبية لمدة 10 سنوات وفقاً للقوانين المالية.'
      },
      {
        id: 'priv-5',
        num: '٥',
        title: 'المستلمون ومعالجو البيانات',
        text: 'لا يتم بيع البيانات أو مشاركتها تجارياً، وتقتصر الاستعانة على مزودي الخوادم السحابية الموثوقين داخل الاتحاد الأوروبي.'
      },
      {
        id: 'priv-6',
        num: '٦',
        title: 'نقل البيانات دولياً',
        text: 'تتم استضافة البيانات ومعالجتها داخل الاتحاد الأوروبي والمنطقة الاقتصادية الأوروبية.'
      },
      {
        id: 'priv-7',
        num: '٧',
        title: 'حقوقك بموجب لائحة GDPR',
        text: 'الحق في الوصول، والتصحيح، والمحو ("الحق في النسيان")، وتقييد المعالجة، ونقل البيانات، والاعتراض، وسحب الموافقة في أي وقت.'
      },
      {
        id: 'priv-8',
        num: '٨',
        title: 'الحق في تقديم شكوى لدى هيئة الرقابة',
        text: 'يحق لك تقديم شكوى لدى مكتب حماية البيانات الشخصية التشيكي (ÚOOÚ) عبر الموقع: <a href="https://www.uoou.gov.cz" target="_blank" rel="noopener noreferrer" style="color: var(--blue-primary); text-decoration: underline;">www.uoou.gov.cz</a>.'
      },
      {
        id: 'priv-9',
        num: '٩',
        title: 'ملفات تعريف الارتباط (Cookies)',
        text: 'راجع <a href="/cookie-policy" data-route="cookie-policy" style="color: var(--blue-primary); text-decoration: underline; font-weight: 600;">سياسة ملفات تعريف الارتباط</a> لإدارة خياراتك وتفضيلاتك.'
      }
    ],
    crossLinksTitle: 'الوثائق ذات الصلة',
    crossLinks: [
      { route: 'product-privacy', name: 'خصوصية المنتج وحماية البيانات', desc: 'معالجة الصوت في الذاكرة المؤقتة دون تسجيل الكلام' },
      { route: 'cookie-policy', name: 'سياسة ملفات تعريف الارتباط', desc: 'تفاصيل ملفات الارتباط والتحليلات' },
      { route: 'data-processing-agreement', name: 'اتفاقية معالجة البيانات DPA', desc: 'الشروط التعاقدية لخدمات السحابة' },
      { route: 'terms-and-conditions', name: 'الشروط والأحكام العامة', desc: 'الشروط التجارية العامة' }
    ]
  }
,
  it: {
    "eyebrow": "PROTEZIONE DEI DATI PERSONALI",
    "title": "Informativa sulla Privacy del Sito Web e Trattamento dei Dati",
    "subtitle": "Informativa trasparente sul trattamento dei dati personali dei visitatori del sito web, clienti, partner commerciali e richiedenti informazioni ai sensi del Regolamento UE 2016/679 (GDPR).",
    "version": "Versione 2026.1 (In vigore dal 1° gennaio 2026)",
    "tocTitle": "Indice dell'Informativa sulla Privacy",
    "companyDetails": "Titolare del Trattamento: JALUD Embedded s.r.o., Nepomucká 1355/261, 326 00 Plzeň, Repubblica Ceca, IČO: 03056287",
    "preamble": "La presente Informativa descrive le modalità con cui JALUD Embedded s.r.o. (\"JALUD\" o \"Titolare\") raccoglie, tratta e protegge i dati personali raccolti tramite il sito web www.jalud.eu, i moduli di contatto, le comunicazioni commerciali e i rapporti con partner e clienti, in piena conformità al Regolamento Generale sulla Protezione dei Dati (GDPR).",
    "sections": [
      {
        "id": "privacy-1",
        "num": "1",
        "title": "Identità e Dati di Contatto del Titolare",
        "text": "Il Titolare del trattamento è JALUD Embedded s.r.o., con sede legale in Nepomucká 1355/261, 326 00 Plzeň, Repubblica Ceca, iscrizione registro imprese IČO: 03056287. Per qualsiasi chiarimento in materia di protezione dei dati è possibile scrivere a: <span class=\"sed-obf-email\" data-u=\"aW5mbw==\" data-d=\"amFsdWQtZW1iZWRkZWQuY29t\" data-t=\"aW5mb0BqYWx1ZC1lbWJlZGRlZC5jb20=\" style=\"color: var(--blue-primary); font-weight: 600;\"><span class=\"sed-obf-fallback\">info [at] jalud-embedded.com</span></span>."
      },
      {
        "id": "privacy-2",
        "num": "2",
        "title": "Categorie di Dati Personali Trattati",
        "text": "Trattiamo i dati forniti volontariamente dall'utente nei moduli di richiesta (nome, cognome, indirizzo e-mail professionale, recapito telefonico, azienda di appartenenza, settore di progetto), nonché dati tecnici di navigazione (indirizzo IP anonimizzato, log di accesso, cookie tecnici necessari)."
      },
      {
        "id": "privacy-3",
        "num": "3",
        "title": "Finalità e Basi Giuridiche del Trattamento",
        "text": "I dati sono trattati per: a) gestione delle richieste di preventivo, consulenza o demo (esecuzione di misure precontrattuali, Art. 6(1)(b) GDPR); b) adempimento di obblighi contrattuali e fiscali (Art. 6(1)(c) GDPR); c) legittimo interesse alla sicurezza del sito e prevenzione di abusi (Art. 6(1)(f) GDPR); d) analisi statistica e cookie opzionali previo espresso consenso dell'utente (Art. 6(1)(a) GDPR)."
      },
      {
        "id": "privacy-4",
        "num": "4",
        "title": "Periodo di Conservazione dei Dati",
        "text": "I dati delle richieste commerciali vengono conservati per il tempo necessario alla gestione della trattativa e per un periodo massimo di 3 anni dall'ultimo contatto utile, salvo obblighi di legge superiori (es. 10 anni per la documentazione contabile e fiscale)."
      },
      {
        "id": "privacy-5",
        "num": "5",
        "title": "Destinatari dei Dati e Trasferimenti Extra-UE",
        "text": "I dati personali non vengono venduti né ceduti a terzi. Possono essere trattati da fornitori tecnici fidati (hosting provider situati nell'Unione Europea, piattaforme CRM, consulenti legali e contabili) debitamente designati quali Responsabili del Trattamento ex Art. 28 GDPR. Non effettuiamo trasferimenti verso paesi extra-SEE privi di decisione di adeguatezza o garanzie adeguate."
      },
      {
        "id": "privacy-6",
        "num": "6",
        "title": "Diritti degli Interessati",
        "text": "In qualità di interessato, l'utente ha diritto di: accedere ai propri dati personali, chiederne la rettifica o la cancellazione (\"diritto all'oblio\"), limitarne il trattamento, opporsi al trattamento per motivi legittimi e richiedere la portabilità dei dati. Ha inoltre diritto di revocare in qualsiasi momento il consenso prestato."
      },
      {
        "id": "privacy-7",
        "num": "7",
        "title": "Diritto di Proporre Reclamo all'Autorità di Controllo",
        "text": "Qualora ritenga che il trattamento violi le norme vigenti, l'interessato ha il diritto di proporre reclamo all'Ufficio per la Protezione dei Dati Personali della Repubblica Ceca (Úřad pro ochranu osobních údajů - ÚOOÚ, www.uoou.cz) o all'autorità garante del paese UE di residenza (in Italia: Garante per la Protezione dei Dati Personali)."
      },
      {
        "id": "privacy-8",
        "num": "8",
        "title": "Misure di Sicurezza Tecniche e Organizzative",
        "text": "Adottiamo standard di sicurezza certificati secondo la norma ISO/IEC 27001:2022, inclusa crittografia SSL/TLS per tutte le trasmissioni dati, controllo rigoroso degli accessi e protezione antivirus avanzata contro accessi non autorizzati."
      },
      {
        "id": "privacy-9",
        "num": "9",
        "title": "Modifiche all'Informativa",
        "text": "Ci riserviamo il diritto di aggiornare periodicamente la presente Informativa in conformità a novità legislative o miglioramenti dei nostri servizi. La data dell'ultima revisione è indicata in intestazione."
      }
    ],
    "crossLinksTitle": "Documenti Legali Correlati",
    "crossLinks": [
      {
        "route": "cookie-policy",
        "name": "Politica sui Cookie",
        "desc": "Dettaglio dei cookie utilizzati, preferenze e revoca del consenso"
      },
      {
        "route": "product-privacy",
        "name": "Privacy del Prodotto SED",
        "desc": "Architettura tecnica di privacy per i dispositivi e telecamere SED"
      },
      {
        "route": "data-processing-agreement",
        "name": "Accordo sul Trattamento dei Dati (DPA)",
        "desc": "Contratto standard ex Art. 28 GDPR per partner e clienti cloud"
      },
      {
        "route": "terms-and-conditions",
        "name": "Termini e Condizioni Generali",
        "desc": "Condizioni commerciali e contrattuali di JALUD Embedded"
      }
    ]
  }
};


export const productPrivacyData = {
  cs: {
    eyebrow: 'ARCHITEKTURA SOUKROMÍ & TECHNICKÁ DATA',
    title: 'Produktové soukromí a ochrana dat',
    subtitle: 'Technické a právní principy ochrany soukromí technologie Sound Event Detector (SED) – zpracování na hraně sítě (Edge), nulové nahrávání řeči a soulad s GDPR.',
    version: 'Verze 2026.1 (Účinnost od 1. ledna 2026)',
    gdprStudyBtn: "Právní posudek GDPR (PDF)",
    gdprStudyBoxTitle: "Oficiální právní posudek a certifikace GDPR",
    gdprStudyBoxDesc: "Nezávislý právní rozbor advokátní kanceláře GÖRGES & PARTNERS i technické prohlášení o shodě s GDPR jsou k dispozici ke stažení:",
    gdprStudyDownloadBtn: "Právní posudek GDPR – GÖRGES & PARTNERS (PDF)",
    gdprStatementDownloadBtn: "Prohlášení o shodě s GDPR (PDF)",
    gdprManualsLink: "Zobrazit v sekci Manuály & Technické listy →",
    tocTitle: 'Obsah dokumentu',
    companyDetails: 'Výrobce a vývojář: JALUD Embedded s.r.o., Nepomucká 1355/261, 326 00 Plzeň, Česká republika, IČO: 03056287',
    introBadge: 'Privacy by Design & by Default',
    introText: 'Technologie Sound Event Detector (SED) byla od samého počátku vyvíjena podle principů Privacy by Design (záměrná ochrana soukromí) a Privacy by Default (výchozí ochrana soukromí). Základním pilířem SED je detekce specifických fyzikálních zvukových vzorců nebezpečných událostí bez nutnosti shromažďovat, nahrávat či odposlouchávat lidskou řeč.',
    sections: [
      {
        id: 'pp-1',
        num: '1',
        title: 'Architektura Privacy by Design a zpracování v RAM',
        text: 'Software SED běží přímo na koncovém zařízení (edge hardware, bezpečnostní kamera Axis/Hikvision/Hanwha nebo lokální server). Vstupní zvukový signál z mikrofonu je načítán do krátkého vyrovnávacího bufferu v dočasné operační paměti (RAM), kde probíhá okamžitá spektrální analýza a extrakce akustických příznaků pomocí neuronových sítí. Audio signál není průběžně ukládán na disk ani nikam vysílán. Jakmile zvuk projde vyhodnocovacím oknem, je z paměti RAM nevratně přepsán a smazán.'
      },
      {
        id: 'pp-2',
        num: '2',
        title: 'Vyloučení biometrické identifikace a rozpoznávání řeči',
        text: '<strong>SED není navržen k identifikaci konkrétních mluvčích ani k provádění biometrické identifikace osob.</strong> Neuronové sítě SED nerozpoznávají obsah lidské řeči, neprovádějí přepis hlasu na text (speech-to-text) ani nezkoumají biometrické charakteristiky hlasu mluvčího. Technologie reaguje výhradně na neřečové akustické fenomény – frekvenční spektra, náběhové křivky a energii zvukových událostí, jako je střelba, tříštění skla, panický výkřik, exploze či průmyslové sirény.'
      },
      {
        id: 'pp-3',
        num: '3',
        title: 'Scénář A: Lokální instalace na straně zákazníka (On-Premise / Edge)',
        text: 'V drtivé většině instalací funguje SED plně v uzavřeném prostředí zákazníka (On-Premise či embedded kamera). Veškeré vyhodnocení probíhá lokálně uvnitř privátní sítě zákazníka a žádná zvuková data ani metadata nejsou odesílána společnosti JALUD. V tomto scénáři je <strong>zákazník výhradním Správcem osobních údajů</strong> a společnost JALUD nemá k datům přístup a <strong>nevystupuje jako Zpracovatel</strong> ve smyslu čl. 28 GDPR.'
      },
      {
        id: 'pp-4',
        num: '4',
        title: 'Scénář B: Cloudové služby, centrální správa a vzdálená podpora',
        text: 'Pokud zákazník dobrovolně využívá cloudovou telemetrii, centrálně hostovaný SEDServer nebo požádá společnost JALUD o technickou diagnostiku a vzdálenou podporu, při které může dojít k předání metadat či verifikačních audio nahrávek, vystupuje JALUD v roli <strong>Zpracovatele osobních údajů</strong>. Tento vztah je závazně upraven naší <a href="/data-processing-agreement" data-route="data-processing-agreement" style="color: var(--blue-primary); text-decoration: underline; font-weight: 600;">Smlouvou o zpracování osobních údajů (DPA)</a> podle čl. 28 GDPR.'
      },
      {
        id: 'pp-5',
        num: '5',
        title: 'Konfigurovatelné verifikační ústřižky (1,5s audio) a metadata',
        text: 'Systém SED umožňuje volitelnou konfiguraci generování krátkých verifikačních zvukových ústřižků (max 1,5s). Tyto ústřižky slouží výhradně k rychlému lidskému ověření pravosti poplachu na dispečinku. Zákazník má plnou kontrolu nad touto funkcí: může ji kompletně vypnout (provoz čistě v režimu metadat/událostí bez zvuku), nastavit retenční lhůtu automatického mazání a určit oprávněné osoby s přístupem.'
      },
      {
        id: 'pp-6',
        num: '6',
        title: 'Povinnosti a odpovědnost provozovatele (zákazníka)',
        text: 'Jako správce monitorovaného prostoru odpovídá zákazník za: (a) stanovení platného právního základu pro provozování bezpečnostního monitoringu (obvykle oprávněný zájem na ochraně majetku a zdraví osob dle čl. 6 odst. 1 písm. f) GDPR); (b) splnění informační povinnosti vůči veřejnosti (např. piktogramy a informační cedule o akustickém monitoringu); (c) provedení posouzení vlivu na ochranu osobních údajů (DPIA), pokud to vyžaduje charakter nasazení; (d) zabezpečení přístupu k VMS a záznamovým zařízením.'
      },
      {
        id: 'pp-7',
        num: '7',
        title: 'Nezávislé právní a bezpečnostní posouzení',
        text: 'Soulad technologie Sound Event Detector s evropskou legislativou na ochranu osobních údajů byl detailně prověřen a potvrzen nezávislou právní analýzou advokátní kanceláře (JUDr. PhDr. Karolina Görges Ph.D., specialista na IT právo a ochranu dat). Z posudku vyplývá, že detekce na hraně sítě bez trvalého záznamu lidského hlasu plně vyhovuje požadavkům GDPR i judikatuře Soudního dvora EU.'
      },
      {
        id: 'pp-8',
        num: '8',
        title: 'Bezpečnostní a technická opatření (TOMs)',
        text: 'Společnost JALUD uplatňuje Integrovaný systém řízení jakosti a bezpečnosti informací dle norem ISO 9001 a ISO 27001 (viz <a href="/policy-ims" data-route="policy-ims" style="color: var(--blue-primary); text-decoration: underline; font-weight: 600;">Politika IMS</a>). Veškerá komunikace mezi komponentami SED využívá šifrování TLS 1.3, binární balíčky firmwaru jsou digitálně podepisovány a přístup do konfiguračních rozhraní podléhá striktní autentizaci.'
      }
    ],
    crossLinksTitle: 'Související dokumentace',
    crossLinks: [
      { route: 'eula', name: 'Licenční smlouva EULA', desc: 'Podmínky užívání softwaru SED, asistivní role a vyloučení odpovědnosti' },
      { route: 'privacy-policy', name: 'Zásady ochrany osobních údajů (Web & CRM)', desc: 'Jak JALUD nakládá s údaji zákazníků a návštěvníků webu' },
      { route: 'data-processing-agreement', name: 'Smlouva o zpracování údajů (DPA)', desc: 'Podmínky zpracování dat při využití cloudu JALUD' },
      { route: 'policy-ims', name: 'Politika IMS (ISO 9001 / 27001)', desc: 'Certifikovaný systém bezpečnosti informací a řízení jakosti' },
      { route: 'manuals-and-datasheets', name: "Manuály a technické listy (GDPR & Certifikace)", desc: "Kompletní technická dokumentace, posudek advokátní kanceláře a certifikáty CE/FCC" }
    ]
  },
  en: {
    eyebrow: 'PRIVACY ARCHITECTURE & TECHNICAL DATA',
    title: 'Product Privacy & Data Protection',
    subtitle: 'Technical and legal privacy framework of Sound Event Detector (SED) – Edge computing, zero ambient speech recording, and GDPR alignment.',
    version: 'Version 2026.1 (Effective January 1, 2026)',
    gdprStudyBtn: "GDPR Legal Study (PDF)",
    gdprStudyBoxTitle: "Official GDPR Legal Assessment & Compliance",
    gdprStudyBoxDesc: "The independent legal assessment by GÖRGES & PARTNERS and the official SED GDPR Compliance Statement are available for download:",
    gdprStudyDownloadBtn: "GDPR Legal Opinion – GÖRGES & PARTNERS (PDF)",
    gdprStatementDownloadBtn: "GDPR Compliance Statement (PDF)",
    gdprManualsLink: "View in Manuals & Datasheets section →",
    tocTitle: 'Table of Contents',
    companyDetails: 'Manufacturer & Developer: JALUD Embedded s.r.o., Nepomucká 1355/261, 326 00 Plzeň, Czech Republic, Reg. ID: 03056287',
    introBadge: 'Privacy by Design & by Default',
    introText: 'Sound Event Detector (SED) technology has been engineered from its foundational design in strict adherence to the principles of Privacy by Design and Privacy by Default. The core paradigm of SED is the automated acoustic detection of physical frequency signatures associated with acute security threats without monitoring, recording, or eavesdropping on human conversation.',
    sections: [
      {
        id: 'pp-1',
        num: '1',
        title: 'Privacy by Design Architecture and Volatile RAM Processing',
        text: 'The SED engine executes directly on edge hardware (dedicated edge nodes, smart IP cameras from Axis, Hikvision, or Hanwha, or on-premise servers). Audio input captured by the connected microphone is ingested into a transient volatile buffer in Random Access Memory (RAM), where acoustic feature extraction and neural network inference occur instantaneously. The continuous audio stream is never saved to non-volatile storage nor transmitted across external networks. Once evaluated, audio frames are immediately and permanently overwritten in RAM.'
      },
      {
        id: 'pp-2',
        num: '2',
        title: 'Exclusion of Biometric Identification and Speech Analysis',
        text: '<strong>SED is not designed to identify individual speakers or perform biometric identification of persons.</strong> The neural networks governing SED do not perform speech-to-text transcription, natural language processing, semantic conversation analysis, or vocal biometric profiling. The system responds solely to non-speech physical acoustic phenomena – frequency bandwidths, attack transients, and energy curves indicative of gunshots, breaking glass, panic screams, explosions, or industrial sirens.'
      },
      {
        id: 'pp-3',
        num: '3',
        title: 'Scenario A: On-Premises & Edge Deployments (Customer Perimeter)',
        text: 'In standard deployments, SED operates completely within the customer’s secure physical and digital perimeter. All inference takes place locally on edge devices or local servers. No audio stream, event notification, or metadata is transmitted to JALUD. Under this scenario, the <strong>customer is the sole Data Controller</strong> under GDPR, and JALUD has no access to data and <strong>does not act as a Data Processor</strong> under GDPR Article 28.'
      },
      {
        id: 'pp-4',
        num: '4',
        title: 'Scenario B: Cloud-Connected Deployments and Remote Support',
        text: 'Where a customer voluntarily opts into cloud telemetry, cloud-hosted SEDServer management, or requests remote technical support involving access to diagnostic logs or event verification snippets, JALUD acts as a <strong>Data Processor</strong> on the customer’s behalf. This processing is strictly governed by our standard <a href="/data-processing-agreement" data-route="data-processing-agreement" style="color: var(--blue-primary); text-decoration: underline; font-weight: 600;">Data Processing Agreement (DPA)</a> pursuant to GDPR Article 28.'
      },
      {
        id: 'pp-5',
        num: '5',
        title: 'Configurable Verification Snippets (1.5s Audio) and Metadata',
        text: 'SED provides an optional, user-configurable feature to generate brief verification audio clips (max 1.5s). These clips enable security operators at control stations to verify incident authenticity. The customer retains full governance over this capability: it can be entirely disabled (operating exclusively with metadata and trigger alerts), retention periods can be enforced, and granular access controls applied.'
      },
      {
        id: 'pp-6',
        num: '6',
        title: 'Customer Compliance and Deployment Responsibilities',
        text: 'As the operator and Data Controller of the monitored installation, the customer is responsible for: (a) establishing a lawful legal basis for acoustic monitoring under applicable law (typically legitimate interest under GDPR Article 6(1)(f)); (b) displaying clear public notices and surveillance signage where required; (c) conducting Data Protection Impact Assessments (DPIA) where mandated by local supervisory authorities; and (d) configuring role-based access to security management systems.'
      },
      {
        id: 'pp-7',
        num: '7',
        title: 'Independent Legal and Regulatory Assessment',
        text: 'The compliance of Sound Event Detector with European privacy legislation has been thoroughly evaluated and validated by independent legal experts in data protection and IT law (including comprehensive legal opinions by Dr. Karolina Görges). The assessments confirm that edge acoustic event detection without persistent speech storage complies fully with GDPR principles and CJEU jurisprudence.'
      },
      {
        id: 'pp-8',
        num: '8',
        title: 'Technical and Organizational Security Measures (TOMs)',
        text: 'JALUD Embedded s.r.o. maintains an Integrated Management System certified under ISO 9001 (Quality) and ISO 27001 (Information Security) standards (see <a href="/policy-ims" data-route="policy-ims" style="color: var(--blue-primary); text-decoration: underline; font-weight: 600;">Policy IMS</a>). All inter-service communications enforce TLS 1.3 encryption, firmware packages are cryptographically signed, and administrative interfaces require robust authentication.'
      }
    ],
    crossLinksTitle: 'Related Governance Documents',
    crossLinks: [
      { route: 'eula', name: 'End User License Agreement (EULA)', desc: 'Software licensing terms, assistive technology role, and liability limits' },
      { route: 'privacy-policy', name: 'General Privacy Policy (Web & Inquiries)', desc: 'Controller-level privacy policy for website visitors and business inquiries' },
      { route: 'data-processing-agreement', name: 'Data Processing Agreement (DPA)', desc: 'Standard GDPR Article 28 terms for cloud services and support' },
      { route: 'policy-ims', name: 'Policy IMS (ISO 9001 / 27001)', desc: 'Certified information security and quality management commitments' },
      { route: 'manuals-and-datasheets', name: "Manuals & Datasheets (GDPR & Compliance)", desc: "Complete technical documentation, independent legal opinion, and CE/FCC certificates" }
    ]
  },
  de: {
    eyebrow: 'DATENSCHUTZARCHITEKTUR & TECHNIK',
    title: 'Produktdatenschutz & Datensicherheit',
    subtitle: 'Technische und rechtliche Grundlagen des Datenschutzes bei Sound Event Detector (SED) – Edge-Computing, keine Sprachaufzeichnung und DSGVO-Konformität.',
    version: 'Version 2026.1 (Gültig ab 1. Januar 2026)',
    gdprStudyBtn: "DSGVO-Rechtsgutachten (PDF)",
    gdprStudyBoxTitle: "Offizielles DSGVO-Rechtsgutachten & Zertifizierung",
    gdprStudyBoxDesc: "Das unabhängige juristische Gutachten der Kanzlei GÖRGES & PARTNERS und die offizielle DSGVO-Erklärung stehen zum Download bereit:",
    gdprStudyDownloadBtn: "DSGVO-Rechtsgutachten – GÖRGES & PARTNERS (PDF)",
    gdprStatementDownloadBtn: "DSGVO-Konformitätserklärung (PDF)",
    gdprManualsLink: "In Handbücher & Datenblätter ansehen →",
    tocTitle: 'Inhaltsverzeichnis',
    companyDetails: 'Entwickler & Hersteller: JALUD Embedded s.r.o., Nepomucká 1355/261, 326 00 Plzeň, Tschechische Republik, Id-Nr.: 03056287',
    introBadge: 'Privacy by Design & by Default',
    introText: 'Die Technologie des Sound Event Detectors (SED) wurde von Grund auf nach den Prinzipien Privacy by Design und Privacy by Default entwickelt. SED erkennt spezifische physikalische Frequenzmuster von Gefahrenereignissen, ohne menschliche Gespräche aufzuzeichnen oder abzuhören.',
    sections: [
      {
        id: 'pp-1',
        num: '1',
        title: 'Privacy-by-Design-Architektur und RAM-Verarbeitung',
        text: 'SED wird direkt auf Edge-Geräten (Axis/Hikvision/Hanwha Kameras oder lokalen Servern) ausgeführt. Audiosignale werden flüchtig im Arbeitsspeicher (RAM) analysiert. Nach der Erkennung werden die Daten sofort überschrieben. Es erfolgt keine dauerhafte Speicherung von Gesprächsdaten.'
      },
      {
        id: 'pp-2',
        num: '2',
        title: 'Ausschluss biometrischer Identifikation',
        text: '<strong>SED ist nicht darauf ausgelegt, einzelne Sprecher zu identifizieren oder biometrische Erkennung durchzuführen.</strong> Das System führt weder Spracherkennung noch Sprecherprofiling durch. Es reagiert ausschließlich auf nicht-sprachliche akustische Merkmale wie Schüsse, Glasbruch, Schreie oder Alarme.'
      },
      {
        id: 'pp-3',
        num: '3',
        title: 'Szenario A: Lokale Vor-Ort-Installation (On-Premise / Edge)',
        text: 'Bei lokalen Installationen verbleiben alle Daten vollständig im geschlossenen Kundennetzwerk. JALUD hat keinen Zugriff auf Audiodaten. Der Kunde ist alleiniger Verantwortlicher im Sinne der DSGVO; JALUD agiert nicht als Auftragsverarbeiter.'
      },
      {
        id: 'pp-4',
        num: '4',
        title: 'Szenario B: Cloud-Dienste und Fernwartung',
        text: 'Werden Cloud-Funktionen oder Fernwartung in Anspruch genommen, bei denen Metadaten oder Diagnoseaufzeichnungen übertragen werden, wird JALUD als Auftragsverarbeiter tätig. Es gilt unser <a href="/data-processing-agreement" data-route="data-processing-agreement" style="color: var(--blue-primary); text-decoration: underline; font-weight: 600;">Auftragsverarbeitungsvertrag (AVV)</a> gemäß Art. 28 DSGVO.'
      },
      {
        id: 'pp-5',
        num: '5',
        title: 'Konfigurierbare Verifizierungs-Audioschnipsel (1,5s) und Metadaten',
        text: 'SED ermöglicht die optionale Erstellung kurzer Audioschnipsel (max. 1,5s) zur Verifizierung von Alarmen. Diese Funktion kann vom Kunden vollständig deaktiviert werden.'
      },
      {
        id: 'pp-6',
        num: '6',
        title: 'Pflichten des Betreibers (Kunden)',
        text: 'Der Betreiber ist für die Rechtsgrundlage der Überwachung, Hinweisschilder im öffentlichen Raum und erforderliche Datenschutz-Folgenabschätzungen (DSFA) verantwortlich.'
      },
      {
        id: 'pp-7',
        num: '7',
        title: 'Unabhängiges Rechtsgutachten',
        text: 'Die datenschutzrechtliche Konformität von SED wurde durch ein unabhängiges Rechtsgutachten der Kanzlei Dr. Karolina Görges bestätigt.'
      },
      {
        id: 'pp-8',
        num: '8',
        title: 'Technische und organisatorische Maßnahmen (TOMs)',
        text: 'JALUD ist nach ISO 9001 und ISO 27001 zertifiziert (siehe <a href="/policy-ims" data-route="policy-ims" style="color: var(--blue-primary); text-decoration: underline; font-weight: 600;">Politik IMS</a>). Alle Übertragungen sind mit TLS 1.3 verschlüsselt.'
      }
    ],
    crossLinksTitle: 'Zugehörige Dokumente',
    crossLinks: [
      { route: 'eula', name: 'Endbenutzer-Lizenzvereinbarung (EULA)', desc: 'Lizenzbestimmungen und Haftungsausschlüsse' },
      { route: 'privacy-policy', name: 'Allgemeine Datenschutzerklärung', desc: 'Datenschutz für Website-Besucher und Geschäftskontakte' },
      { route: 'data-processing-agreement', name: 'Auftragsverarbeitungsvertrag (AVV)', desc: 'Bedingungen gemäß Art. 28 DSGVO' },
      { route: 'policy-ims', name: 'IMS-Richtlinie (ISO 9001 / 27001)', desc: 'Zertifiziertes Informationssicherheits-Managementsystem' },
      { route: 'manuals-and-datasheets', name: "Handbücher & Datenblätter (DSGVO & Zertifikate)", desc: "Technische Dokumentation, juristisches Gutachten und CE/FCC-Zertifikate" }
    ]
  },
  es: {
    eyebrow: 'ARQUITECTURA DE PRIVACIDAD & DATOS TÉCNICOS',
    title: 'Privacidad del Producto y Protección de Datos',
    subtitle: 'Marco técnico y legal de privacidad de Sound Event Detector (SED) – Procesamiento en el edge, cero grabación de conversaciones y cumplimiento del RGPD.',
    version: 'Versión 2026.1 (Vigente a partir del 1 de enero de 2026)',
    gdprStudyBtn: "Dictamen Jurídico RGPD (PDF)",
    gdprStudyBoxTitle: "Dictamen Jurídico Oficial y Certificación RGPD",
    gdprStudyBoxDesc: "El informe jurídico independiente del bufete GÖRGES & PARTNERS y la declaración oficial de conformidad con el RGPD están disponibles para su descarga:",
    gdprStudyDownloadBtn: "Dictamen Jurídico RGPD – GÖRGES & PARTNERS (PDF)",
    gdprStatementDownloadBtn: "Declaración de Conformidad RGPD (PDF)",
    gdprManualsLink: "Ver en Manuales y Fichas Técnicas →",
    tocTitle: 'Índice del documento',
    companyDetails: 'Fabricante: JALUD Embedded s.r.o., Nepomucká 1355/261, 326 00 Plzeň, República Checa, NIF: 03056287',
    introBadge: 'Privacy by Design & by Default',
    introText: 'La tecnología Sound Event Detector (SED) se diseñó desde su origen bajo los principios de privacidad desde el diseño y por defecto. SED detecta patrones acústicos de peligro sin grabar ni escuchar conversaciones humanas.',
    sections: [
      {
        id: 'pp-1',
        num: '1',
        title: 'Arquitectura de privacidad y procesamiento en RAM',
        text: 'El software opera directamente en el dispositivo perimetral (cámaras IP Axis/Hikvision/Hanwha o servidores locales). El audio se analiza en la memoria RAM volátil y se sobrescribe de inmediato. No existe grabación continua en disco.'
      },
      {
        id: 'pp-2',
        num: '2',
        title: 'Exclusión de identificación biométrica',
        text: '<strong>SED no está diseñado para identificar hablantes individuales ni para realizar identificación biométrica de personas.</strong> El sistema no transcribe conversaciones ni procesa perfiles de voz. Solo responde a patrones físicos no verbales (disparos, cristales rotos, gritos, alarmas).'
      },
      {
        id: 'pp-3',
        num: '3',
        title: 'Escenario A: Instalación local (On-Premise / Edge)',
        text: 'En instalaciones locales, los datos nunca salen de la red del cliente. JALUD no tiene acceso a las señales acústicas. El cliente es el Responsable del Tratamiento y JALUD no actúa como Encargado del Tratamiento.'
      },
      {
        id: 'pp-4',
        num: '4',
        title: 'Escenario B: Servicios en la nube y soporte remoto',
        text: 'Cuando se utilizan servicios en la nube o soporte con acceso a metadatos, JALUD actúa como Encargado del Tratamiento según el <a href="/data-processing-agreement" data-route="data-processing-agreement" style="color: var(--blue-primary); text-decoration: underline; font-weight: 600;">Acuerdo de Encargo de Tratamiento (DPA)</a> (Art. 28 RGPD).'
      },
      {
        id: 'pp-5',
        num: '5',
        title: 'Fragmentos de audio de verificación (1,5s) y metadatos',
        text: 'SED permite generar fragmentos cortos de audio (máx. 1,5s) para verificación en el centro de control. El cliente puede desactivar por completo esta función.'
      },
      {
        id: 'pp-6',
        num: '6',
        title: 'Obligaciones del responsable (cliente)',
        text: 'El cliente es responsable de definir la base jurídica del monitoreo, colocar carteles informativos en áreas vigiladas y realizar evaluaciones de impacto (EIPD) si procede.'
      },
      {
        id: 'pp-7',
        num: '7',
        title: 'Dictamen jurídico independiente',
        text: 'La compatibilidad de SED con el RGPD ha sido validada por el dictamen jurídico independiente de la abogada Dra. Karolina Görges.'
      },
      {
        id: 'pp-8',
        num: '8',
        title: 'Medidas de seguridad técnicas y organizativas (TOMs)',
        text: 'JALUD está certificada bajo ISO 9001 e ISO 27001 (consulte la <a href="/policy-ims" data-route="policy-ims" style="color: var(--blue-primary); text-decoration: underline; font-weight: 600;">Política IMS</a>). Todas las conexiones aplican cifrado TLS 1.3.'
      }
    ],
    crossLinksTitle: 'Documentos relacionados',
    crossLinks: [
      { route: 'eula', name: 'Acuerdo de Licencia EULA', desc: 'Términos de software y exclusión de responsabilidad' },
      { route: 'privacy-policy', name: 'Política de Privacidad General', desc: 'Tratamiento de datos para la web y clientes' },
      { route: 'data-processing-agreement', name: 'Acuerdo de Encargo de Tratamiento (DPA)', desc: 'Términos del Art. 28 RGPD para soporte y cloud' },
      { route: 'policy-ims', name: 'Política IMS (ISO 9001 / 27001)', desc: 'Compromiso certificado de seguridad de la información' },
      { route: 'manuals-and-datasheets', name: "Manuales y Fichas Técnicas (RGPD y Certificados)", desc: "Documentación técnica completa, dictamen jurídico RGPD y certificados CE/FCC" }
    ]
  },
  pt: {
    eyebrow: 'ARQUITETURA DE PRIVACIDADE & DADOS TÉCNICOS',
    title: 'Privacidade do Produto e Proteção de Dados',
    subtitle: 'Estrutura técnica e jurídica de privacidade do Sound Event Detector (SED) – Processamento local, zero gravação de voz humana e conformidade com o RGPD.',
    version: 'Versão 2026.1 (Em vigor desde 1 de janeiro de 2026)',
    gdprStudyBtn: "Parecer Jurídico RGPD (PDF)",
    gdprStudyBoxTitle: "Parecer Jurídico Oficial e Certificação RGPD",
    gdprStudyBoxDesc: "O parecer jurídico independente do escritório GÖRGES & PARTNERS e a declaração de conformidade com o RGPD estão disponíveis para download:",
    gdprStudyDownloadBtn: "Parecer Jurídico RGPD – GÖRGES & PARTNERS (PDF)",
    gdprStatementDownloadBtn: "Declaração de Conformidade RGPD (PDF)",
    gdprManualsLink: "Ver na secção Manuais e Fichas Técnicas →",
    tocTitle: 'Índice do documento',
    companyDetails: 'Fabricante: JALUD Embedded s.r.o., Nepomucká 1355/261, 326 00 Plzeň, República Checa, NIF: 03056287',
    introBadge: 'Privacy by Design & by Default',
    introText: 'A tecnologia Sound Event Detector (SED) foi concebida de raiz com base nos princípios de Privacidade desde a Conceção e por Defeito. O SED deteta padrões físicos de perigo sem gravar nem monitorizar conversas humanas.',
    sections: [
      {
        id: 'pp-1',
        num: '1',
        title: 'Arquitetura de Privacidade e Processamento em RAM',
        text: 'O software opera diretamente no dispositivo perimetral (câmaras de vídeo Axis/Hikvision/Hanwha ou servidores locais). O áudio é analisado na memória RAM volátil e imediatamente eliminado. Não há gravação contínua em disco.'
      },
      {
        id: 'pp-2',
        num: '2',
        title: 'Exclusão de Identificação Biométrica',
        text: '<strong>O SED não foi concebido para identificar oradores individuais nem efetuar identificação biométrica de pessoas.</strong> O sistema não efetua transcrição de voz nem perfis de voz, respondendo unicamente a frequências não verbais (tiros, vidros partidos, gritos, sirenes).'
      },
      {
        id: 'pp-3',
        num: '3',
        title: 'Cenário A: Instalação Local (On-Premise / Edge)',
        text: 'Em implementações locais, nenhum dado de áudio ou metadado sai da rede do cliente. A JALUD não tem acesso aos dados. O cliente é o Responsável pelo Tratamento e a JALUD não é Subcontratante.'
      },
      {
        id: 'pp-4',
        num: '4',
        title: 'Cenário B: Serviços Cloud e Assistência Remota',
        text: 'Quando o cliente utiliza serviços cloud ou assistência remota com acesso a diagnósticos, a JALUD atua como Subcontratante nos termos do <a href="/data-processing-agreement" data-route="data-processing-agreement" style="color: var(--blue-primary); text-decoration: underline; font-weight: 600;">Acordo de Processamento de Dados (DPA)</a> (Art. 28 do RGPD).'
      },
      {
        id: 'pp-5',
        num: '5',
        title: 'Excerto de Áudio de Verificação (1,5s) e Metadados',
        text: 'O SED permite a geração opcional de pequenos excertos de áudio (máx. 1,5s) para confirmação de alarmes. Esta função pode ser desativada pelo cliente a qualquer momento.'
      },
      {
        id: 'pp-6',
        num: '6',
        title: 'Deveres do Cliente Responsável',
        text: 'O cliente é responsável pela base de licitude, colocação de avisos de vigilância acústica e realização de Avaliações de Impacto (AIPD) quando legalmente exigido.'
      },
      {
        id: 'pp-7',
        num: '7',
        title: 'Parecer Jurídico Independente',
        text: 'A conformidade do SED com a regulamentação europeia de proteção de dados foi validada por parecer da advogada Dra. Karolina Görges.'
      },
      {
        id: 'pp-8',
        num: '8',
        title: 'Medidas Técnicas e Organizativas (TOMs)',
        text: 'A JALUD possui certificação ISO 9001 e ISO 27001 (consulte a <a href="/policy-ims" data-route="policy-ims" style="color: var(--blue-primary); text-decoration: underline; font-weight: 600;">Política IMS</a>). Todas as comunicações utilizam encriptação TLS 1.3.'
      }
    ],
    crossLinksTitle: 'Documentos associados',
    crossLinks: [
      { route: 'eula', name: 'Contrato de Licença EULA', desc: 'Termos de licenciamento do software e limitações' },
      { route: 'privacy-policy', name: 'Política de Privacidade Geral', desc: 'Tratamento de dados no website e contactos comerciais' },
      { route: 'data-processing-agreement', name: 'Acordo de Processamento de Dados (DPA)', desc: 'Termos do Art. 28 do RGPD para suporte cloud' },
      { route: 'policy-ims', name: 'Política IMS (ISO 9001 / 27001)', desc: 'Certificação de segurança da informação e qualidade' },
      { route: 'manuals-and-datasheets', name: "Manuais e Fichas Técnicas (RGPD e Certificados)", desc: "Documentação técnica, parecer jurídico RGPD e certificados CE/FCC" }
    ]
  },
  ar: {
    eyebrow: 'بنية الخصوصية والبيانات التقنية',
    title: 'خصوصية المنتج وحماية البيانات',
    subtitle: 'الإطار التقني والقانوني لحماية الخصوصية في نظام Sound Event Detector (SED) – المعالجة الطرفية (Edge)، صفر تسجيل للمحادثات، والامتثال للائحة GDPR.',
    version: 'الإصدار 2026.1 (يسري اعتباراً من 1 يناير 2026)',
    gdprStudyBtn: "الدراسة القانونية لـ GDPR (PDF)",
    gdprStudyBoxTitle: "التقييم القانوني الرسمي والامتثال لـ GDPR",
    gdprStudyBoxDesc: "التقييم القانوني المستقل من مكتب GÖRGES & PARTNERS وبيان الامتثال لـ GDPR متاحان للتحميل المباشر:",
    gdprStudyDownloadBtn: "الرأي القانوني لـ GDPR – مكتب GÖRGES & PARTNERS (PDF)",
    gdprStatementDownloadBtn: "بيان الامتثال لمعايير GDPR (PDF)",
    gdprManualsLink: "عرض في قسم الأدلة وأوراق البيانات ←",
    tocTitle: 'فهرس بنود الوثيقة',
    companyDetails: 'المصنّع والمطور: JALUD Embedded s.r.o.، العنوان: Nepomucká 1355/261, 326 00 Plzeň، الجمهورية التشيكية، السجل: 03056287',
    introBadge: 'الخصوصية بالتصميم والوضع الافتراضي',
    introText: 'تم تطوير تقنية كاشف الأحداث الصوتية (SED) وفقاً لمبادئ الخصوصية بالتصميم والخصوصية بالوضع الافتراضي. يعتمد النظام على الكشف الصوتي التلقائي عن البصمات الترددية للمخاطر دون تسجيل أو التنصت على محادثات البشر.',
    sections: [
      {
        id: 'pp-1',
        num: '١',
        title: 'بنية الخصوصية بالتصميم والمعالجة في الذاكرة المؤقتة (RAM)',
        text: 'تعمل برمجيات SED مباشرة على الأجهزة الطرفية (كاميرات المراقبة أو الخوادم المحلية). تتم معالجة الإشارة الصوتية لحظياً داخل ذاكرة RAM المؤقتة، ويتم مسح الصوت واستبداله فوراً دون حفظ دائم على الأقراص أو إرسال خارجي.'
      },
      {
        id: 'pp-2',
        num: '٢',
        title: 'استبعاد التحديد البيومتري وتحليل الكلام',
        text: '<strong>لم يُصمم نظام SED للتعرف على هوية المتحدثين أو إجراء التحديد البيومتري للأشخاص.</strong> لا يقوم النظام بتحويل الكلام إلى نصوص ولا بتحليل دلالات الحوار أو السمات الحيوية لنبرات الصوت، بل يستجيب حصراً للظواهر الصوتية غير الكلامية كالرصاص وتكسر الزجاج والصراخ والصفارات.'
      },
      {
        id: 'pp-3',
        num: '٣',
        title: 'السيناريو (أ): التثبيت المحلي على خوادم وكاميرات العميل (On-Premise / Edge)',
        text: 'في التركيبات المحلية، تجري المعالجة بالكامل داخل شبكة العميل الخاصة ولا تُرسل أي بيانات إلى JALUD. في هذا السيناريو، يكون <strong>العميل هو المتحكم الحصري في البيانات</strong>، ولا تتدخل JALUD ولا تعتبر معالجاً بموجب المادة 28 من GDPR.'
      },
      {
        id: 'pp-4',
        num: '٤',
        title: 'السيناريو (ب): الخدمات السحابية والدعم الفني عن بعد',
        text: 'في حال استخدام الخدمات السحابية أو طلب الدعم الفني عن بعد، تعمل JALUD كمعالج بيانات نيابة عن العميل وتخضع لوثيقة <a href="/data-processing-agreement" data-route="data-processing-agreement" style="color: var(--blue-primary); text-decoration: underline; font-weight: 600;">اتفاقية معالجة البيانات (DPA)</a> وفقاً للمادة 28 من GDPR.'
      },
      {
        id: 'pp-5',
        num: '٥',
        title: 'مقاطع التحقق الصوتية الاختيارية (1.5 ثانية) والبيانات الوصفية',
        text: 'يتيح النظام خياراً برمجياً لإنشاء مقطع صوتي مقتضب (بحد أقصى 1.5 ثانية) للتحقق البشري من صحة الإنذar في غرف التحكم. يملك العميل التحكم الكامل في تفعيل هذه الميزة أو تعطيلها تماماً.'
      },
      {
        id: 'pp-6',
        num: '٦',
        title: 'التزامات ومسؤوليات المشغّل (العميل)',
        text: 'يتحمل العميل كمتحكم في الموقع مسؤولية: توفير الأساس القانوني للمراقبة الصوتية، ووضع لوحات التنبيه في الأماكن العامة، وإجراء تقييم أثر حماية البيانات (DPIA) متى لزم الأمر.'
      },
      {
        id: 'pp-7',
        num: '٧',
        title: 'التقييم القانوني المستقل',
        text: 'تم التحقق من امتثال نظام SED لقوانين الخصوصية الأوروبية بموجب تقرير قانوني مستقل أعده مكتب المحاماة المتخصص (الدكتورة كارولينا غورغيس).'
      },
      {
        id: 'pp-8',
        num: '٨',
        title: 'التدابير الأمنية والفنية (TOMs)',
        text: 'تلتزم شركة JALUD بمعايير إدارة الجودة وأمن المعلومات ISO 9001 و ISO 27001 (راجع <a href="/policy-ims" data-route="policy-ims" style="color: var(--blue-primary); text-decoration: underline; font-weight: 600;">سياسة IMS</a>)، وتُشفر جميع الاتصالات ببروتوكول TLS 1.3.'
      }
    ],
    crossLinksTitle: 'الوثائق ذات الصلة',
    crossLinks: [
      { route: 'eula', name: 'اتفاقية ترخيص المستخدم النهائي EULA', desc: 'شروط ترخيص البرمجيات والتقنية المساعدة وحدود المسؤولية' },
      { route: 'privacy-policy', name: 'سياسة الخصوصية العامة للموقع', desc: 'معالجة بيانات عملاء وزوار الموقع الإلكتروني' },
      { route: 'data-processing-agreement', name: 'اتفاقية معالجة البيانات DPA', desc: 'شروط معالجة البيانات في البيئات السحابية والدعم الفني' },
      { route: 'policy-ims', name: 'سياسة IMS (ISO 9001 / 27001)', desc: 'الالتزامات المعتمدة لأمن المعلومات ونظام إدارة الجودة' },
      { route: 'manuals-and-datasheets', name: "الأدلة وأوراق البيانات (الامتثال وGDPR)", desc: "الوثائق التقنية الكاملة والآراء القانونية المستقلة وشهادات المطابقة" }
    ]
  }
,
  it: {
    "eyebrow": "SICUREZZA DEL PRODOTTO & PRIVACY BY DESIGN",
    "title": "Informativa sulla Privacy del Prodotto e Protezione dei Dati",
    "subtitle": "Architettura tecnica di protezione dei dati, elaborazione transitoria in RAM, assenza di dati biometrici e conformità GDPR per i sistemi Sound Event Detector.",
    "version": "Versione 2026.1 (In vigore dal 1° gennaio 2026)",
    "tocTitle": "Indice dell'Informativa di Prodotto",
    "companyDetails": "JALUD Embedded s.r.o., Nepomucká 1355/261, 326 00 Plzeň, Repubblica Ceca, IČO: 03056287",
    "preamble": "Questa informativa illustra l'architettura tecnica e i principi di salvaguardia della riservatezza dei prodotti software e hardware Sound Event Detector (SED). La tecnologia SED è stata concepita secondo i principi di Privacy by Design e Privacy by Default, assicurando una sicurezza acustica ad altissima efficienza nel rispetto assoluto dei diritti fondamentali delle persone.",
    "sections": [
      {
        "id": "prod-1",
        "num": "1",
        "title": "Filosofia Privacy by Design e Rilevamento Acustico Non Invasivo",
        "text": "Sound Event Detector è stato sviluppato fin dalle prime fasi di progettazione per monitorare esclusivamente eventi acustici di pericolo (come colpi d'arma da fuoco, urla di panico, rottura di cristalli o sirene), escludendo deliberatamente qualsiasi ascolto continuativo o sorveglianza delle conversazioni umane ordinarie."
      },
      {
        "id": "prod-2",
        "num": "2",
        "title": "Elaborazione Transitoria Esclusiva in RAM (Nessuna Registrazione Continua)",
        "text": "L'analisi audio viene svolta in tempo reale all'interno della memoria volatile ad accesso casuale (RAM) della telecamera (edge) o del server. I blocchi audio transitori vengono trasformati in spettrogrammi, analizzati dalla rete neurale e sovrascritti immediatamente. Nessun flusso audio grezzo viene mai memorizzato in modo permanente o scritto su disco rigido o memoria flash durante il normale funzionamento."
      },
      {
        "id": "prod-3",
        "num": "3",
        "title": "Configurazione degli Snippet Audio di Verifica dell'Allarme (max 1,5s)",
        "text": "Il sistema SED consente la configurazione opzionale per la generazione di brevi snippet audio di verifica (max 1,5s). Tale funzionalità, facoltativa e controllata unicamente dall'amministratore di sistema dell'Acquirente, è destinata esclusivamente a permettere all'operatore di sicurezza di verificare la natura dell'allarme generato prima dell'eventuale invio delle forze di polizia."
      },
      {
        "id": "prod-4",
        "num": "4",
        "title": "Assenza di Identificazione Biometrica e Riconoscimento Vocale",
        "text": "I modelli neurali di SED non contengono algoritmi di biometria vocale, non effettuano il tracciamento vocale delle persone (voiceprinting) né riconoscono l'identità dei parlanti. Il sistema è intrinsecamente incapace di identificare le singole persone attraverso la loro voce."
      },
      {
        "id": "prod-5",
        "num": "5",
        "title": "Riconoscimento Modelli Acustici vs Comprensione del Linguaggio Naturale",
        "text": "Il software non include alcuna tecnologia di Speech-to-Text (trascrizione vocale) o Natural Language Processing (NLP). SED riconosce esclusivamente le caratteristiche fisiche, di frequenza, inviluppo e dinamica dei suoni non verbali, rimanendo totalmente agnostico rispetto al contenuto, al significato delle parole o alla lingua parlata."
      },
      {
        "id": "prod-6",
        "num": "6",
        "title": "Conformità al Regolamento Generale sulla Protezione dei Dati (GDPR) e DPIA",
        "text": "Grazie all'elaborazione on-edge e all'assenza di dati vocali biometrici, la tecnologia SED riduce al minimo l'impatto sulla privacy negli spazi pubblici. JALUD fornisce ai propri clienti documentazione tecnica e schede descrittive per facilitare la redazione della Valutazione d'Impatto sulla Protezione dei Dati (DPIA) ai sensi dell'Art. 35 GDPR."
      },
      {
        "id": "prod-7",
        "num": "7",
        "title": "Ruoli di Trattamento: Titolare (Cliente) vs Fornitore Tecnologico (JALUD)",
        "text": "Il Cliente che acquista e gestisce il sistema SED agisce in qualità di autonomo Titolare del Trattamento dei dati del proprio impianto di videosorveglianza e sicurezza. JALUD agisce come mero fornitore della tecnologia software/hardware. In caso di fornitura di servizi cloud di allerta o manutenzione remota, JALUD opera come Responsabile del Trattamento disciplinato da apposito Accordo DPA."
      },
      {
        "id": "prod-8",
        "num": "8",
        "title": "Misure Tecniche e Organizzative di Sicurezza e Crittografia",
        "text": "Tutti i metadati di allarme inviati ai sistemi VMS o alle centrali operative sono protetti tramite connessioni crittografate TLS 1.3 / HTTPS. L'accesso alle configurazioni è protetto da autenticazione a ruoli e password robuste, e il firmware è sottoposto a rigorosi test periodici di sicurezza e conformità ISO 27001."
      }
    ],
    "crossLinksTitle": "Documenti Legali Correlati",
    "crossLinks": [
      {
        "route": "eula",
        "name": "Licenza Utente Finale (EULA)",
        "desc": "Termini legali di utilizzo del software SED e limitazioni di garanzia"
      },
      {
        "route": "data-processing-agreement",
        "name": "Accordo Trattamento Dati (DPA)",
        "desc": "Clausole contrattuali standard ex Art. 28 GDPR per l'elaborazione dei dati"
      },
      {
        "route": "code-of-ethics",
        "name": "Codice Etico e Principi dell'IA",
        "desc": "Principi etici JALUD per l'uso responsabile dell'intelligenza artificiale"
      },
      {
        "route": "privacy-policy",
        "name": "Informativa sulla Privacy del Sito",
        "desc": "Trattamento dei dati dei visitatori e partner sul sito web jalud.eu"
      }
    ]
  }
};


export const dpaData = {
  cs: {
    eyebrow: 'GDPR ČLÁNEK 28 & OCHRANA OSOBNÍCH ÚDAJŮ',
    title: 'Smlouva o zpracování osobních údajů (DPA)',
    subtitle: 'Standardní smluvní ujednání o zpracování osobních údajů pro cloudové služby, centrální správu SEDServer a technickou podporu JALUD Embedded s.r.o.',
    version: 'Verze 2026.1 (Účinnost od 1. ledna 2026)',
    gdprStudyBtn: "Studio Legale GDPR (PDF)",
    gdprStudyBoxTitle: "Parere Legale Ufficiale e Certificazione GDPR",
    gdprStudyBoxDesc: "Il parere legale indipendente dello studio GÖRGES & PARTNERS e la dichiarazione ufficiale di conformità al GDPR sono disponibili per il download:",
    gdprStudyDownloadBtn: "Parere Legale GDPR – GÖRGES & PARTNERS (PDF)",
    gdprStatementDownloadBtn: "Dichiarazione di Conformità GDPR (PDF)",
    gdprManualsLink: "Visualizza in Manuali e Schede Tecniche →",
    tocTitle: 'Obsah smlouvy DPA',
    companyDetails: 'Zpracovatel: JALUD Embedded s.r.o., Nepomucká 1355/261, 326 00 Plzeň, Česká republika, IČO: 03056287',
    preamble: 'Tato Smlouva o zpracování osobních údajů („DPA“) tvoří nedílnou součást smluvního vztahu mezi zákazníkem („Správce“) a společností JALUD Embedded s.r.o. („Zpracovatel“) v případech, kdy Zpracovatel v rámci poskytování cloudových služeb, hostovaného SEDServeru nebo vzdálené podpory zpracovává osobní údaje jménem Správce ve smyslu čl. 28 Nařízení Evropského parlamentu a Rady (EU) 2016/679 (GDPR).',
    sections: [
      {
        id: 'dpa-1',
        num: '1',
        title: 'Předmět, účel a rozsah zpracování',
        text: 'Předmětem této DPA je stanovení práv a povinností smluvních stran při zpracování osobních údajů Zpracovatelem pro Správce. Účelem zpracování je výhradně technické zajištění provozu cloudových služeb Sound Event Detector (SED), přenos a vizualizace bezpečnostních akustických poplachů, doručování notifikací, zálohování konfigurací a poskytování technické diagnostiky a podpory.'
      },
      {
        id: 'dpa-2',
        num: '2',
        title: 'Povaha dat a kategorie subjektů údajů',
        text: 'Zpracovávané údaje mohou zahrnovat: identifikátory zařízení (MAC adresa, IP adresa, název senzoru), časová razítka, akustická metadata (typ události, hladina hluku v dB, míra spolehlivosti detekce), lokalizační souřadnice senzoru a volitelně krátké verifikační audio ústřižky (max 1,5s). Subjekty údajů jsou fyzické osoby pohybující se v prostorách monitorovaných senzory Správce a oprávnění uživatelé systému na straně Správce.'
      },
      {
        id: 'dpa-3',
        num: '3',
        title: 'Pokyny Správce a mlčenlivost',
        text: 'Zpracovatel zpracovává osobní údaje výhradně na základě doložených pokynů Správce, včetně otázek předání údajů do třetí země. Zpracovatel se zavazuje zajistit, aby se osoby oprávněné zpracovávat osobní údaje (zaměstnanci a spolupracovníci) zavázaly k mlčenlivosti nebo aby se na ně vztahovala zákonná povinnost mlčenlivosti.'
      },
      {
        id: 'dpa-4',
        num: '4',
        title: 'Technická a organizační bezpečnostní opatření (TOMs)',
        text: 'Zpracovatel s přihlédnutím ke stavu techniky, nákladům na provedení a povaze zpracování zavedl a udržuje vhodná technická a organizační opatření k zajištění úrovně bezpečnosti odpovídající danému riziku dle čl. 32 GDPR a norem ISO 27001. Tato opatření zahrnují: šifrování dat při přenosu (TLS 1.3) a v klidu (AES-256), řízení fyzického a logického přístupu, dvoufaktorovou autentizaci (2FA), oddělení dat zákazníků (multi-tenancy izolace) a pravidelné testování zranitelností.'
      },
      {
        id: 'dpa-5',
        num: '5',
        title: 'Zapojení dalších zpracovatelů (Sub-procesorů)',
        text: 'Správce uděluje Zpracovateli obecné písemné povolení k zapojení dalších zpracovatelů zajišťujících provoz hostingové infrastruktury, cloudových serverů a datových center výhradně na území Evropské unie / Evropského hospodářského prostoru. Zpracovatel smluvně zaváže každého sub-procesora ke stejným povinnostem na ochranu údajů, jaké jsou uvedeny v této smlouvě.'
      },
      {
        id: 'dpa-6',
        num: '6',
        title: 'Součinnost při výkonu práv subjektů údajů',
        text: 'Zpracovatel je, pokud je to možné, nápomocen Správci prostřednictvím vhodných technických a organizačních opatření při plnění Správcovy povinnosti reagovat na žádosti o výkon práv subjektů údajů stanovených v kapitole III GDPR (právo na přístup, výmaz, omezení zpracování, námitka).'
      },
      {
        id: 'dpa-7',
        num: '7',
        title: 'Ohlášení porušení zabezpečení osobních údajů',
        text: 'V případě zjištění jakéhokoli bezpečnostního incidentu vedoucího k náhodnému nebo protiprávnímu zničení, ztrátě, změně nebo neoprávněnému poskytnutí osobních údajů ohlásí Zpracovatel tuto skutečnost Správci bez zbytečného odkladu, nejpozději do 48 hodin od okamžiku, kdy se o porušení dozvěděl.'
      },
      {
        id: 'dpa-8',
        num: '8',
        title: 'Součinnost při posouzení vlivu na ochranu dat (DPIA)',
        text: 'Zpracovatel poskytne Správci přiměřenou součinnost a technické podklady při zajišťování souladu s povinnostmi podle článků 32 až 36 GDPR (posouzení vlivu na ochranu osobních údajů DPIA a předchozí konzultace s dozorovým úřadem), s přihlédnutím k povaze zpracování a informacím, jež má Zpracovatel k dispozici.'
      },
      {
        id: 'dpa-9',
        num: '9',
        title: 'Výmaz nebo vrácení osobních údajů po ukončení služeb',
        text: 'Po ukončení poskytování služeb souvisejících se zpracováním je Zpracovatel povinen podle volby Správce všechny osobní údaje buď vymazat, nebo vrátit Správci a vymazat existující kopie, ledaže právo Evropské unie nebo členského státu vyžaduje uložení daných osobních údajů.'
      },
      {
        id: 'dpa-10',
        num: '10',
        title: 'Audity, kontroly a rozhodné právo',
        text: 'Zpracovatel poskytne Správci veškeré informace potřebné k prokázání splnění povinností stanovených v čl. 28 GDPR a umožní audity, včetně inspekcí, prováděné Správcem nebo jiným auditorem pověřeným Správcem za předem dohodnutých a přiměřených podmínek. Tato smlouva se řídí právem České republiky a nařízením GDPR.'
      }
    ],
    crossLinksTitle: 'Související právní dokumenty',
    crossLinks: [
      { route: 'product-privacy', name: 'Produktové soukromí a ochrana dat', desc: 'Technická architektura ochrany soukromí u SED (Edge vs Cloud)' },
      { route: 'privacy-policy', name: 'Zásady ochrany osobních údajů', desc: 'Zpracování údajů, kde JALUD vystupuje jako Správce (Web a CRM)' },
      { route: 'eula', name: 'Licenční smlouva EULA', desc: 'Podmínky užívání softwaru SED a licenční ujednání' },
      { route: 'policy-ims', name: 'Politika IMS (ISO 27001)', desc: 'Certifikovaný systém bezpečnosti informací' },
      { route: 'manuals-and-datasheets', name: "Manuali e Schede Tecniche (GDPR e Certificazioni)", desc: "Documentazione tecnica completa, parere legale GDPR e certificazioni CE/FCC" }
    ]
  },
  en: {
    eyebrow: 'GDPR ARTICLE 28 & DATA PROTECTION',
    title: 'Data Processing Agreement (DPA)',
    subtitle: 'Standard Data Processing Terms pursuant to Article 28 GDPR for cloud-connected deployments, hosted SEDServer, and technical maintenance services by JALUD Embedded s.r.o.',
    version: 'Version 2026.1 (Effective January 1, 2026)',
    tocTitle: 'Table of Contents',
    companyDetails: 'Data Processor: JALUD Embedded s.r.o., Nepomucká 1355/261, 326 00 Plzeň, Czech Republic, Reg. ID: 03056287',
    preamble: 'This Data Processing Agreement ("DPA") governs the processing of personal data by JALUD Embedded s.r.o. ("Processor") on behalf of the customer ("Controller") whenever the Processor processes personal data in the course of providing cloud-hosted SED services, centralized SEDServer infrastructure, or remote technical diagnostics under Regulation (EU) 2016/679 ("GDPR").',
    sections: [
      {
        id: 'dpa-1',
        num: '1',
        title: 'Subject Matter, Nature, and Purpose of Processing',
        text: 'The subject matter of this DPA is the execution of data processing operations by the Processor on behalf of the Controller. The nature and purpose of processing are strictly confined to the provision of Sound Event Detector (SED) cloud services, acoustic alarm transmission, alert delivery, configuration backups, and remote technical diagnostics requested by Controller.'
      },
      {
        id: 'dpa-2',
        num: '2',
        title: 'Types of Personal Data and Categories of Data Subjects',
        text: 'The personal data processed may comprise: edge hardware identifiers (MAC addresses, IP addresses, sensor names), system timestamps, acoustic event metadata (sound class, decibel level, neural confidence score), sensor spatial coordinates, and optional short verification audio clips (max 1.5s). Data subjects are individuals present in areas monitored by Controller’s acoustic sensors and authorized personnel operating the Controller’s systems.'
      },
      {
        id: 'dpa-3',
        num: '3',
        title: 'Documented Instructions and Confidentiality',
        text: 'The Processor shall process personal data solely on documented instructions from the Controller, including with regard to transfers of personal data to a third country. The Processor ensures that persons authorized to process personal data have committed themselves to confidentiality or are under an appropriate statutory obligation of confidentiality.'
      },
      {
        id: 'dpa-4',
        num: '4',
        title: 'Technical and Organizational Security Measures (TOMs)',
        text: 'Taking into account the state of the art, the costs of implementation, and the nature of processing, the Processor has implemented and maintains comprehensive technical and organizational measures pursuant to GDPR Article 32 and ISO 27001 standards. These measures include: end-to-end transport layer encryption (TLS 1.3), storage encryption (AES-256), multi-tenant isolation, strict role-based access control, multi-factor authentication (2FA), and continuous vulnerability monitoring.'
      },
      {
        id: 'dpa-5',
        num: '5',
        title: 'Sub-processors and Cloud Infrastructure',
        text: 'Controller grants Processor general written authorization to engage sub-processors for hosting infrastructure and cloud operations located strictly within the European Union / European Economic Area (EU/EEA). Processor shall impose upon each sub-processor data protection obligations substantially equivalent to those set out in this DPA.'
      },
      {
        id: 'dpa-6',
        num: '6',
        title: 'Assistance with Data Subject Rights',
        text: 'Taking into account the nature of processing, Processor shall assist Controller by appropriate technical and organizational measures, insofar as possible, in fulfilling Controller’s obligation to respond to requests exercising data subject rights under GDPR Chapter III (access, rectification, erasure, restriction, and portability).'
      },
      {
        id: 'dpa-7',
        num: '7',
        title: 'Personal Data Breach Notification',
        text: 'Processor shall notify Controller without undue delay, and in any event within forty-eight (48) hours, upon becoming aware of any confirmed personal data breach affecting Controller’s data.'
      },
      {
        id: 'dpa-8',
        num: '8',
        title: 'Data Protection Impact Assessments (DPIA)',
        text: 'Processor shall provide reasonable assistance to Controller in ensuring compliance with the obligations pursuant to GDPR Articles 32 to 36, taking into account the nature of processing and the information available to Processor.'
      },
      {
        id: 'dpa-9',
        num: '9',
        title: 'Deletion or Return of Personal Data',
        text: 'Upon termination of the service agreement, Processor shall, at the choice of Controller, delete or return all personal data to Controller and delete existing copies unless European Union or Member State law requires retention.'
      },
      {
        id: 'dpa-10',
        num: '10',
        title: 'Audits, Inspections, and Governing Law',
        text: 'Processor shall make available to Controller all information necessary to demonstrate compliance with GDPR Article 28 and allow for and contribute to reasonable audits conducted by Controller or an independent auditor mandated by Controller upon mutually agreed terms. This DPA is governed by the laws of the Czech Republic and the GDPR.'
      }
    ],
    crossLinksTitle: 'Related Legal Framework',
    crossLinks: [
      { route: 'product-privacy', name: 'Product Privacy & Data Protection', desc: 'Edge vs Cloud architecture and Privacy by Design implementation' },
      { route: 'privacy-policy', name: 'General Privacy Policy', desc: 'Controller-level privacy policy for corporate website and contacts' },
      { route: 'eula', name: 'End User License Agreement (EULA)', desc: 'Software licensing terms and operational responsibilities' },
      { route: 'policy-ims', name: 'Policy IMS (ISO 27001)', desc: 'Information security management framework' }
    ]
  },
  de: {
    eyebrow: 'DSGVO ARTIKEL 28 & AUFTRAGSVERARBEITUNG',
    title: 'Auftragsverarbeitungsvertrag (AVV)',
    subtitle: 'Standardvereinbarung zur Auftragsverarbeitung gemäß Art. 28 DSGVO für Cloud-Dienste, gehostete SEDServer-Systeme und Fernwartung der JALUD Embedded s.r.o.',
    version: 'Version 2026.1 (Gültig ab 1. Januar 2026)',
    tocTitle: 'Inhaltsverzeichnis',
    companyDetails: 'Auftragsverarbeiter: JALUD Embedded s.r.o., Nepomucká 1355/261, 326 00 Plzeň, Tschechische Republik, Id-Nr.: 03056287',
    preamble: 'Diese Vereinbarung zur Auftragsverarbeitung („AVV“) regelt die Verarbeitung personenbezogener Daten durch die JALUD Embedded s.r.o. („Auftragsverarbeiter“) im Auftrag des Kunden („Verantwortlicher“) gemäß Art. 28 der Datenschutz-Grundverordnung (DSGVO).',
    sections: [
      {
        id: 'dpa-1',
        num: '1',
        title: 'Gegenstand und Zweck der Verarbeitung',
        text: 'Gegenstand ist die Erbringung von Cloud- und Supportleistungen für den Sound Event Detector (SED), die Übertragung von Alarmmeldungen und die technische Systemüberwachung im Auftrag des Kunden.'
      },
      {
        id: 'dpa-2',
        num: '2',
        title: 'Art der Daten und Kategorien betroffener Personen',
        text: 'Verarbeitet werden technische Gerätekennungen, Zeitstempel, akustische Metadaten (Schallpegel, Ereignistyp) sowie optional konfigurierbare kurze Verifizierungs-Audioschnipsel (max. 1,5s).'
      },
      {
        id: 'dpa-3',
        num: '3',
        title: 'Weisungsgebundenheit und Vertraulichkeit',
        text: 'Die Verarbeitung erfolgt ausschließlich auf dokumentierte Weisung des Verantwortlichen. Alle mit der Verarbeitung betrauten Mitarbeiter sind zur Vertraulichkeit verpflichtet.'
      },
      {
        id: 'dpa-4',
        num: '4',
        title: 'Technische und organisatorische Maßnahmen (TOMs)',
        text: 'Der Auftragsverarbeiter gewährleistet Sicherheitsmaßnahmen gemäß Art. 32 DSGVO und ISO 27001, einschließlich Transportverschlüsselung (TLS 1.3), Speicherverschlüsselung (AES-256) und Mandantentrennung.'
      },
      {
        id: 'dpa-5',
        num: '5',
        title: 'Unterauftragsverarbeiter',
        text: 'Der Verantwortliche genehmigt den Einsatz von Unterauftragsverarbeitern für Cloud-Infrastruktur innerhalb der EU/EWR unter Einhaltung gleichwertiger Schutzstandards.'
      },
      {
        id: 'dpa-6',
        num: '6',
        title: 'Unterstützung bei Betroffenenrechten',
        text: 'Der Auftragsverarbeiter unterstützt den Verantwortlichen bei der Erfüllung von Anfragen betroffener Personen gemäß Kapitel III der DSGVO.'
      },
      {
        id: 'dpa-7',
        num: '7',
        title: 'Meldung von Datenschutzverletzungen',
        text: 'Datenschutzverletzungen werden dem Verantwortlichen unverzüglich, spätestens innerhalb von 48 Stunden nach Bekanntwerden, gemeldet.'
      },
      {
        id: 'dpa-8',
        num: '8',
        title: 'Datenschutz-Folgenabschätzung (DSFA)',
        text: 'Der Auftragsverarbeiter unterstützt den Verantwortlichen bei erforderlichen Datenschutz-Folgenabschätzungen nach Art. 35 DSGVO.'
      },
      {
        id: 'dpa-9',
        num: '9',
        title: 'Löschung und Rückgabe von Daten',
        text: 'Nach Beendigung der Leistungen werden alle Daten nach Wahl des Verantwortlichen gelöscht oder zurückgegeben, sofern keine gesetzlichen Aufbewahrungspflichten bestehen.'
      },
      {
        id: 'dpa-10',
        num: '10',
        title: 'Audits und anwendbares Recht',
        text: 'Der Verantwortliche hat das Recht, nach Vorankündigung Prüfungen zur Einhaltung dieser Vereinbarung durchzuführen. Es gilt das Recht der Tschechischen Republik.'
      }
    ],
    crossLinksTitle: 'Zugehörige Dokumente',
    crossLinks: [
      { route: 'product-privacy', name: 'Produktdatenschutz & Datensicherheit', desc: 'Details zu lokaler vs. Cloud-basierter Verarbeitung' },
      { route: 'privacy-policy', name: 'Allgemeine Datenschutzerklärung', desc: 'Verarbeitung von Webseiten- und Kundendaten' },
      { route: 'eula', name: 'Endbenutzer-Lizenzvereinbarung (EULA)', desc: 'Software-Lizenzbedingungen' },
      { route: 'policy-ims', name: 'IMS-Richtlinie (ISO 27001)', desc: 'Zertifiziertes Sicherheitsmanagementsystem' }
    ]
  },
  es: {
    eyebrow: 'RGPD ARTÍCULO 28 & PROTECCIÓN DE DATOS',
    title: 'Acuerdo de Encargo de Tratamiento (DPA)',
    subtitle: 'Términos contractuales estándar según el Art. 28 del RGPD para servicios cloud y soporte técnico de JALUD Embedded s.r.o.',
    version: 'Versión 2026.1 (Vigente a partir del 1 de enero de 2026)',
    tocTitle: 'Índice del DPA',
    companyDetails: 'Encargado del Tratamiento: JALUD Embedded s.r.o., Nepomucká 1355/261, 326 00 Plzeň, República Checa, NIF: 03056287',
    preamble: 'Este Acuerdo de Encargo de Tratamiento ("DPA") regula el tratamiento de datos personales realizado por JALUD Embedded s.r.o. ("Encargado") por cuenta del cliente ("Responsable") en el marco de servicios en la nube o mantenimiento conforme al RGPD.',
    sections: [
      {
        id: 'dpa-1',
        num: '1',
        title: 'Objeto y finalidad del tratamiento',
        text: 'El tratamiento tiene como única finalidad la prestación técnica de servicios cloud para Sound Event Detector (SED), alertas acústicas y diagnóstico remoto.'
      },
      {
        id: 'dpa-2',
        num: '2',
        title: 'Tipos de datos y categorías de interesados',
        text: 'Datos técnicos del dispositivo, marcas de tiempo, metadatos de eventos acústicos y fragmentos de audio opcionales de verificación (máx. 1,5s).'
      },
      {
        id: 'dpa-3',
        num: '3',
        title: 'Instrucciones del responsable y confidencialidad',
        text: 'El Encargado tratará los datos únicamente siguiendo instrucciones documentadas del Responsable. El personal autorizado está sujeto a secreto profesional.'
      },
      {
        id: 'dpa-4',
        num: '4',
        title: 'Medidas técnicas y organizativas (TOMs)',
        text: 'Se aplican medidas conforme al Art. 32 del RGPD e ISO 27001: cifrado TLS 1.3 en tránsito y AES-256 en reposo, y aislamiento entre clientes.'
      },
      {
        id: 'dpa-5',
        num: '5',
        title: 'Subencargados del tratamiento',
        text: 'Se autoriza la contratación de subencargados para infraestructura en la UE/EEE bajo obligaciones contractuales equivalentes.'
      },
      {
        id: 'dpa-6',
        num: '6',
        title: 'Ejercicio de derechos de los interesados',
        text: 'El Encargado asistirá al Responsable en la respuesta a solicitudes de ejercicio de derechos del Capítulo III del RGPD.'
      },
      {
        id: 'dpa-7',
        num: '7',
        title: 'Notificación de violaciones de seguridad',
        text: 'Cualquier incidente de seguridad que afecte a datos personales se notificará en un plazo máximo de 48 horas tras su detección.'
      },
      {
        id: 'dpa-8',
        num: '8',
        title: 'Evaluaciones de impacto (EIPD)',
        text: 'El Encargado facilitará la información técnica necesaria para la realización de evaluaciones de impacto de protección de datos.'
      },
      {
        id: 'dpa-9',
        num: '9',
        title: 'Supresión o devolución de datos',
        text: 'Finalizado el servicio, todos los datos personales serán suprimidos o devueltos al Responsable según su elección.'
      },
      {
        id: 'dpa-10',
        num: '10',
        title: 'Auditorías y ley aplicable',
        text: 'El Responsable podrá verificar el cumplimiento de este acuerdo mediante auditorías razonables. Se aplica la legislación checa y el RGPD.'
      }
    ],
    crossLinksTitle: 'Documentos relacionados',
    crossLinks: [
      { route: 'product-privacy', name: 'Privacidad del Producto', desc: 'Arquitectura técnica de privacidad de SED' },
      { route: 'privacy-policy', name: 'Política de Privacidad General', desc: 'Tratamiento de datos como Responsable (Web)' },
      { route: 'eula', name: 'Acuerdo de Licencia EULA', desc: 'Condiciones de licencia de software' },
      { route: 'policy-ims', name: 'Política IMS (ISO 27001)', desc: 'Certificación de seguridad de la información' }
    ]
  },
  pt: {
    eyebrow: 'RGPD ARTIGO 28 & PROTEÇÃO DE DADOS',
    title: 'Acordo de Processamento de Dados (DPA)',
    subtitle: 'Termos contratuais de subcontratação nos termos do Art. 28 do RGPD para soluções cloud e assistência da JALUD Embedded s.r.o.',
    version: 'Versão 2026.1 (Em vigor desde 1 de janeiro de 2026)',
    tocTitle: 'Índice do DPA',
    companyDetails: 'Subcontratante: JALUD Embedded s.r.o., Nepomucká 1355/261, 326 00 Plzeň, República Checa, NIF: 03056287',
    preamble: 'O presente Acordo de Processamento de Dados ("DPA") estabelece as obrigações entre o cliente ("Responsável pelo Tratamento") e a JALUD Embedded s.r.o. ("Subcontratante") nos termos do Art. 28 do Regulamento (UE) 2016/679 (RGPD).',
    sections: [
      {
        id: 'dpa-1',
        num: '1',
        title: 'Objeto e Âmbito do Tratamento',
        text: 'O tratamento restringe-se à operação técnica dos serviços cloud do Sound Event Detector (SED), gestão de alarmes acústicos e suporte técnico.'
      },
      {
        id: 'dpa-2',
        num: '2',
        title: 'Tipologia dos Dados Pessoais',
        text: 'Identificadores de rede e sensores, carimbos temporais, metadados de eventos acústicos e excertos curtos de verificação (máx. 1,5s).'
      },
      {
        id: 'dpa-3',
        num: '3',
        title: 'Instruções e Confidencialidade',
        text: 'O processamento efetua-se exclusivamente sob instruções documentadas do Responsável. O pessoal envolvido está sujeito a estrito dever de sigilo.'
      },
      {
        id: 'dpa-4',
        num: '4',
        title: 'Medidas Técnicas e Organizativas (TOMs)',
        text: 'Aplicação de segurança conforme o Art. 32 do RGPD e ISO 27001: cifragem TLS 1.3 em trânsito e AES-256 em repouso com segregação de ambientes.'
      },
      {
        id: 'dpa-5',
        num: '5',
        title: 'Subcontratantes Ulteriores',
        text: 'Autorização geral para subcontratantes de infraestrutura cloud na UE/EEE sob compromissos contratuais de nível idêntico.'
      },
      {
        id: 'dpa-6',
        num: '6',
        title: 'Direitos dos Titulares dos Dados',
        text: 'Assistência ao Responsável no atendimento aos direitos dos titulares dos dados previstos no Capítulo III do RGPD.'
      },
      {
        id: 'dpa-7',
        num: '7',
        title: 'Notificação de Violações de Segurança',
        text: 'Notificação de qualquer violação de dados pessoais no prazo máximo de 48 horas após a respetiva confirmação.'
      },
      {
        id: 'dpa-8',
        num: '8',
        title: 'Avaliação de Impacto (AIPD)',
        text: 'Colaboração e fornecimento de documentação técnica para suporte a avaliações de impacto sobre a proteção de dados.'
      },
      {
        id: 'dpa-9',
        num: '9',
        title: 'Apagamento ou Devolução dos Dados',
        text: 'Cessada a prestação de serviços, todos os dados serão apagados ou devolvidos ao Responsável, consoante a sua opção.'
      },
      {
        id: 'dpa-10',
        num: '10',
        title: 'Auditorias e Lei Aplicável',
        text: 'Disponibilização de informação e realização de auditorias acordadas previamente. Regido pela lei da República Checa e pelo RGPD.'
      }
    ],
    crossLinksTitle: 'Documentos associados',
    crossLinks: [
      { route: 'product-privacy', name: 'Privacidade do Produto', desc: 'Arquitetura técnica de privacidade local e na nuvem' },
      { route: 'privacy-policy', name: 'Política de Privacidade Geral', desc: 'Tratamento de dados no website' },
      { route: 'eula', name: 'Contrato de Licença EULA', desc: 'Termos de licenciamento de software' },
      { route: 'policy-ims', name: 'Política IMS (ISO 27001)', desc: 'Sistema de gestão de segurança da informação' }
    ]
  },
  ar: {
    eyebrow: 'المادة 28 من GDPR وحماية البيانات',
    title: 'اتفاقية معالجة البيانات (DPA)',
    subtitle: 'الشروط التعاقدية القياسية لمعالجة البيانات بموجب المادة 28 من اللائحة العامة لحماية البيانات (GDPR) للخدمات السحابية والدعم الفني لشركة JALUD Embedded s.r.o.',
    version: 'الإصدار 2026.1 (يسري اعتباراً من 1 يناير 2026)',
    tocTitle: 'فهرس بنود الاتفاقية',
    companyDetails: 'معالج البيانات: JALUD Embedded s.r.o.، العنوان: Nepomucká 1355/261, 326 00 Plzeň، الجمهورية التشيكية، السجل: 03056287',
    preamble: 'تحكم هذه الاتفاقية ("DPA") معالجة البيانات الشخصية التي تجريها شركة JALUD Embedded s.r.o. ("المعالج") نيابة عن العميل ("المتحكم") عند تقديم الخدمات السحابية أو الصيانة التقنية لنظام SED وفقاً للائحة (EU) 2016/679 ("GDPR").',
    sections: [
      {
        id: 'dpa-1',
        num: '١',
        title: 'محل الاتفاقية وطبيعة المعالجة والغرض منها',
        text: 'يقتصر الغرض من المعالجة حصرياً على التشغيل التقني لخدمات السحابة لنظام SED وإرسال الإنذارات الصوتية وتقديم الدعم الفني بناءً على طلب المتحكم.'
      },
      {
        id: 'dpa-2',
        num: '٢',
        title: 'أنواع البيانات الشخصية وفئات أصحاب البيانات',
        text: 'معرفات الأجهزة، والأختام الزمنية، والبيانات الوصفية الصوتية (مستوى الديسيبل، فئة الصوت)، ومقاطع التحقق الصوتية الاختيارية المقتضبة (بحد أقصى 1.5 ثانية).'
      },
      {
        id: 'dpa-3',
        num: '٣',
        title: 'تعليمات المتحكم والسرية',
        text: 'تتم المعالجة حصراً وفقاً لتعليمات المتحكم الموثقة، ويلتزم جميع الموظفين بالتزام قانوني صارم بالحفاظ على سرية البيانات.'
      },
      {
        id: 'dpa-4',
        num: '٤',
        title: 'التدابير الأمنية الفنية والتنظيمية (TOMs)',
        text: 'تطبيق معايير المادة 32 من GDPR ومعايير ISO 27001، بما في ذلك التشفير الكامل TLS 1.3 للنقل و AES-256 للتخزين وعزل بيانات العملاء.'
      },
      {
        id: 'dpa-5',
        num: '٥',
        title: 'المعالجون من الباطن',
        text: 'يمنح المتحكم تفويضاً عاماً بالاستعانة بمزودي البنية التحتية السحابية داخل الاتحاد الأوروبي / المنطقة الاقتصادية الأوروبية بشروط حماية مماثلة.'
      },
      {
        id: 'dpa-6',
        num: '٦',
        title: 'المساعدة في تلبية حقوق أصحاب البيانات',
        text: 'مساعدة المتحكم عبر الوسائل التقنية المتاحة في الاستجابة لطلبات ممارسة الحقوق المنصوص عليها في الباب الثالث من GDPR.'
      },
      {
        id: 'dpa-7',
        num: '٧',
        title: 'الإخطار بانتهاكات حماية البيانات',
        text: 'إخطار المتحكم بأي خرق أو انتهاك أمني يمس البيانات الشخصية دون تأخير وخلال مدة أقصاها 48 ساعة من تأكيد الواقعة.'
      },
      {
        id: 'dpa-8',
        num: '٨',
        title: 'تقييم أثر حماية البيانات (DPIA)',
        text: 'تقديم الدعم والوثائق التقنية للمتحكم للمساعدة في إعداد تقييمات أثر حماية البيانات وفقاً للمادة 35 من GDPR.'
      },
      {
        id: 'dpa-9',
        num: '٩',
        title: 'حذف البيانات أو إعادتها عند انتهاء الخدمة',
        text: 'عند انتهاء العقد، يلتزم المعالج بحذف كافة البيانات الشخصية أو إعادتها للمتحكم وفقاً لاختياره.'
      },
      {
        id: 'dpa-10',
        num: '١٠',
        title: 'التدقيق والقانون الحاكم',
        text: 'إتاحة المعلومات اللازمة لإثبات الامتثال للمادة 28 من GDPR والسماح بعمليات التدقيق المتفق عليها. يسري قانون الجمهورية التشيكية ولائحة GDPR.'
      }
    ],
    crossLinksTitle: 'الوثائق ذات الصلة',
    crossLinks: [
      { route: 'product-privacy', name: 'خصوصية المنتج وحماية البيانات', desc: 'تفاصيل المعالجة الطرفية والسحابية' },
      { route: 'privacy-policy', name: 'سياسة الخصوصية العامة', desc: 'معالجة بيانات الموقع والعملاء' },
      { route: 'eula', name: 'اتفاقية ترخيص المستخدم النهائي EULA', desc: 'شروط استخدام البرمجيات' },
      { route: 'policy-ims', name: 'سياسة IMS (ISO 27001)', desc: 'نظام إدارة أمن المعلومات المعتمد' }
    ]
  }
,
  it: {
    "eyebrow": "CONTRATTO DI TRATTAMENTO DATI EX ART. 28 GDPR",
    "title": "Accordo sul Trattamento dei Dati Personali (DPA)",
    "subtitle": "Termini contrattuali standard per i servizi cloud, telemetria opzionale e supporto remoto conformi all'Art. 28 del Regolamento UE 2016/679 (GDPR).",
    "version": "Versione 2026.1 (In vigore dal 1° gennaio 2026)",
    "tocTitle": "Indice dell'Accordo DPA",
    "companyDetails": "Responsabile del Trattamento: JALUD Embedded s.r.o., Nepomucká 1355/261, 326 00 Plzeň, Repubblica Ceca",
    "preamble": "Il presente Accordo sul Trattamento dei Dati (\"DPA\") si applica ogniqualvolta JALUD Embedded s.r.o. (\"Responsabile\" o \"Fornitore\") tratta dati personali per conto del Cliente (\"Titolare\") nell'ambito della fornitura di servizi di supporto tecnico remoto, manutenzione cloud o telemetria dei sistemi Sound Event Detector.",
    "sections": [
      {
        "id": "dpa-1",
        "num": "1",
        "title": "Oggetto e Finalità dell'Accordo",
        "text": "Il presente DPA disciplina le condizioni in base alle quali il Responsabile tratta dati personali per conto del Titolare, garantendo la piena rispondenza all'Articolo 28 del Regolamento (UE) 2016/679 (GDPR)."
      },
      {
        "id": "dpa-2",
        "num": "2",
        "title": "Ruoli delle Parti e Istruzioni Vincolanti",
        "text": "Il Cliente è il Titolare del Trattamento e determina finalità e mezzi del trattamento. JALUD opera unicamente in qualità di Responsabile del Trattamento ed elabora i dati esclusivamente sulla base delle istruzioni documentate fornite dal Titolare."
      },
      {
        "id": "dpa-3",
        "num": "3",
        "title": "Categorie di Dati e Soggetti Interessati",
        "text": "I dati trattati possono comprendere: metadati tecnici di eventi allarme, log di stato dei dispositivi, indirizzi IP di configurazione e, qualora abilitati dal Cliente, brevi frammenti audio di verifica (max 1,5s). Gli interessati sono le persone fisiche presenti nelle aree monitorate dai dispositivi del Titolare."
      },
      {
        "id": "dpa-4",
        "num": "4",
        "title": "Misure Tecniche e Organizzative di Sicurezza",
        "text": "Il Responsabile adotta misure tecniche e organizzative adeguate per garantire un livello di sicurezza commisurato al rischio, in conformità allo standard ISO/IEC 27001, inclusa la pseudonimizzazione, la cifratura dei dati in transito (TLS) e a riposo, e controlli di accesso granulari."
      },
      {
        "id": "dpa-5",
        "num": "5",
        "title": "Personale Autorizzato e Obblighi di Riservatezza",
        "text": "JALUD assicura che i dipendenti e collaboratori autorizzati ad accedere ai dati personali si siano formalmente impegnati alla riservatezza o abbiano un adeguato obbligo legale di segretezza."
      },
      {
        "id": "dpa-6",
        "num": "6",
        "title": "Sub-responsabili del Trattamento (Sub-processors)",
        "text": "Il Titolare concede un'autorizzazione generale a JALUD per l'impiego di sub-responsabili (es. hosting cloud UE per servizi di notifica). JALUD informa tempestivamente il Titolare di eventuali modifiche o sostituzioni e impone ai sub-responsabili gli stessi obblighi in materia di protezione dei dati previsti dal presente DPA."
      },
      {
        "id": "dpa-7",
        "num": "7",
        "title": "Assistenza al Titolare del Trattamento",
        "text": "Tenendo conto della natura del trattamento, JALUD assiste il Titolare con misure tecniche e organizzative adeguate per dare seguito alle richieste di esercizio dei diritti degli interessati (Capo III GDPR) e per adempiere agli obblighi di sicurezza e consultazione preliminare DPIA (Artt. 32-36 GDPR)."
      },
      {
        "id": "dpa-8",
        "num": "8",
        "title": "Notifica di Violazione dei Dati Personali (Data Breach)",
        "text": "JALUD notifica al Titolare senza indebito ritardo, e comunque entro 48 ore dalla venuta a conoscenza, qualsiasi violazione di sicurezza che comporti accidentalmente o illecitamente la distruzione, perdita o divulgazione indebita dei dati personali trattati."
      },
      {
        "id": "dpa-9",
        "num": "9",
        "title": "Cancellazione e Restituzione dei Dati al Termine del Servizio",
        "text": "Alla cessazione della fornitura dei servizi, JALUD provvede, a scelta del Titolare, alla cancellazione definitiva o alla restituzione di tutti i dati personali trattati per suo conto, distruggendo le copie esistenti salvo che la legge europea o nazionale ne prescriva la conservazione."
      },
      {
        "id": "dpa-10",
        "num": "10",
        "title": "Verifiche di Conformità, Audit e Disposizioni Finali",
        "text": "JALUD mette a disposizione del Titolare tutte le informazioni necessarie per dimostrare il rispetto degli obblighi di cui all'Art. 28 GDPR e consente verifiche o ispezioni condotte dal Titolare o da un revisore indipendente incaricato, nel rispetto dei segreti industriali e dei requisiti di sicurezza fisica."
      }
    ],
    "crossLinksTitle": "Documenti Legali Correlati",
    "crossLinks": [
      {
        "route": "product-privacy",
        "name": "Privacy del Prodotto",
        "desc": "Principi tecnici di elaborazione in memoria volatile e salvaguardia audio"
      },
      {
        "route": "eula",
        "name": "Licenza Utente Finale (EULA)",
        "desc": "Condizioni di concessione della licenza per il software Sound Event Detector"
      },
      {
        "route": "support-and-maintenance",
        "name": "Termini di Supporto e Manutenzione",
        "desc": "Accordi sui livelli di servizio e manutenzione correttiva del software"
      },
      {
        "route": "policy-ims",
        "name": "Politica IMS (ISO 9001 e ISO 27001)",
        "desc": "Sistema di gestione della qualità e della sicurezza delle informazioni"
      }
    ]
  }
};


export const LEGAL_VERSIONS = {
  "cs": "Verze 2026.1 (Účinnost od 1. ledna 2026)",
  "en": "Version 2026.1 (Effective January 1, 2026)",
  "de": "Version 2026.1 (Gültig ab 1. Januar 2026)",
  "es": "Versión 2026.1 (Vigente a partir del 1 de enero de 2026)",
  "pt": "Versão 2026.1 (Em vigor desde 1 de janeiro de 2026)",
  "ar": "الإصدار 2026.1 (يسري اعتباراً من 1 يناير 2026)",
  "it": "Versione 2026.1 (In vigore dal 1° gennaio 2026)"
};

export const supportData = {
  "cs": {
    "eyebrow": "SERVISNÍ SLUŽBY & TECHNICKÁ PODPORA",
    "title": "Podmínky podpory a údržby",
    "subtitle": "Rozsah technické podpory, pravidla aktualizací AI modelů, klasifikace závažnosti incidentů a cílové reakční doby pro řešení JALUD Embedded s.r.o.",
    "version": "Verze 2026.1 (Účinnost od 1. ledna 2026)",
    "tocTitle": "Obsah podmínek podpory",
    "companyDetails": "Poskytovatel podpory: JALUD Embedded s.r.o., Nepomucká 1355/261, 326 00 Plzeň, Česká republika, IČO: 03056287",
    "preamble": "Tyto Podmínky podpory a údržby („Podmínky podpory“) upravují poskytování služeb technické podpory, údržby softwaru, bezpečnostních oprav a aktualizací neuronových modelů společností JALUD Embedded s.r.o. („Poskytovatel“) pro oprávněné zákazníky a certifikované partnery využívající software Sound Event Detector (SED).",
    "slaNoticeBadge": "Důležité upozornění k reakčním dobám",
    "slaNoticeText": "Cílové reakční doby uvedené v těchto podmínkách představují provozní cíle technického týmu JALUD pro zahájení diagnostiky. Tyto časy nezakládají garantovanou dobu vyřešení incidentu ani smluvní garanci (SLA) se smluvními pokutami, pokud není se zákazníkem písemně uzavřena samostatná individuální prémiová servisní smlouva (SLA).",
    "sections": [
      {
        "id": "supp-1",
        "num": "1",
        "title": "Rozsah služeb podpory a role Dodavatele SED",
        "text": "Technická a servisní podpora řešení Sound Event Detector (SED) je organizována ve víceúrovňovém modelu: (a) Vyřízení základních uživatelských dotazů k používání, instalace softwaru a hardwaru, prvotní přihlášení, zajištění odborné montáže a proškolení personálu objednatele pro správnou instalaci zařízení zajišťuje autorizovaný Dodavatel SED; (b) Technická podpora k produktu, integrace do nadřazených VMS systémů a konzultace spojené se správným provozem jsou rovněž zajišťovány Dodavatelem SED ve spolupráci s Poskytovatelem; (c) Provozování servisní podpory nad dedikovaným hardwarovým zařízením společnosti JALUD Embedded je povinné pro zachování garantované detekční spolehlivosti, stability neuronových modelů a platnosti záruk."
      },
      {
        "id": "supp-2",
        "num": "2",
        "title": "Adaptace na akustické prostředí a garance falešných alarmů",
        "text": "Společnost JALUD Embedded v rámci servisní podpory poskytuje: (a) Odbornou adaptaci a doladění algoritmických parametrů Zařízení na specifické akustické podmínky prostředí objednatele (např. rušné městské tepny, průmyslové haly, školy, dopravní uzly); (b) Řešení anomálií a optimalizaci detekčních prahů v případě vykazování nadměrného počtu falešných poplachů. Poskytovatel garantuje provozní toleranci v průměru maximálně 3 falešných alarmů na jedno zařízení za 24 hodin provozu při dodržení doporučených montážních podmínek."
      },
      {
        "id": "supp-3",
        "num": "3",
        "title": "Aktualizace softwaru, neuronových modelů a nové detekční třídy",
        "text": "Pravidla pro aktualizace softwaru a rozšiřování neuronových sítí: (a) Objednatel má po dobu trvání podpory nárok na pozdější softwarový upgrade Zařízení, která již byla objednateli dodána. Upgrade obsahuje vylepšení funkcionalit pro již dodané a zakoupené zvuky a detekce (tříštění skla, střelba, panický křik, verbální agrese atd.) – zejména vyšší odolnost vůči falešným poplachům, vyšší citlivost modelu, prodloužení efektivního dosahu detekce a úpravu algoritmů Zařízení. Tyto aktualizace pro již dodaná zařízení jsou bezplatné; (b) Bezplatné jsou rovněž veškeré aktualizace obslužných softwarových nástrojů SED Presentation a SED Control."
      },
      {
        "id": "supp-4",
        "num": "4",
        "title": "Serverová Dual Verification, konektivita a akustická triangulace",
        "text": "Pro kamerové instalace a rozsáhlé systémy je k dispozici pokročilá serverová podpora (v cloudovém i on-premise provedení): (a) Dual verification na serveru (SED Server) – dodatečné dvouúrovňové ověření detekcí z kamerových instalací probíhá na serverové infrastruktuře za využití výrazně většího neuronového modelu, což snižuje míru falešných poplachů přibližně o dalších 50 % oproti primárnímu vyhodnocení probíhajícímu přímo na kameře (ACAP/HEOP); (b) Podpora standardního ONVIF alarmového a audio/video streamu z bezpečnostních kamer; (c) Podpora standardních rozhraní RestAPI, FCM (Firebase Cloud Messaging), SIA DC-09, ConnectID apod. pro plnohodnotnou integraci do systémů VMS (Genetec Security Center, Milestone XProtect, Avigilon Control Center aj.); (d) Automatické prostorové určení polohy (akustická triangulace) a výpočet souřadnic zdroje zvuku (útočníka či oběti) v případě zachycení zvukové události minimálně 3 venkovními zařízeními SED."
      },
      {
        "id": "supp-5",
        "num": "5",
        "title": "Důsledky neobjednání nebo vypršení servisní podpory",
        "text": "V případě, že servisní podpora není objednatelem sjednána nebo dojde k jejímu vypršení bez včasného obnovení: (a) Objednatel ztrácí nárok na adaptaci neuronových modelů na specifické prostředí instalace, zaniká garance maximální míry falešných poplachů a je deaktivována prostorová triangulace/lokalizace incidentů; (b) Servisní podpora po vypršení platnosti zaniká a nelze ji na dříve zakoupené produkty a zařízení uplatnit zpětně bez úhrady poplatku za reaktivaci a technického auditu instalace."
      },
      {
        "id": "supp-6",
        "num": "6",
        "title": "Podporované verze softwaru",
        "text": "Poskytovatel poskytuje plnou technickou podporu pro aktuální hlavní verzi softwaru (N) a bezprostředně předcházející verzi (N-1). Pro starší verze jsou poskytovány pouze kritické bezpečnostní záplaty dle uvážení Poskytovatele. Zákazníkům je doporučeno udržovat instalace na podporovaných verzích."
      },
      {
        "id": "supp-7",
        "num": "7",
        "title": "Komunikační kanály a provozní doba podpory",
        "text": "Standardní technická podpora je dostupná v pracovní dny od pondělí do pátku v čase 09:00 až 17:00 CET/CEST (s výjimkou státních svátků v České republice). Požadavky se zadávají prostřednictvím servisního Helpdesku nebo na e-mail: <span class=\"sed-obf-email\" data-u=\"c3VwcG9ydA==\" data-d=\"amFsdWQtZW1iZWRkZWQuY29t\" data-t=\"c3VwcG9ydEBqYWx1ZC1lbWJlZGRlZC5jb20=\" style=\"color: var(--blue-primary); text-decoration: none; font-weight: 600;\"><span class=\"sed-obf-fallback\">support [at] jalud-embedded.com</span></span>."
      },
      {
        "id": "supp-8",
        "num": "8",
        "title": "Kategorie závažnosti incidentů a cílové reakční doby",
        "text": "Incidenty jsou při přijetí klasifikovány do následujících úrovní závažnosti s těmito provozními cíli první reakce:<ul style=\"margin: 0.75rem 0 0 1.25rem; padding: 0;\"><li style=\"margin-bottom: 0.5rem;\"><strong>Závažnost 1 (Kritická – Havárie celého systému):</strong> Celkový výpadek detekce na primárním serveru či kritickém uzlu bez možnosti náhradního řešení. Cílová reakce technika: <strong>do 4 pracovních hodin</strong>.</li><li style=\"margin-bottom: 0.5rem;\"><strong>Závažnost 2 (Vysoká – Omezený provoz):</strong> Významné zhoršení funkce detekce na části zařízení nebo selhání integrace s VMS, základní provoz zachován. Cílová reakce: <strong>do 8 pracovních hodin</strong>.</li><li style=\"margin-bottom: 0.5rem;\"><strong>Závažnost 3 (Střední – Menší vada):</strong> Izolovaná chyba nemající vliv na spolehlivost klíčových detekcí, existuje náhradní řešení. Cílová reakce: <strong>do 2 pracovních dnů</strong>.</li><li style=\"margin-bottom: 0.5rem;\"><strong>Závažnost 4 (Nízká – Dotaz / Návrh):</strong> Dotazy na konfiguraci, požadavky na novou funkcionalitu či drobná kosmetická hlášení. Cílová reakce: <strong>do 5 pracovních dnů</strong>.</li></ul>"
      },
      {
        "id": "supp-9",
        "num": "9",
        "title": "Součinnost zákazníka",
        "text": "Rychlost a úspěšnost vyřešení incidentu závisí na poskytnutí součinnosti ze strany zákazníka. Zákazník je povinen: poskytnout přesný popis incidentu a postup reprodukce, poskytnout exportované systémové protokoly (logy) a diagnostická data ze zařízení, a v případě potřeby umožnit zabezpečený vzdálený přístup (VPN / TeamViewer)."
      },
      {
        "id": "supp-10",
        "num": "10",
        "title": "Výluky ze standardní podpory",
        "text": "Standardní podpora nezahrnuje: (a) odstraňování vad způsobených nekompatibilním či vadným hardwarem třetích stran, poškozenými mikrofony nebo vadnou kabeláží; (b) podporu neautorizovaných úprav softwaru či neoficiálních operačních systémů; (c) výjezdy techniků na místo instalace (on-site podpora); (d) obnovu dat ztracených v důsledku výpadku infrastruktury zákazníka."
      },
      {
        "id": "supp-11",
        "num": "11",
        "title": "Zásady ukončení životnosti produktů (EOL / EOS)",
        "text": "Poskytovatel si vyhrazuje právo ukončit podporu starších verzí softwaru nebo hardwarových platforem (End-of-Life / End-of-Support). Oznámení o EOL je vydáváno s předstihem minimálně 6 měsíců a zákazníkům je nabídnut přechod na aktuální podporovanou verzi."
      }
    ],
    "crossLinksTitle": "Související dokumentace",
    "crossLinks": [
      {
        "route": "eula",
        "name": "Licenční smlouva EULA",
        "desc": "Podmínky užívání softwaru SED a práva k licencím"
      },
      {
        "route": "terms-and-conditions",
        "name": "Obchodní podmínky",
        "desc": "Komerční podmínky, záruka na hardware a platby"
      },
      {
        "route": "product-privacy",
        "name": "Produktové soukromí",
        "desc": "Nakládání se zvukem a diagnostickými logy při servisu"
      },
      {
        "route": "policy-ims",
        "name": "Politika IMS",
        "desc": "Certifikované řízení jakosti a informační bezpečnosti"
      }
    ]
  },
  "en": {
    "eyebrow": "SUPPORT POLICIES & SERVICE MAINTENANCE",
    "title": "Support & Maintenance Terms",
    "subtitle": "Technical support framework, AI model maintenance, incident severity tiers, and target response times for JALUD Embedded s.r.o.",
    "version": "Version 2026.1 (Effective January 1, 2026)",
    "tocTitle": "Table of Contents",
    "companyDetails": "Support Provider: JALUD Embedded s.r.o., Nepomucká 1355/261, 326 00 Plzeň, Czech Republic, Reg. ID: 03056287",
    "preamble": "These Support & Maintenance Terms (\"Support Terms\") define the technical support services, software maintenance releases, security patches, and neural detection model updates provided by JALUD Embedded s.r.o. (\"Licensor\" or \"JALUD\") to authorized customers and certified system integrators operating Sound Event Detector (SED) solutions.",
    "slaNoticeBadge": "Important Notice on Response Times",
    "slaNoticeText": "The target response times specified herein represent operational goals for the technical support team to acknowledge and initiate diagnosis. They do NOT constitute guaranteed resolution times or binding financial Service Level Agreements (SLAs) with liquidated damages, unless a separate, custom SLA agreement has been expressly executed in writing.",
    "sections": [
      {
        "id": "supp-1",
        "num": "1",
        "title": "Scope of Support Services and Role of the SED Supplier",
        "text": "Technical and service support for Sound Event Detector (SED) solutions is organized within a multi-tiered framework: (a) Addressing standard user inquiries regarding system operation, installation of software and hardware, initial login setup, installation verification, and operational training for proper device deployment are provided by the certified SED Supplier; (b) Product technical support, upstream VMS integration, and operational guidance are likewise provided by the SED Supplier in coordination with JALUD; (c) Active service support for dedicated hardware devices manufactured by JALUD Embedded is mandatory to maintain guaranteed detection performance, neural model stability, and warranty coverage."
      },
      {
        "id": "supp-2",
        "num": "2",
        "title": "Acoustic Environment Adaptation and False Alarm Guarantee",
        "text": "As part of active service support, JALUD Embedded delivers: (a) Professional adaptation and calibration of Device parameters tailored to the customer's specific acoustic environment (e.g., bustling urban corridors, industrial facilities, transit hubs, educational campuses); (b) Rapid diagnosis and algorithmic threshold tuning in cases of elevated false alarm occurrences. JALUD guarantees an operational tolerance averaging a maximum of 3 false alarms per device per 24-hour period, subject to standard deployment specifications."
      },
      {
        "id": "supp-3",
        "num": "3",
        "title": "Software Upgrades, Neural Model Maintenance, and New Sound Classes",
        "text": "Guidelines governing software upgrades and neural network maintenance: (a) Customers maintain the right to subsequent software upgrades for Devices already delivered and licensed. Upgrades encompass performance enhancements for previously delivered and purchased sound detection classes (glass break, gunshot, panic scream, verbal aggression, etc.) — specifically enhanced false alarm suppression, improved model sensitivity, extended acoustic range, and algorithm optimizations. These updates for delivered devices are complimentary; (b) All version updates for SED Presentation and SED Control software utilities are likewise provided free of charge."
      },
      {
        "id": "supp-4",
        "num": "4",
        "title": "Server Dual Verification, Connectivity, and Acoustic Triangulation",
        "text": "For camera deployments and enterprise infrastructure, advanced server support is available in both cloud and on-premise environments: (a) Dual Verification on SED Server — secondary verification of detections from camera installations is performed on server infrastructure utilizing a substantially larger neural network model, reducing edge false alarms by approximately an additional 50% compared to on-camera evaluation (ACAP/HEOP); (b) Native support for standard ONVIF alarm and audio/video streaming from IP cameras; (c) Comprehensive integration interfaces including RestAPI, FCM (Firebase Cloud Messaging), SIA DC-09, and ConnectID for seamless interoperation with leading VMS suites (Genetec Security Center, Milestone XProtect, Avigilon Control Center, etc.); (d) Automated spatial coordinate calculation (acoustic triangulation) pinpointing the location of the sound source (attacker or victim) in real time when an incident is captured by at least 3 outdoor SED devices."
      },
      {
        "id": "supp-5",
        "num": "5",
        "title": "Consequences of Lapsed or Unordered Support",
        "text": "In the event that service support is not contracted or is permitted to expire without timely renewal: (a) The Customer forfeits access to acoustic environment model adaptation, the guaranteed maximum false alarm threshold, and multi-sensor event triangulation/localization; (b) Support entitlement terminates upon expiration and cannot be reinstated retroactively for previously deployed products and units without an authorized reactivation fee and baseline technical audit."
      },
      {
        "id": "supp-6",
        "num": "6",
        "title": "Supported Software Versions",
        "text": "Full technical support is provided for the current major release (N) and the immediately preceding release (N-1). For older software generations, only critical security patches may be provided at JALUD’s sole discretion. Customers are strongly encouraged to maintain software deployments within active support branches."
      },
      {
        "id": "supp-7",
        "num": "7",
        "title": "Support Channels and Operational Hours",
        "text": "Standard support is available during business hours, Monday through Friday, from 09:00 to 17:00 CET/CEST (excluding statutory public holidays in the Czech Republic). Support requests must be submitted via the official Helpdesk portal or via email to: <span class=\"sed-obf-email\" data-u=\"c3VwcG9ydA==\" data-d=\"amFsdWQtZW1iZWRkZWQuY29t\" data-t=\"c3VwcG9ydEBqYWx1ZC1lbWJlZGRlZC5jb20=\" style=\"color: var(--blue-primary); text-decoration: none; font-weight: 600;\"><span class=\"sed-obf-fallback\">support [at] jalud-embedded.com</span></span>."
      },
      {
        "id": "supp-8",
        "num": "8",
        "title": "Incident Severity Levels and Target Response Times",
        "text": "Incoming support inquiries are prioritized according to the following operational severity matrix:<ul style=\"margin: 0.75rem 0 0 1.25rem; padding: 0;\"><li style=\"margin-bottom: 0.5rem;\"><strong>Severity 1 (Critical – Outage):</strong> Complete failure of detection on a primary server or critical edge node with no workaround available. Initial target response: <strong>within 4 business hours</strong>.</li><li style=\"margin-bottom: 0.5rem;\"><strong>Severity 2 (High – Degraded):</strong> Substantial degradation of detection capability or failure of VMS alerting integration, with core application operational. Initial target response: <strong>within 8 business hours</strong>.</li><li style=\"margin-bottom: 0.5rem;\"><strong>Severity 3 (Medium – Minor Defect):</strong> Isolated functional issue not impairing critical detection, with a known operational workaround. Initial target response: <strong>within 2 business days</strong>.</li><li style=\"margin-bottom: 0.5rem;\"><strong>Severity 4 (Low – Inquiry / Request):</strong> General configuration questions, feature requests, or minor user-interface cosmetic items. Initial target response: <strong>within 5 business days</strong>.</li></ul>"
      },
      {
        "id": "supp-9",
        "num": "9",
        "title": "Customer Cooperation Obligations",
        "text": "Timely defect resolution requires active customer cooperation. Customers must: provide a clear description and reproduction steps, furnish relevant log exports and diagnostic telemetry, and enable secure remote network access (VPN or supervised remote session) when necessary."
      },
      {
        "id": "supp-10",
        "num": "10",
        "title": "Standard Support Exclusions",
        "text": "Standard support excludes: (a) troubleshooting defects originating from third-party hardware, degraded camera microphones, or network infrastructure; (b) custom or unsupported operating system distributions; (c) on-site physical dispatch of technical personnel; and (d) data recovery resulting from customer hardware or storage failures."
      },
      {
        "id": "supp-11",
        "num": "11",
        "title": "End-of-Life (EOL) and End-of-Support (EOS) Policy",
        "text": "JALUD reserves the right to retire mature software versions or unsupported hardware architectures. EOL announcements will precede the effective retirement date by a minimum of six (6) months, during which migration pathways will be made available."
      }
    ],
    "crossLinksTitle": "Related Governance Documents",
    "crossLinks": [
      {
        "route": "eula",
        "name": "End User License Agreement (EULA)",
        "desc": "Software licensing terms, authorized use, and liability limits"
      },
      {
        "route": "terms-and-conditions",
        "name": "Terms & Conditions",
        "desc": "Commercial ordering, payment terms, and hardware warranty"
      },
      {
        "route": "product-privacy",
        "name": "Product Privacy & Data Protection",
        "desc": "Technical edge privacy architecture and diagnostic data handling"
      },
      {
        "route": "policy-ims",
        "name": "Policy IMS (ISO 9001 / 27001)",
        "desc": "Certified quality and security management framework"
      }
    ]
  },
  "de": {
    "eyebrow": "SUPPORT-RICHTLINIEN & WARTUNG",
    "title": "Support- und Wartungsbedingungen",
    "subtitle": "Regelungen zum technischen Support, Software- und KI-Aktualisierungen sowie Ziel-Reaktionszeiten der JALUD Embedded s.r.o.",
    "version": "Version 2026.1 (Gültig ab 1. Januar 2026)",
    "tocTitle": "Inhaltsverzeichnis",
    "companyDetails": "Supportgeber: JALUD Embedded s.r.o., Nepomucká 1355/261, 326 00 Plzeň, Tschechische Republik, Id-Nr.: 03056287",
    "preamble": "Diese Support- und Wartungsbedingungen regeln die Bereitstellung von technischem Support, Softwareaktualisierungen und KI-Modell-Updates für den Sound Event Detector (SED) durch die JALUD Embedded s.r.o.",
    "slaNoticeBadge": "Wichtiger Hinweis zu Reaktionszeiten",
    "slaNoticeText": "Die angegebenen Ziel-Reaktionszeiten stellen interne Betriebsziele unseres Supportteams dar. Sie begründen keine garantierten Lösungszeiten oder vertraglichen Pönalen (SLA), sofern kein gesonderter Premium-SLA-Vertrag geschlossen wurde.",
    "sections": [
      {
        "id": "supp-1",
        "num": "1",
        "title": "Umfang der Supportleistungen und Rolle des SED-Lieferanten",
        "text": "Der technische Support für den Sound Event Detector (SED) erfolgt in einem mehrstufigen Servicemodell: (a) Die Bearbeitung grundlegender Benutzerfragen, die Installation von SW und HW, Erstanmeldung, fachgerechte Montage und Anwenderschulung für die korrekte Inbetriebnahme werden durch den zertifizierten SED-Lieferanten erbracht; (b) Technischer Produktsupport, VMS-Integration und Beratung zum ordnungsgemäßen Betrieb erfolgen ebenfalls durch den SED-Lieferanten in Abstimmung mit JALUD; (c) Der Abschluss eines Servicevertrags für dedizierte JALUD Embedded Hardware ist obligatorisch, um die garantierte Erkennungsleistung, neuronale Stabilität und Gewährleistungsansprüche aufrechtzuerhalten."
      },
      {
        "id": "supp-2",
        "num": "2",
        "title": "Umgebungsanpassung und Fehlalarm-Garantie",
        "text": "Im Rahmen des aktiven Service-Supports bietet JALUD Embedded: (a) Fachliche Anpassung und Kalibrierung der Geräteparameter an die spezifische akustische Umgebung des Auftraggebers (z. B. städtische Verkehrsknotenpunkte, Industriezonen, Schulen); (b) Fehlerdiagnose und Schwellenwertoptimierung bei erhöhtem Fehlalarmaufkommen. JALUD garantiert eine Betriebstoleranz von durchschnittlich maximal 3 Fehlalarmen pro Gerät und Tag unter Einhaltung der empfohlenen Montagebedingungen."
      },
      {
        "id": "supp-3",
        "num": "3",
        "title": "Software-Upgrades, neuronale Modellpflege und neue Erkennungsklassen",
        "text": "Regelungen zu Software- und Modellaktualisierungen: (a) Der Auftraggeber hat Anspruch auf nachfolgende Software-Upgrades für bereits gelieferte Geräte. Upgrades enthalten Funktionsverbesserungen für bereits erworbene Erkennungsklassen (Glasbruch, Schüsse, Panikschreie, Aggression usw.) – insbesondere höhere Fehlalarmfestigkeit, höhere Empfindlichkeit, größere Reichweite und Algorithmenoptimierung. Diese Aktualisierungen für gelieferte Geräte sind kostenfrei; (b) Aktualisierungen der Dienstprogramme SED Presentation und SED Control sind ebenfalls gebührenfrei."
      },
      {
        "id": "supp-4",
        "num": "4",
        "title": "Server Dual Verification, VMS-Konnektivität und Triangulation",
        "text": "Für Kamera- und Enterprise-Installationen steht eine erweiterte Server-Unterstützung (Cloud oder On-Premise) bereit: (a) Dual Verification auf dem SED Server – die sekundäre Überprüfung von Kameraerkennungen auf Serverinfrastruktur mit einem wesentlich größeren neuronalen Modell reduziert die Fehlalarmrate um ca. weitere 50 % gegenüber der reinen Kameraauswertung (ACAP/HEOP); (b) Unterstützung von ONVIF-Alarm- und Audio/Videostreams; (c) Schnittstellen RestAPI, FCM, SIA DC-09, ConnectID für VMS-Systeme (Genetec, Milestone, Avigilon usw.); (d) Automatische akustische Standortbestimmung (Triangulation) und Positionsberechnung von Täter oder Opfer bei Erfassung durch mindestens 3 Außen-SED-Geräte."
      },
      {
        "id": "supp-5",
        "num": "5",
        "title": "Folgen bei Nichtbeauftragung oder Ablauf des Service-Supports",
        "text": "Wird kein Service-Support beauftragt oder läuft dieser ohne Erneuerung aus: (a) Verliert der Kunde den Anspruch auf Umgebungsanpassung der Modelle, die Fehlalarm-Garantie und die akustische Triangulation; (b) Der Supportanspruch erlischt und kann für Altsysteme nicht rückwirkend ohne Reaktivierungsgebühr und Systemaudit geltend gemacht werden."
      },
      {
        "id": "supp-6",
        "num": "6",
        "title": "Unterstützte Softwareversionen",
        "text": "Unterstützt werden die aktuelle Hauptversion (N) sowie die Vorversion (N-1). Für ältere Versionen werden Sicherheitsupdates nur nach Ermessen bereitgestellt."
      },
      {
        "id": "supp-7",
        "num": "7",
        "title": "Supportkanäle und Betriebszeiten",
        "text": "Montag bis Freitag, 09:00 bis 17:00 Uhr MEZ/MESZ (ausgenommen tschechische Feiertage). Anfragen sind über das Support-Portal oder per E-Mail an: <span class=\"sed-obf-email\" data-u=\"c3VwcG9ydA==\" data-d=\"amFsdWQtZW1iZWRkZWQuY29t\" data-t=\"c3VwcG9ydEBqYWx1ZC1lbWJlZGRlZC5jb20=\" style=\"color: var(--blue-primary); text-decoration: none; font-weight: 600;\"><span class=\"sed-obf-fallback\">support [at] jalud-embedded.com</span></span> zu richten."
      },
      {
        "id": "supp-8",
        "num": "8",
        "title": "Prioritäten und Ziel-Reaktionszeiten",
        "text": "Kritische Vorfälle (Stufe 1): Ziel-Reaktionszeit <strong>innerhalb von 4 Geschäftsstunden</strong>. Hohe Priorität (Stufe 2): <strong>innerhalb von 8 Geschäftsstunden</strong>. Mittlere Priorität (Stufe 3): <strong>innerhalb von 2 Geschäftstagen</strong>. Niedrige Priorität (Stufe 4): <strong>innerhalb von 5 Geschäftstagen</strong>."
      },
      {
        "id": "supp-9",
        "num": "9",
        "title": "Mitwirkungspflichten des Kunden",
        "text": "Der Kunde ist verpflichtet, Logdateien bereitzustellen, Fehler reproduzierbar zu beschreiben und bei Bedarf gesicherten Fernzugriff zu ermöglichen."
      },
      {
        "id": "supp-10",
        "num": "10",
        "title": "Support-Ausschlüsse",
        "text": "Ausgeschlossen sind Mängel an Drittanbieter-Hardware, defekte Mikrofone, Vor-Ort-Einsätze ohne gesonderten Vertrag sowie nicht autorisierte Modifikationen."
      },
      {
        "id": "supp-11",
        "num": "11",
        "title": "End-of-Life-Richtlinie (EOL)",
        "text": "Die Abkündigung von Versionen erfolgt mit einer Vorankündigungsfrist von mindestens 6 Monaten."
      }
    ],
    "crossLinksTitle": "Zugehörige Dokumente",
    "crossLinks": [
      {
        "route": "eula",
        "name": "Endbenutzer-Lizenzvertrag (EULA)",
        "desc": "Lizenzbedingungen für SED-Software"
      },
      {
        "route": "terms-and-conditions",
        "name": "Allgemeine Geschäftsbedingungen",
        "desc": "Hardware-Garantie und kommerzielle Bedingungen"
      },
      {
        "route": "product-privacy",
        "name": "Produktdatenschutz",
        "desc": "Behandlung von Telemetrie und Diagnosedaten"
      },
      {
        "route": "policy-ims",
        "name": "IMS-Richtlinie (ISO 9001 / 27001)",
        "desc": "Qualitäts- und Sicherheitszertifizierung"
      }
    ]
  },
  "es": {
    "eyebrow": "POLÍTICAS DE SOPORTE & MANTENIMIENTO",
    "title": "Términos de Soporte y Mantenimiento",
    "subtitle": "Niveles de servicio técnico, actualizaciones de modelos de IA y tiempos objetivo de respuesta de JALUD Embedded s.r.o.",
    "version": "Versión 2026.1 (Vigente a partir del 1 de enero de 2026)",
    "tocTitle": "Índice de soporte",
    "companyDetails": "Proveedor de soporte: JALUD Embedded s.r.o., Nepomucká 1355/261, 326 00 Plzeň, República Checa, NIF: 03056287",
    "preamble": "Estos Términos de Soporte regulan los servicios de asistencia técnica y mantenimiento de software para Sound Event Detector (SED) prestados por JALUD Embedded s.r.o.",
    "slaNoticeBadge": "Aviso sobre tiempos de respuesta",
    "slaNoticeText": "Los tiempos objetivo de respuesta son metas operativas de atención inicial y NO constituyen tiempos garantizados de resolución ni un SLA vinculante con penalizaciones sin un contrato de servicio independiente.",
    "sections": [
      {
        "id": "supp-1",
        "num": "1",
        "title": "Alcance del soporte técnico y rol del Proveedor SED",
        "text": "El soporte técnico para Sound Event Detector (SED) opera bajo un modelo por niveles: (a) Atención de consultas básicas, instalación de SW y HW, configuración inicial, verificación de montaje y capacitación del usuario para la correcta instalación son suministradas por el Proveedor Autorizado de SED; (b) El soporte técnico del producto y la integración en sistemas VMS corresponden al Proveedor SED en coordinación con JALUD; (c) El soporte de servicio sobre hardware dedicado de JALUD Embedded es obligatorio para preservar el rendimiento garantizado, la estabilidad de los modelos neuronales y la vigencia de la garantía."
      },
      {
        "id": "supp-2",
        "num": "2",
        "title": "Adaptación al entorno acústico y garantía de falsas alarmas",
        "text": "En el marco del soporte activo, JALUD Embedded ofrece: (a) Adaptación y calibración experta de los parámetros del Dispositivo al entorno acústico específico del cliente; (b) Diagnóstico y ajuste de umbrales algorítmicos ante incidencias de falsas alarmas, garantizando una tolerancia operativa media de máximo 3 falsas alarmas por dispositivo y día en condiciones estándar."
      },
      {
        "id": "supp-3",
        "num": "3",
        "title": "Actualizaciones de software, modelos neuronales y nuevas clases sonoras",
        "text": "Condiciones de actualización: (a) El cliente tiene derecho a actualizaciones de software para los Dispositivos ya suministrados, incorporando mejoras para las clases de sonido adquiridas (rotura de cristales, disparos, gritos de pánico, agresión) — mayor robustez frente a ruidos parásitos, mayor sensibilidad y alcance. Estas actualizaciones son gratuitas; (b) Las actualizaciones de SED Presentation y SED Control son igualmente gratuitas."
      },
      {
        "id": "supp-4",
        "num": "4",
        "title": "Dual Verification en servidor, conectividad VMS y triangulación acústica",
        "text": "Para despliegues de cámaras e infraestructura avanzada: (a) Dual Verification en servidor (SED Server) — verificación secundaria en servidor con una red neuronal de mayor capacidad que reduce las falsas alarmas aproximadamente un 50 % adicional frente a la evaluación en cámara (ACAP/HEOP); (b) Compatibilidad nativa con alarmas y transmisiones ONVIF de audio/vídeo; (c) Interfaces RestAPI, FCM, SIA DC-09 y ConnectID para integración con VMS (Genetec, Milestone, Avigilon); (d) Cálculo automático de coordenadas espaciales (triangulación acústica) del agresor o víctima cuando un evento es captado por al menos 3 dispositivos SED exteriores."
      },
      {
        "id": "supp-5",
        "num": "5",
        "title": "Consecuencias de la no contratación o expiración del soporte",
        "text": "En caso de no contratar o permitir el vencimiento del soporte: (a) El cliente pierde el derecho a adaptación acústica, garantía de tasa máxima de falsas alarmas y triangulación espacial; (b) El servicio expira y no puede aplicarse retroactivamente a productos anteriormente adquiridos sin tarifa de reactivación y auditoría previa."
      },
      {
        "id": "supp-6",
        "num": "6",
        "title": "Versiones de software soportadas",
        "text": "Soporte completo para la versión principal actual (N) y la anterior (N-1)."
      },
      {
        "id": "supp-7",
        "num": "7",
        "title": "Canales y horario de atención",
        "text": "Lunes a viernes de 09:00 a 17:00 CET/CEST (laborables en la República Checa) a través del portal de Helpdesk o email: <span class=\"sed-obf-email\" data-u=\"c3VwcG9ydA==\" data-d=\"amFsdWQtZW1iZWRkZWQuY29t\" data-t=\"c3VwcG9ydEBqYWx1ZC1lbWJlZGRlZC5jb20=\" style=\"color: var(--blue-primary); text-decoration: none; font-weight: 600;\"><span class=\"sed-obf-fallback\">support [at] jalud-embedded.com</span></span>."
      },
      {
        "id": "supp-8",
        "num": "8",
        "title": "Niveles de gravedad y tiempos objetivo",
        "text": "Gravedad 1 (Crítica – Caída total): respuesta objetivo <strong>en 4 horas laborables</strong>. Gravedad 2 (Alta): <strong>en 8 horas laborables</strong>. Gravedad 3 (Media): <strong>en 2 días laborables</strong>. Gravedad 4 (Baja / Consulta): <strong>en 5 días laborables</strong>."
      },
      {
        "id": "supp-9",
        "num": "9",
        "title": "Cooperación del cliente",
        "text": "El cliente debe facilitar logs de diagnóstico, pasos de reproducción y acceso remoto seguro cuando sea necesario."
      },
      {
        "id": "supp-10",
        "num": "10",
        "title": "Exclusiones de soporte",
        "text": "No cubre hardware defectuoso de terceros, micrófonos dañados, intervenciones presenciales no contratadas ni modificaciones de software."
      },
      {
        "id": "supp-11",
        "num": "11",
        "title": "Política de fin de soporte (EOL)",
        "text": "Los avisos de retirada de versiones se comunican con al menos 6 meses de antelación."
      }
    ],
    "crossLinksTitle": "Documentos relacionados",
    "crossLinks": [
      {
        "route": "eula",
        "name": "Acuerdo de Licencia EULA",
        "desc": "Términos de software"
      },
      {
        "route": "terms-and-conditions",
        "name": "Términos y Condiciones",
        "desc": "Garantía comercial de hardware"
      },
      {
        "route": "product-privacy",
        "name": "Privacidad del Producto",
        "desc": "Tratamiento técnico de datos"
      },
      {
        "route": "policy-ims",
        "name": "Política IMS",
        "desc": "Gestión de calidad y seguridad"
      }
    ]
  },
  "pt": {
    "eyebrow": "SERVIÇOS DE SUPORTE & MANUTENÇÃO",
    "title": "Termos de Suporte e Manutenção",
    "subtitle": "Níveis de serviço, atualizações de modelos de IA e tempos-alvo de resposta da JALUD Embedded s.r.o.",
    "version": "Versão 2026.1 (Em vigor desde 1 de janeiro de 2026)",
    "tocTitle": "Índice de suporte",
    "companyDetails": "Prestador de suporte: JALUD Embedded s.r.o., Nepomucká 1355/261, 326 00 Plzeň, República Checa, NIF: 03056287",
    "preamble": "Os presentes Termos de Suporte e Manutenção definem as condições de assistência técnica e atualizações de software para o Sound Event Detector (SED) prestadas pela JALUD Embedded s.r.o.",
    "slaNoticeBadge": "Aviso sobre tempos de resposta",
    "slaNoticeText": "Os tempos-alvo de resposta representam objetivos operacionais e NÃO constituem tempos garantidos de resolução ou SLA vinculativo com penalidades sem um contrato de suporte específico.",
    "sections": [
      {
        "id": "supp-1",
        "num": "1",
        "title": "Âmbito do suporte técnico e função do Fornecedor SED",
        "text": "O suporte técnico do Sound Event Detector (SED) está estruturado em níveis de serviço: (a) Resolução de dúvidas operacionais básicas, instalação de SW e HW, configuração inicial e formação do utilizador para instalação correta são asseguradas pelo Fornecedor Autorizado SED; (b) O suporte técnico ao produto e integração em plataformas VMS competem ao Fornecedor SED em articulação com a JALUD; (c) O suporte de serviço sobre hardware dedicado da JALUD Embedded é obrigatório para assegurar a fiabilidade garantida, estabilidade das redes neuronais e validade da garantia."
      },
      {
        "id": "supp-2",
        "num": "2",
        "title": "Adaptação ao ambiente acústico e garantia de alarmes falsos",
        "text": "No âmbito do suporte ativo, a JALUD Embedded assegura: (a) Calibração e adaptação especializada dos parâmetros do Dispositivo às condições acústicas do cliente; (b) Resolução de anomalias e otimização de limiares em caso de alarmes excessivos, garantindo uma tolerância média máxima de 3 alarmes falsos por dispositivo ao dia em condições nominais."
      },
      {
        "id": "supp-3",
        "num": "3",
        "title": "Atualizações de software, modelos neuronais e novas classes de som",
        "text": "Diretrizes de atualização: (a) O cliente tem direito a upgrades de software para Dispositivos já fornecidos, abrangendo melhorias nas classes sonoras adquiridas (tiros, quebra de vidros, gritos de pânico, agressão) — maior imunidade a ruídos, sensibilidade refinada e maior alcance. Estas atualizações são gratuitas; (b) As atualizações para SED Presentation e SED Control são fornecidas sem custos adicionais."
      },
      {
        "id": "supp-4",
        "num": "4",
        "title": "Dual Verification em servidor, conectividade VMS e triangulação acústica",
        "text": "Para instalações com câmaras de segurança: (a) Dual Verification em servidor (SED Server) — verificação secundária em servidor com modelo neuronal avançado que reduz a taxa de alarmes falsos em cerca de 50 % adicionais face ao processamento na câmara (ACAP/HEOP); (b) Suporte a alarmes e fluxo de áudio/vídeo ONVIF; (c) Interfaces RestAPI, FCM, SIA DC-09 e ConnectID para integração com VMS (Genetec, Milestone, Avigilon); (d) Triangulação acústica automática e cálculo de coordenadas da fonte sonora (agressor ou vítima) quando o evento é detetado por pelo menos 3 dispositivos SED exteriores."
      },
      {
        "id": "supp-5",
        "num": "5",
        "title": "Consequências da não subscrição ou cessação do suporte",
        "text": "Caso o suporte não seja contratado ou expire sem renovação: (a) O cliente perde o direito à calibração acústica, garantia de tolerância a alarmes falsos e triangulação espacial; (b) O suporte caduca e não pode ser reativado retroativamente para dispositivos existentes sem taxa de reativação e auditoria técnica."
      },
      {
        "id": "supp-6",
        "num": "6",
        "title": "Versões de software suportadas",
        "text": "Suporte integral para a versão principal atual (N) e a versão anterior (N-1)."
      },
      {
        "id": "supp-7",
        "num": "7",
        "title": "Canais de suporte e horário",
        "text": "Segunda a sexta-feira, das 09:00 às 17:00 CET/CEST (dias úteis na Chéquia) via portal de Helpdesk ou por email: <span class=\"sed-obf-email\" data-u=\"c3VwcG9ydA==\" data-d=\"amFsdWQtZW1iZWRkZWQuY29t\" data-t=\"c3VwcG9ydEBqYWx1ZC1lbWJlZGRlZC5jb20=\" style=\"color: var(--blue-primary); text-decoration: none; font-weight: 600;\"><span class=\"sed-obf-fallback\">support [at] jalud-embedded.com</span></span>."
      },
      {
        "id": "supp-8",
        "num": "8",
        "title": "Níveis de severidade e tempos-alvo",
        "text": "Severidade 1 (Crítica – Paragem total): resposta-alvo <strong>em 4 horas úteis</strong>. Severidade 2 (Alta): <strong>em 8 horas úteis</strong>. Severidade 3 (Média): <strong>em 2 dias úteis</strong>. Severidade 4 (Baixa / Dúvida): <strong>em 5 dias úteis</strong>."
      },
      {
        "id": "supp-9",
        "num": "9",
        "title": "Cooperação do cliente",
        "text": "O cliente deve fornecer ficheiros de registo (logs), passos de reprodução e acesso remoto quando solicitado."
      },
      {
        "id": "supp-10",
        "num": "10",
        "title": "Exclusões de suporte",
        "text": "Não abrange avarias de hardware de terceiros, microfones com danos físicos nem deslocações presenciais sem contrato próprio."
      },
      {
        "id": "supp-11",
        "num": "11",
        "title": "Política de descontinuação (EOL)",
        "text": "Comunicação de descontinuação de versões com aviso prévio mínimo de 6 meses."
      }
    ],
    "crossLinksTitle": "Documentos associados",
    "crossLinks": [
      {
        "route": "eula",
        "name": "Contrato de Licença EULA",
        "desc": "Termos de licenciamento do software"
      },
      {
        "route": "terms-and-conditions",
        "name": "Termos e Condições",
        "desc": "Garantia de hardware e termos comerciais"
      },
      {
        "route": "product-privacy",
        "name": "Privacidade do Produto",
        "desc": "Gestão técnica de dados de diagnóstico"
      },
      {
        "route": "policy-ims",
        "name": "Política IMS",
        "desc": "Gestão de qualidade e segurança"
      }
    ]
  },
  "ar": {
    "eyebrow": "سياسات الدعم الفني والصيانة",
    "title": "شروط الدعم والصيانة",
    "subtitle": "نطاق الدعم الفني، وتحديثات نماذج الذكاء الاصطناعي، وتصنيف شدة الأعطال وأوقات الاستجابة المستهدفة من شركة JALUD Embedded s.r.o.",
    "version": "الإصدار 2026.1 (يسري اعتباراً من 1 يناير 2026)",
    "tocTitle": "فهرس بنود الدعم",
    "companyDetails": "مقدم الدعم: JALUD Embedded s.r.o.، العنوان: Nepomucká 1355/261, 326 00 Plzeň، الجمهورية التشيكية، السجل: 03056287",
    "preamble": "تحدد شروط الدعم والصيانة هذه آليات تقديم خدمات المساعدة التقنية وتحديثات البرمجيات وتحديثات النماذج العصبية لنظام Sound Event Detector (SED) من شركة JALUD Embedded s.r.o.",
    "slaNoticeBadge": "تنويه هام بشأن أوقات الاستجابة",
    "slaNoticeText": "تمثل أوقات الاستجابة المستهدفة المذكورة أهدافاً تشغيلية لفريق الدعم للبدء في التشخيص، ولا تشكل أوقاتاً مضمونة لحل المشكلات أو اتفاقية مستوى خدمة (SLA) ملزمة مالياً ما لم يتم إبرام اتفاقية خدمة مخصصة خطياً.",
    "sections": [
      {
        "id": "supp-1",
        "num": "١",
        "title": "نطاق خدمات الدعم الفني ودور مورد نظام SED",
        "text": "يتم تنظيم الدعم الفني لنظام Sound Event Detector (SED) وفق نموذج متعدد المستويات: (أ) يتولى مورد نظام SED المعتمد الرد على الاستفسارات الأساسية، وتثبيت البرمجيات والعتاد، وإعداد تسجيل الدخول الأولي، وتدريب المستخدم لضمان التثبيت الصحيح؛ (ب) يقدم مورد SED الدعم الفني للمنتج والتكامل مع أنظمة VMS بالتنسيق مع JALUD؛ (ج) يعد الاشتراك في الدعم الفني لأجهزة العتاد المخصصة من شركة JALUD Embedded إلزامياً لضمان دقة الكشف واستقرار النماذج العصبية وسريان الضمان."
      },
      {
        "id": "supp-2",
        "num": "٢",
        "title": "التكيف مع البيئة الصوتية وضمان الحد من الإنذارات الخاطئة",
        "text": "تقدم شركة JALUD Embedded ضمن الدعم الفني الفعال: (أ) التكييف والضبط الدقيق لمعايير الجهاز بما يتناسب مع البيئة الصوتية الخاصة بالعميل؛ (ب) معالجة الحالات غير الطبيعية وضبط عتبات الكشف في حال صدور إنذارات خاطئة، مع ضمان ألا يتجاوز متوسط الإنذارات الخاطئة 3 إنذارات لكل جهاز يومياً في الظروف التشغيلية الموصى بها."
      },
      {
        "id": "supp-3",
        "num": "٣",
        "title": "ترقيات البرمجيات وصيانة النماذج العصبية وفئات الأصوات الجديدة",
        "text": "قواعد التحديث والترقية: (أ) يحق للعميل الحصول على ترقيات البرمجيات للأجهزة الموردة سابقاً، متضمنة تحسينات لفئات الأصوات المشتراة (كسر الزجاج، إطلاق النار، صراخ الذعر، العدوان اللفظي) مثل رفع المناعة ضد الضوضاء وزيادة الحساسية ومدى الكشف، وتتاح هذه التحديثات مجاناً؛ (ب) تتاح تحديثات أدوات SED Presentation و SED Control مجاناً."
      },
      {
        "id": "supp-4",
        "num": "٤",
        "title": "التحقق المزدوج على الخادم والتكامل مع VMS والتثليث الصوتي",
        "text": "لأنظمة الكاميرات والبنية التحتية المتقدمة: (أ) التحقق المزدوج على الخادم (SED Server) — تدقيق إضافي للكشف القادم من الكاميرات باستخدام نموذج عصبي فائق الضخامة، مما يخفض الإنذارات الخاطئة بنسبة 50% إضافية مقارنة بالمعالجة المباشرة على الكاميرا (ACAP/HEOP)؛ (ب) دعم بث إنذارات وصوت/فيديو ONVIF القياسي؛ (ج) دعم واجهات RestAPI و FCM و SIA DC-09 و ConnectID للتكامل مع أنظمة VMS (مثل Genetec و Milestone و Avigilon)؛ (د) التثليث الصوتي التلقائي وتحديد الإحداثيات المكانية لمصدر الصوت (المهاجم أو الضحية) فور رصد الحدث بواسطة 3 أجهزة SED خارجية على الأقل."
      },
      {
        "id": "supp-5",
        "num": "٥",
        "title": "آثار عدم الاشتراك في الدعم أو انتهاء صلاحيته",
        "text": "في حال عدم التعاقد على الدعم أو انقضائه دون تجديد: (أ) يفقد العميل حقه في ضبط النماذج على البيئة الصوتية، وضمان الحد الأقصى للإنذارات الخاطئة، والتثليث المكاني للأحداث؛ (ب) يسقط حق الدعم بانتهاء مدته ولا يمكن تطبيقه بأثر رجعي على المنتجات المباعة سابقاً دون سداد رسوم إعادة التفعيل وإجراء فحص فني."
      },
      {
        "id": "supp-6",
        "num": "٦",
        "title": "إصدارات البرمجيات المدعومة",
        "text": "يتم تقديم الدعم الكامل للإصدار الرئيسي الحالي (N) والإصدار السابق له مباشرة (N-1)."
      },
      {
        "id": "supp-7",
        "num": "٧",
        "title": "قنوات الدعم الفني وساعات العمل",
        "text": "من الاثنين إلى الجمعة، من الساعة 09:00 حتى 17:00 بتوقيت وسط أوروبا (باستثناء العطلات الرسمية في التشيك) عبر بوابة الدعم أو البريد الإلكتروني: <span class=\"sed-obf-email\" data-u=\"c3VwcG9ydA==\" data-d=\"amFsdWQtZW1iZWRkZWQuY29t\" data-t=\"c3VwcG9ydEBqYWx1ZC1lbWJlZGRlZC5jb20=\" style=\"color: var(--blue-primary); text-decoration: none; font-weight: 600;\"><span class=\"sed-obf-fallback\">support [at] jalud-embedded.com</span></span>."
      },
      {
        "id": "supp-8",
        "num": "٨",
        "title": "مستويات شدة الأعطال وأوقات الاستجابة المستهدفة",
        "text": "المستوى 1 (حرج – توقف كامل للنظام): الاستجابة المستهدفة <strong>خلال 4 ساعات عمل</strong>. المستوى 2 (مرتفع – انخفاض الكفاءة): <strong>خلال 8 ساعات عمل</strong>. المستوى 3 (متوسط – خلل محدود): <strong>خلال يومي عمل</strong>. المستوى 4 (منخفض – استفسار عام): <strong>خلال 5 أيام عمل</strong>."
      },
      {
        "id": "supp-9",
        "num": "٩",
        "title": "التزامات العميل بالتعاون",
        "text": "يتعين على العميل تزويد فريق الدعم بسجلات التشخيص (logs) وخطوات تكرار الخلل وتوفير الوصول الآمن عن بعد عند الحاجة."
      },
      {
        "id": "supp-10",
        "num": "١٠",
        "title": "استثناءات الدعم القياسي",
        "text": "لا يشمل الدعم عيوب عتاد الطرف الثالث أو تلف الميكروفونات المادي أو الزيارات الميدانية غير المتعاقد عليها مسبقاً."
      },
      {
        "id": "supp-11",
        "num": "١١",
        "title": "سياسة انتهاء الدعم (EOL)",
        "text": "يتم الإعلان عن إيقاف دعم الإصدارات القديمة بإشعار مسبق لا يقل عن 6 أشهر مع توفير مسارات ترقية للإصدارات الأحدث."
      }
    ],
    "crossLinksTitle": "الوثائق ذات الصلة",
    "crossLinks": [
      {
        "route": "eula",
        "name": "اتفاقية ترخيص المستخدم النهائي EULA",
        "desc": "شروط استخدام البرمجيات والترخيص"
      },
      {
        "route": "terms-and-conditions",
        "name": "الشروط والأحكام التجارية",
        "desc": "شروط التعاقد وضمان الأجهزة"
      },
      {
        "route": "product-privacy",
        "name": "خصوصية المنتج",
        "desc": "معالجة بيانات التشخيص والصيانة"
      },
      {
        "route": "policy-ims",
        "name": "سياسة IMS",
        "desc": "نظام إدارة الجودة وأمن المعلومات"
      }
    ]
  },
  "it": {
    "eyebrow": "SERVIZI DI SUPPORTO & ACCORDI SUI LIVELLI DI SERVIZIO",
    "title": "Termini di Supporto Tecnico e Manutenzione Software",
    "subtitle": "Livelli di servizio (SLA), tempi di risposta tecnici, aggiornamenti firmware, release dei modelli AI e ciclo di vita del supporto per i sistemi Sound Event Detector.",
    "version": "Versione 2026.1 (In vigore dal 1° gennaio 2026)",
    "tocTitle": "Indice dei Termini di Supporto",
    "companyDetails": "Fornitore del Supporto: JALUD Embedded s.r.o., Nepomucká 1355/261, 326 00 Plzeň, Repubblica Ceca, P.IVA: 03056287",
    "preamble": "I presenti Termini di Supporto Tecnico e Manutenzione (\"Termini di Supporto\") stabiliscono gli standard di assistenza, i tempi obiettivo di risposta (SLA) e le modalità di aggiornamento fornite da JALUD Embedded s.r.o. per i software e i dispositivi Sound Event Detector (SED) coperti da licenza valida o contratto di manutenzione attivo.",
    "slaNoticeBadge": "Avviso importante sui tempi di risposta",
    "slaNoticeText": "I tempi obiettivo di risposta costituiscono traguardi operativi del team tecnico per l'avvio della diagnosi e NON rappresentano tempi vincolanti di risoluzione né un accordo sui livelli di servizio (SLA) con penali senza apposito contratto integrativo.",
    "sections": [
      {
        "id": "supp-1",
        "num": "1",
        "title": "Ambito dei Servizi di Supporto e Ruolo del Fornitore SED",
        "text": "I servizi di assistenza tecnica per il sistema Sound Event Detector (SED) sono organizzati in un modello multilivello: (a) Gestione delle richieste operative di base, installazione software e hardware, configurazione iniziale dell'accesso, verifica della corretta installazione e formazione dell'utente finale sono garantite dal Fornitore Autorizzato SED; (b) Il supporto tecnico di prodotto, l'integrazione con sistemi VMS e la consulenza operativa sono forniti dal Fornitore SED in coordinamento con JALUD; (c) Il supporto di manutenzione sull'hardware dedicato prodotto da JALUD Embedded è obbligatorio per preservare le prestazioni garantite, la stabilità dei modelli neurali e la validità della garanzia."
      },
      {
        "id": "supp-2",
        "num": "2",
        "title": "Adattamento all'Ambiente Acustico e Tolleranza Falsi Allarmi",
        "text": "Nell'ambito del supporto attivo, JALUD Embedded assicura: (a) Adattamento e calibrazione specialistica dei parametri dei dispositivi in base allo specifico ambiente acustico del cliente (es. snodi viari urbani, contesti industriali, plessi scolastici); (b) Diagnosi e ottimizzazione delle soglie algoritmiche in caso di falsi allarmi, garantendo una tolleranza operativa media massima di 3 falsi allarmi al giorno per dispositivo, nel rispetto delle condizioni di installazione raccomandate."
      },
      {
        "id": "supp-3",
        "num": "3",
        "title": "Aggiornamenti Software, Manutenzione Modelli Neurali e Nuove Classi Sonore",
        "text": "Modalità di aggiornamento e rilascio modelli: (a) Il cliente ha diritto ai successivi aggiornamenti software per i Dispositivi già consegnati. Gli aggiornamenti includono il potenziamento dei modelli di classificazione per le categorie di suono già licenziate (rottura vetri, spari, urla di panico, aggressione verbale) — con maggiore immunità ai disturbi, sensibilità accresciuta e raggio di rilevamento esteso. Tali aggiornamenti sono gratuiti; (b) Gli aggiornamenti delle suite SED Presentation e SED Control sono forniti gratuitamente."
      },
      {
        "id": "supp-4",
        "num": "4",
        "title": "Dual Verification su Server, Connettività VMS e Triangolazione Acustica",
        "text": "Per impianti con telecamere e architetture centralizzate: (a) Dual Verification su SED Server — la validazione secondaria delle rilevazioni generate dalle telecamere avviene sull'infrastruttura server mediante una rete neurale ad alta capacità, riducendo i falsi allarmi di un ulteriore 50% circa rispetto all'analisi a bordo camera (ACAP/HEOP); (b) Supporto completo dello streaming audio/video e degli allarmi ONVIF; (c) Interfacce standard RestAPI, FCM (Firebase Cloud Messaging), SIA DC-09 e ConnectID per l'integrazione fluida nei VMS (Genetec Security Center, Milestone XProtect, Avigilon Control Center, ecc.); (d) Determinazione automatica delle coordinate spaziali (triangolazione acustica) della fonte sonora (aggressore o vittima) quando l'evento acustico è rilevato da almeno 3 dispositivi SED da esterno."
      },
      {
        "id": "supp-5",
        "num": "5",
        "title": "Conseguenze della Mancata Sottoscrizione o Scadenza del Supporto",
        "text": "In caso di mancata sottoscrizione o di mancato rinnovo del servizio di supporto: (a) Il cliente perde il diritto all'adattamento acustico dei modelli, decade la garanzia sui falsi allarmi medi giornalieri e viene disattivata la triangolazione/localizzazione; (b) Il supporto scade e non può essere applicato retroattivamente su prodotti e dispositivi precedentemente acquistati senza il pagamento del diritto di riattivazione e audit tecnico dell'impianto."
      },
      {
        "id": "supp-6",
        "num": "6",
        "title": "Versioni Software Supportate",
        "text": "Viene garantito il supporto completo per la versione principale corrente (N) e per la versione immediatamente precedente (N-1)."
      },
      {
        "id": "supp-7",
        "num": "7",
        "title": "Canali di Assistenza e Segnalazione Incidenti",
        "text": "Le richieste di assistenza tecnica devono essere trasmesse tramite il portale di ticketing dedicato o via e-mail all'indirizzo <span class=\"sed-obf-email\" data-u=\"c3VwcG9ydA==\" data-d=\"amFsdWQtZW1iZWRkZWQuY29t\" data-t=\"c3VwcG9ydEBqYWx1ZC1lbWJlZGRlZC5jb20=\" style=\"color: var(--blue-primary); text-decoration: none; font-weight: 600;\"><span class=\"sed-obf-fallback\">support [at] jalud-embedded.com</span></span>. Il desk operativo è attivo nei giorni feriali dal lunedì al venerdì dalle 09:00 alle 17:00 CET."
      },
      {
        "id": "supp-8",
        "num": "8",
        "title": "Livelli di Gravità e Tempi Obiettivo di Risposta (SLA)",
        "text": "Gli incidenti vengono classificati in: a) Critico (blocco totale del rilevamento su impianti di produzione) – risposta iniziale entro 4 ore lavorative; b) Alto (degrado funzionale rilevante o malfunzionamento di specifici allarmi) – risposta entro 8 ore lavorative; c) Medio (anomalia circoscritta con soluzione temporanea) – risposta entro 2 giorni lavorativi; d) Basso (domande di configurazione o richieste ordinarie) – risposta entro 5 giorni lavorativi."
      },
      {
        "id": "supp-9",
        "num": "9",
        "title": "Prerequisiti per il Supporto e Responsabilità del Cliente",
        "text": "Il Cliente è tenuto a: mantenere il firmware delle telecamere e dei sistemi VMS compatibile con le specifiche JALUD; eseguire copie di backup delle proprie configurazioni; fornire log di sistema dettagliati e, se necessario, consentire un accesso remoto sicuro (es. VPN temporanea o sessione di desktop condiviso)."
      },
      {
        "id": "supp-10",
        "num": "10",
        "title": "Esclusioni e Servizi Professionali Fuori Ambito",
        "text": "Il supporto standard non comprende: interventi fisici on-site per reinstallazione cavi o microfoni; risoluzione di guasti all'infrastruttura di rete del Cliente; danni derivanti da modifiche non autorizzate del sistema; personalizzazioni di codice o integrazioni VMS non supportate."
      },
      {
        "id": "supp-11",
        "num": "11",
        "title": "Durata del Supporto, Rinnovi e Cessazione del Servizio (EOL)",
        "text": "I servizi di supporto hanno la durata indicata nell'ordine o nel contratto di licenza. JALUD garantisce il supporto di ciascuna versione software principale per almeno 6 mesi dal preavviso di dismissione (politica End-of-Life)."
      }
    ],
    "crossLinksTitle": "Documenti Legali Correlati",
    "crossLinks": [
      {
        "route": "eula",
        "name": "Licenza Utente Finale (EULA)",
        "desc": "Diritti e condizioni d'uso delle licenze software SED"
      },
      {
        "route": "terms-and-conditions",
        "name": "Termini e Condizioni Generali",
        "desc": "Fornitura di prodotti, garanzia hardware e condizioni contrattuali"
      },
      {
        "route": "product-privacy",
        "name": "Privacy del Prodotto SED",
        "desc": "Gestione e protezione dei flussi audio locali"
      },
      {
        "route": "policy-ims",
        "name": "Politica IMS (Qualità ISO 9001)",
        "desc": "Sistema integrato di gestione della qualità e conformità"
      }
    ]
  }
};

export const ethicsData = {
  cs: {
    version: 'Verze 2026.1 (Účinnost od 1. ledna 2026)',
    title: 'Etický kodex pro dodavatele a partnery',
    eyebrow: 'FIREMNÍ ODPOVĚDNOST, UDRŽITELNOST & ETICKÁ AI',
    subtitle: 'Etické zásady, standardy odpovědného podnikání a principy odpovědné umělé inteligence pro dodavatele a obchodní partnery společnosti JALUD Embedded s.r.o.',
    pdfBtn: 'Stáhnout PDF',
    pdfUrl: '/docs/legal/ETICKY_KODEX_DODAVATELE.pdf',
    intro: 'JALUD EMBEDDED, s.r.o. (dále JLD) dbá na sociální a obchodní zodpovědnost, s cílem dlouhodobě vytvářet hodnoty. Součástí tohoto přístupu je zapojení obchodních partnerů do strategie udržitelnosti.',
    sections: [
      {
        num: '1',
        title: 'Zacházení se zaměstnanci',
        text: 'JLD od obchodních partnerů požaduje dodržování právních předpisů a standardů OSN a ILO (Mezinárodní organizace práce), zákaz využívání dětské práce, rovnost příležitostí bez diskriminace, odmítání otroctví a nucené práce, respekt k odborům a zájmovým skupinám, dodržování právních předpisů v oblasti mezd a pracovní doby.'
      },
      {
        num: '2',
        title: 'Bezpečnost a ochrana zdraví',
        text: 'JLD požaduje, aby dodavatelé zajistili bezpečné pracovní prostředí, dodržovali legislativu o BOZP a přijali preventivní opatření na ochranu zdraví.'
      },
      {
        num: '3',
        title: 'Ochrana životního prostředí',
        text: 'JLD od obchodních partnerů očekává dodržování příslušných zákonů a nařízení, stejně jako i efektivní využívání zdrojů a bezpečných materiálů.'
      },
      {
        num: '4',
        title: 'Při jednání v obchodním prostředí',
        text: 'JLD prosazuje netolerování úplatků a manipulace, přijímání darů a pozvánek pouze v přiměřené hodnotě, rozhodování na základě objektivních kritérií, dodržování pravidel hospodářské soutěže a součinnost v boji proti praní špinavých peněz.'
      },
      {
        num: '5',
        title: 'Ochrana informací',
        text: 'Dodavatelé JLD jsou povinni chránit důvěrné informace a obchodní tajemství, zpracovávat osobní data v souladu s právními předpisy a využívat informace pouze k oprávněným účelům.'
      },
      {
        num: '6',
        title: 'Vztahy s dodavateli',
        text: 'JLD požaduje, aby její partneři přenesli zásady tohoto etického kodexu na své subdodavatele.'
      },
      {
        num: '7',
        title: 'Dodržování kodexu',
        text: 'Porušení zásad tohoto etického kodexu může vést k přehodnocení obchodního vztahu s dodavateli JLD s.r.o., ukončení spolupráce a případné náhradě škody.'
      },
      {
        num: '8',
        title: 'Oznámení porušení',
        text: 'Obchodní partneři jsou povinni hlásit podezření na porušení kodexu nebo právních předpisů oprávněnému zástupci JALUD EMBEDDED, s.r.o.'
      },
      {
        num: '9',
        title: 'Odpovědná a na člověka orientovaná umělá inteligence',
        text: 'JLD vyvíjí a nasazuje technologie akustické umělé inteligence s důrazem na etiku, asistivní charakter a lidský dohled. Software Sound Event Detector (SED) je nástrojem na podporu lidských operátorů a nenahrazuje lidské rozhodování. SED je striktně navržen tak, aby respektoval soukromí občanů: analyzuje zvukové vzorce lokálně na zařízení v reálném čase a neprovádí záznam lidské řeči. <strong>SED není navržen k identifikaci konkrétních mluvčích ani k provádění biometrické identifikace osob.</strong> JLD zakazuje zneužití svých technologií k diskriminačním účelům, nezákonnému sledování či potlačování lidských práv.'
      }
    ],
    crossLinksTitle: 'Související dokumentace',
    crossLinks: [
      { route: 'eula', name: 'Licenční smlouva EULA', desc: 'Podmínky užívání softwaru SED a asistivní role' },
      { route: 'product-privacy', name: 'Produktové soukromí a ochrana dat', desc: 'Technické principy ochrany soukromí u SED' },
      { route: 'policy-ims', name: 'Politika IMS (ISO 9001 / 27001)', desc: 'Certifikovaný integrovaný systém řízení' }
    ]
  },
  de: {
    version: 'Version 2026.1 (Gültig ab 1. Januar 2026)',
    title: 'Ethikkodex für Lieferanten und Partner',
    eyebrow: 'UNTERNEHMENSVERANTWORTUNG, NACHHALTIGKEIT & ETHISCHE KI',
    subtitle: 'Ethische Grundsätze, Standards und Prinzipien verantwortungsvoller künstlicher Intelligenz für Partner der JALUD Embedded s.r.o.',
    pdfBtn: 'PDF herunterladen',
    pdfUrl: '/docs/legal/ETHIKKODEX_LIEFERANTEN.pdf',
    intro: 'JALUD EMBEDDED, s.r.o. (im Folgenden JLD) legt großen Wert auf soziale und geschäftliche Verantwortung, mit dem Ziel, langfristig Werte zu schaffen. Ein Bestandteil dieses Ansatzes ist die Einbeziehung von Geschäftspartnern in die Nachhaltigkeitsstrategie.',
    sections: [
      {
        num: '1',
        title: 'Umgang mit Mitarbeitenden',
        text: 'JLD verlangt von seinen Geschäftspartnern die Einhaltung der gesetzlichen Vorschriften sowie der Standards der UN und der ILO (Internationale Arbeitsorganisation), das Verbot von Kinderarbeit, Chancengleichheit ohne Diskriminierung, die Ablehnung von Sklaverei und Zwangsarbeit, die Achtung von Gewerkschaften und Interessenvertretungen sowie die Einhaltung gesetzlicher Vorschriften zu Löhnen und Arbeitszeiten.'
      },
      {
        num: '2',
        title: 'Sicherheit und Gesundheitsschutz',
        text: 'JLD fordert von seinen Lieferanten, ein sicheres Arbeitsumfeld zu gewährleisten, die Arbeitsschutzvorschriften einzuhalten und vorbeugende Maßnahmen zum Schutz der Gesundheit zu ergreifen.'
      },
      {
        num: '3',
        title: 'Umweltschutz',
        text: 'JLD erwartet von seinen Geschäftspartnern die Einhaltung der einschlägigen Gesetze und Verordnungen sowie den effizienten Einsatz von Ressourcen und sicheren Materialien.'
      },
      {
        num: '4',
        title: 'Verhalten im geschäftlichen Umfeld',
        text: 'JLD setzt die Null-Toleranz gegenüber Bestechung und Manipulation durch, akzeptiert Geschenke und Einladungen nur in angemessenem Wert, trifft Entscheidungen auf Grundlage objektiver Kriterien, fordert die Einhaltung der Wettbewerbsregeln und die Mitwirkung im Kampf gegen Geldwäsche.'
      },
      {
        num: '5',
        title: 'Informationsschutz',
        text: 'Die Lieferanten von JLD sind verpflichtet, vertrauliche Informationen und Geschäftsgeheimnisse zu schützen, personenbezogene Daten gemäß den gesetzlichen Vorschriften zu verarbeiten und Informationen ausschließlich für rechtmäßige Zwecke zu verwenden.'
      },
      {
        num: '6',
        title: 'Beziehungen zu Unterlieferanten',
        text: 'JLD verlangt, dass seine Partner die Grundsätze dieses Ethikkodex an ihre Unterlieferanten weitergeben.'
      },
      {
        num: '7',
        title: 'Einhaltung des Kodex',
        text: 'Ein Verstoß gegen die Grundsätze dieses Ethikkodex kann zur Neubewertung der Geschäftsbeziehung mit den Lieferanten von JLD s.r.o., zur Beendigung der Zusammenarbeit und gegebenenfalls zu Schadensersatzforderungen führen.'
      },
      {
        num: '8',
        title: 'Meldung von Verstößen',
        text: 'Geschäftspartner sind verpflichtet, den Verdacht auf Verstöße gegen den Kodex oder gegen gesetzliche Vorschriften einem berechtigten Vertreter von JALUD EMBEDDED, s.r.o. zu melden.'
      },
      {
        num: '9',
        title: 'Verantwortungsvolle und menschenzentrierte künstliche Intelligenz',
        text: 'JLD entwickelt und implementiert akustische KI-Technologien unter Wahrung ethischer Grundsätze und menschlicher Aufsicht. Der Sound Event Detector (SED) dient als Assistenzsystem für Sicherheitskräfte und ersetzt keine menschlichen Entscheidungen. SED respektiert die Privatsphäre: Die akustische Analyse erfolgt lokal und flüchtig im Arbeitsspeicher ohne Aufzeichnung von Gesprächen. <strong>SED ist nicht darauf ausgelegt, einzelne Sprecher zu identifizieren oder biometrische Erkennung durchzuführen.</strong> JLD untersagt den Missbrauch seiner Technologien für diskriminierende Zwecke oder rechtswidrige Überwachung.'
      }
    ],
    crossLinksTitle: 'Zugehörige Dokumente',
    crossLinks: [
      { route: 'eula', name: 'Endbenutzer-Lizenzvereinbarung (EULA)', desc: 'Lizenzbedingungen für SED-Software' },
      { route: 'product-privacy', name: 'Produktdatenschutz', desc: 'Technische Datenschutz-Architektur' },
      { route: 'policy-ims', name: 'IMS-Richtlinie (ISO 9001 / 27001)', desc: 'Qualitäts- und Sicherheitszertifizierung' }
    ]
  },
  en: {
    version: 'Version 2026.1 (Effective January 1, 2026)',
    title: 'Code of Ethics for Suppliers & Partners',
    eyebrow: 'CORPORATE RESPONSIBILITY, SUSTAINABILITY & ETHICAL AI',
    subtitle: 'Ethical principles, responsible business conduct, and human-centred artificial intelligence standards for partners of JALUD Embedded s.r.o.',
    pdfBtn: 'Download PDF',
    pdfUrl: '/docs/legal/CODE_of_Ethics.pdf',
    intro: 'JALUD EMBEDDED, s.r.o. (hereinafter JLD) is committed to social and business responsibility with the goal of creating long-term value. As part of this approach, business partners are engaged in the sustainability strategy.',
    sections: [
      {
        num: '1',
        title: 'Treatment of Employees',
        text: 'JLD requires its business partners to comply with legal regulations and standards set by the UN and ILO (International Labour Organization), including the prohibition of child labor, ensuring equal opportunities without discrimination, rejecting slavery and forced labor, respecting trade unions and interest groups, and adhering to legal regulations on wages and working hours.'
      },
      {
        num: '2',
        title: 'Health & Safety',
        text: 'JLD requires suppliers to ensure a safe working environment, comply with occupational health and safety (OHS) regulations, and adopt preventive measures to protect employees\' well-being.'
      },
      {
        num: '3',
        title: 'Environmental Protection',
        text: 'JLD expects business partners to comply with relevant laws and regulations, as well as to use resources efficiently and handle materials safely.'
      },
      {
        num: '4',
        title: 'Business Conduct',
        text: 'JLD promotes zero tolerance for bribery and manipulation and expects the acceptance of gifts and invitations only within reasonable value, decision-making based on objective criteria, compliance with fair competition rules, and cooperation in the fight against money laundering.'
      },
      {
        num: '5',
        title: 'Information Protection',
        text: 'JLD suppliers must protect confidential information and trade secrets, handle personal data in accordance with legal regulations, and use information only for legitimate purposes.'
      },
      {
        num: '6',
        title: 'Supplier Relations',
        text: 'JLD requires its partners to extend the principles of this Code of Ethics to their subcontractors.'
      },
      {
        num: '7',
        title: 'Compliance with the Code',
        text: 'Violations of this Code of Ethics may lead to a review of the business relationship, termination of cooperation, and potential compensation for damages.'
      },
      {
        num: '8',
        title: 'Reporting Violations',
        text: 'Business partners are required to report any suspected violations of this Code or legal regulations to an authorized representative of JALUD EMBEDDED, s.r.o.'
      },
      {
        num: '9',
        title: 'Responsible and Human-Centred Artificial Intelligence',
        text: 'JLD develops and deploys acoustic artificial intelligence solutions anchored in ethics, human oversight, and transparent operation. Sound Event Detector (SED) serves as an assistive situational awareness tool and does not substitute for human judgment or verified command decisions. The technology operates under strict Privacy-by-Design principles: acoustic spectra are processed ephemerally in RAM without ambient speech recording. <strong>SED is not designed to identify individual speakers or perform biometric identification of persons.</strong> JLD strictly prohibits the deployment of its systems for discriminatory purposes, mass biometric surveillance, or the infringement of civil liberties.'
      }
    ],
    crossLinksTitle: 'Related Governance Documents',
    crossLinks: [
      { route: 'eula', name: 'End User License Agreement (EULA)', desc: 'Software licensing terms and assistive role' },
      { route: 'product-privacy', name: 'Product Privacy & Data Protection', desc: 'Technical edge privacy architecture' },
      { route: 'policy-ims', name: 'Policy IMS (ISO 9001 / 27001)', desc: 'Certified quality and security management framework' }
    ]
  },
  es: {
    version: 'Versión 2026.1 (Vigente a partir del 1 de enero de 2026)',
    title: 'Código de Ética para Proveedores y Socios',
    eyebrow: 'RESPONSABILIDAD CORPORATIVA, SOSTENIBILIDAD & IA ÉTICA',
    subtitle: 'Principios éticos, normas de conducta empresarial e inteligencia artificial centrada en el ser humano para socios de JALUD Embedded s.r.o.',
    pdfBtn: 'Descargar PDF (en inglés)',
    pdfUrl: '/docs/legal/CODE_of_Ethics.pdf',
    intro: 'JALUD EMBEDDED, s.r.o. (en adelante JLD) está comprometida con la responsabilidad social y comercial con el objetivo de generar valor a largo plazo. Como parte de este enfoque, los socios comerciales participan activamente en la estrategia de sostenibilidad.',
    sections: [
      {
        num: '1',
        title: 'Trato a los empleados',
        text: 'JLD exige a sus socios comerciales el cumplimiento de las normativas legales y los estándares de la ONU y la OIT (Organización Internacional del Trabajo), incluida la prohibición del trabajo infantil, la garantía de igualdad de oportunidades sin discriminación, el rechazo de la esclavitud y el trabajo forzoso, el respeto a los sindicatos y grupos de interés, y el cumplimiento de las regulaciones sobre salarios y jornadas laborales.'
      },
      {
        num: '2',
        title: 'Seguridad y salud en el trabajo',
        text: 'JLD exige que los proveedores garanticen un entorno de trabajo seguro, cumplan la legislación de seguridad y salud en el trabajo y adopten medidas preventivas para proteger la salud de sus trabajadores.'
      },
      {
        num: '3',
        title: 'Protección del medio ambiente',
        text: 'JLD espera que sus socios comerciales cumplan las leyes y reglamentos pertinentes, además de hacer un uso eficiente de los recursos y emplear materiales seguros.'
      },
      {
        num: '4',
        title: 'Conducta en el entorno empresarial',
        text: 'JLD promueve la tolerancia cero frente al soborno y la manipulación, y exige que la aceptación de regalos e invitaciones sea únicamente por un valor razonable, que las decisiones se tomen con criterios objetivos, que se respeten las normas de libre competencia y se colabore en la prevención del blanqueo de capitales.'
      },
      {
        num: '5',
        title: 'Protección de la información',
        text: 'Los proveedores de JLD están obligados a proteger la información confidencial y los secretos comerciales, a tratar los datos de carácter personal de conformidad con la legislación aplicable y a utilizar la información únicamente para fines legítimos.'
      },
      {
        num: '6',
        title: 'Relaciones con subproveedores',
        text: 'JLD exige que sus socios transmitan y apliquen los principios de este Código de Ética a sus propios subcontratistas y proveedores.'
      },
      {
        num: '7',
        title: 'Cumplimiento del Código',
        text: 'El incumplimiento de los principios de este Código de Ética puede dar lugar a la revisión de la relación comercial con los proveedores de JLD s.r.o., la rescisión de la cooperación y posibles reclamaciones de indemnización por daños y perjuicios.'
      },
      {
        num: '8',
        title: 'Notificación de infracciones',
        text: 'Los socios comerciales tienen la obligación de comunicar cualquier sospecha de infracción del Código o de la legislación aplicable a un representante autorizado de JALUD EMBEDDED, s.r.o.'
      },
      {
        num: '9',
        title: 'Inteligencia Artificial Responsable y Centrada en el Ser Humano',
        text: 'JLD desarrolla e implementa tecnología de inteligencia artificial acústica bajo principios de ética, supervisión humana y transparencia. Sound Event Detector (SED) es una herramienta analítica asistencial que no reemplaza las decisiones humanas. El sistema respeta la privacidad mediante procesamiento local sin almacenar conversaciones de voz. <strong>SED no está diseñado para identificar hablantes individuales ni para realizar identificación biométrica de personas.</strong> JLD prohíbe el uso de sus tecnologías con fines discriminatorios o vigilancia ilegal.'
      }
    ],
    crossLinksTitle: 'Documentos relacionados',
    crossLinks: [
      { route: 'eula', name: 'Acuerdo de Licencia EULA', desc: 'Términos de software' },
      { route: 'product-privacy', name: 'Privacidad del Producto', desc: 'Arquitectura técnica de SED' },
      { route: 'policy-ims', name: 'Política IMS (ISO 9001 / 27001)', desc: 'Gestión de calidad y seguridad' }
    ]
  },
  pt: {
    version: 'Versão 2026.1 (Em vigor desde 1 de janeiro de 2026)',
    title: 'Código de Ética para Fornecedores e Parceiros',
    eyebrow: 'RESPONSABILIDADE CORPORATIVA, SUSTENTABILIDADE & IA ÉTICA',
    subtitle: 'Princípios éticos, diretrizes de conduta corporativa e inteligência artificial centrada no ser humano para parceiros da JALUD Embedded s.r.o.',
    pdfBtn: 'Baixar PDF (em inglês)',
    pdfUrl: '/docs/legal/CODE_of_Ethics.pdf',
    intro: 'A JALUD EMBEDDED, s.r.o. (doravante JLD) preza pela responsabilidade social e corporativa com o objetivo de gerar valor sustentável a longo prazo. Parte fundamental dessa abordagem é o engajamento dos parceiros comerciais na estratégia de sustentabilidade.',
    sections: [
      {
        num: '1',
        title: 'Tratamento dos colaboradores',
        text: 'A JLD exige de seus parceiros comerciais o cumprimento estrito das disposições legais e das normas da ONU e da OIT (Organização Internacional do Trabalho), vedando o trabalho infantil, garantindo a igualdade de oportunidades sem discriminação, repudiando o trabalho escravo ou forçado, respeitando os sindicatos e entidades de classe, e cumprindo a legislação relativa a salários e jornada de trabalho.'
      },
      {
        num: '2',
        title: 'Segurança e saúde no trabalho',
        text: 'A JLD exige que os fornecedores garantam um ambiente de trabalho seguro, cumpram a legislação de segurança e saúde ocupacional e adotem medidas preventivas eficazes para a proteção da saúde.'
      },
      {
        num: '3',
        title: 'Proteção ambiental',
        text: 'A JLD espera que seus parceiros comerciais cumpram as leis e regulamentos ambientais aplicáveis, além de promover o uso eficiente de recursos e o manuseio de materiais seguros.'
      },
      {
        num: '4',
        title: 'Conduta no ambiente de negócios',
        text: 'A JLD adota tolerância zero contra suborno e manipulação, aceitando presentes e convites somente dentro de valores estritamente razoáveis, fundamentando decisões em critérios objetivos, respeitando as regras da livre concorrência e cooperando no combate à lavagem de dinheiro.'
      },
      {
        num: '5',
        title: 'Proteção de informações',
        text: 'Os fornecedores da JLD são obrigados a proteger informações confidenciais e segredos comerciais, a tratar dados pessoais em total conformidade com a legislação e a utilizar as informações apenas para finalidades autorizadas.'
      },
      {
        num: '6',
        title: 'Relações com subfornecedores',
        text: 'A JLD requer que seus parceiros repassem e exijam a aplicação dos princípios deste Código de Ética aos seus respectivos subcontratados.'
      },
      {
        num: '7',
        title: 'Cumprimento do Código',
        text: 'A violação dos princípios deste Código de Ética poderá acarretar a reavaliação da relação comercial com a JLD s.r.o., a rescisão da cooperação e eventuais reparações por perdas e danos.'
      },
      {
        num: '8',
        title: 'Comunicação de infrações',
        text: 'Os parceiros comerciais têm o dever de reportar qualquer suspeita de violação do Código ou das normas legais a um representante autorizado da JALUD EMBEDDED, s.r.o.'
      },
      {
        num: '9',
        title: 'Inteligência Artificial Responsável e Centrada no Ser Humano',
        text: 'A JLD desenvolve e implementa inteligência artificial acústica pautada pela ética, supervisão humana e respeito aos direitos fundamentais. O Sound Event Detector (SED) atua como tecnologia assistiva, sem substituir o discernimento e a decisão humana. O processamento realiza-se localmente sem armazenamento de conversação humana. <strong>O SED não foi concebido para identificar oradores individuais nem efetuar identificação biométrica de pessoas.</strong> A JLD proíbe terminantemente a utilização de suas soluções para fins discriminatórios ou vigilância ilícita.'
      }
    ],
    crossLinksTitle: 'Documentos associados',
    crossLinks: [
      { route: 'eula', name: 'Contrato de Licença EULA', desc: 'Termos de licenciamento de software' },
      { route: 'product-privacy', name: 'Privacidade do Produto', desc: 'Arquitetura técnica do SED' },
      { route: 'policy-ims', name: 'Política IMS (ISO 9001 / 27001)', desc: 'Sistema de gestão de qualidade e segurança' }
    ]
  },
  ar: {
    version: 'الإصدار 2026.1 (يسري اعتباراً من 1 يناير 2026)',
    title: 'ميثاق الشرف الأخلاقي للموردين والشركاء',
    eyebrow: 'المسؤولية المؤسسية، الاستدامة & الذكاء الاصطناعي الأخلاقي',
    subtitle: 'المبادئ والمعايير الأخلاقية ومبادئ الذكاء الاصطناعي المتمحور حول الإنسان لشركاء وموردي شركة JALUD Embedded s.r.o.',
    pdfBtn: 'تحميل ملف PDF (باللغة الإنجليزية)',
    pdfUrl: '/docs/legal/CODE_of_Ethics.pdf',
    intro: 'تلتزم شركة JALUD EMBEDDED, s.r.o. (المشار إليها فيما يلي بـ JLD) بالمسؤولية الاجتماعية والتجارية بهدف خلق قيمة طويلة الأجل. ويشكل إشراك الشركاء التجاريين في استراتيجية الاستدامة جزءاً أساسياً من هذا النهج.',
    sections: [
      {
        num: '1',
        title: 'معاملة الموظفين',
        text: 'تطلب JLD من شركائها التجاريين الامتثال للأنظمة القانونية ومعايير الأمم المتحدة ومنظمة العمل الدولية (ILO)، وحظر تشغيل الأطفال، وضمان تكافؤ الفرص دون تمييز، ورفض السخرة والعمل القسري، واحترام النقابات ومجموعات المصالح، والالتزام بالقوانين المنظمة للأجور وساعات العمل.'
      },
      {
        num: '2',
        title: 'السلامة والصحة المهنية',
        text: 'تطلب JLD من الموردين توفير بيئة عمل آمنة، والامتثال للتشريعات المنظمة للصحة والسلامة المهنية، واتخاذ تدابير وقائية لحماية الصحة.'
      },
      {
        num: '3',
        title: 'حماية البيئة',
        text: 'تتوقع JLD من شركائها التجاريين الالتزام بجميع القوانين واللوائح المعمول بها، بالإضافة إلى الاستخدام الفعال للموارد والمواد الآمنة.'
      },
      {
        num: '4',
        title: 'السلوك في بيئة الأعمال',
        text: 'تنتهج JLD سياسة عدم التسامح مطلقاً مع الرشوة والتلاعب، وتقتصر على قبول الهدايا والدعوات ذات القيمة المعقولة فقط، واتخاذ القرارات بناءً على معايير موضوعية، والالتزام بقواعد المنافسة العادلة، والتعاون الفعال في مكافحة غسيل الأموال.'
      },
      {
        num: '5',
        title: 'حماية المعلومات',
        text: 'يلتزم موردو JLD بحماية المعلومات السرية والأسرار التجارية، ومعالجة البيانات الشخصية بما يتوافق مع الأنظمة القانونية، واستخدام المعلومات للأغراض المصرح بها فقط.'
      },
      {
        num: '6',
        title: 'العلاقات مع الموردين من الباطن',
        text: 'تطلب JLD من شركائها نقل مبادئ هذا الميثاق الأخلاقي وفرضها على مقاوليهم ومورديهم من الباطن.'
      },
      {
        num: '7',
        title: 'الامتثال للميثاق',
        text: 'قد يؤدي انتهاك مبادئ هذا الميثاق الأخلاقي إلى مراجعة العلاقة التجارية مع موردي JLD s.r.o.، وإنهاء التعاون، والمطالبة بالتعويض عن الأضرار إن وجدت.'
      },
      {
        num: '8',
        title: 'الإبلاغ عن الانتهاكات',
        text: 'يتعين على الشركاء التجاريين إبلاغ الممثل المعتمد لشركة JALUD EMBEDDED, s.r.o. عن أي اشتباه في انتهاك الميثاق أو القوانين المعمول بها.'
      },
      {
        num: '9',
        title: 'الذكاء الاصطناعي المسؤول والمتمحور حول الإنسان',
        text: 'تلتزم JLD بتطوير ونشر تقنيات الذكاء الاصطناعي الصوتي وفقاً لمبادئ الأخلاق والإشراف البشري الكامل. يعد نظام SED أداة تحليلية مساعدة لا تحل محل التقدير البشري في اتخاذ القرارات الأمنية. يعمل النظام بموجب مبادئ الخصوصية الصارمة حيث تجري المعالجة الصوتية لحظياً دون تسجيل أحاديث البشر. <strong>لم يُصمم نظام SED للتعرف على هوية المتحدثين أو إجراء التحديد البيومتري للأشخاص.</strong> وتحظر JLD استخدام تقنياتها لأي أغراض تمييزية أو رقابة جماعية غير مشروعة.'
      }
    ],
    crossLinksTitle: 'الوثائق ذات الصلة',
    crossLinks: [
      { route: 'eula', name: 'اتفاقية ترخيص المستخدم النهائي EULA', desc: 'شروط استخدام البرمجيات والترخيص' },
      { route: 'product-privacy', name: 'خصوصية المنتج وحماية البيانات', desc: 'معالجة الصوت في الذاكرة المؤقتة' },
      { route: 'policy-ims', name: 'سياسة IMS (ISO 9001 / 27001)', desc: 'نظام إدارة الجودة وأمن المعلومات' }
    ]
  }
,
  it: {
    "eyebrow": "RESPONSABILITÀ SOCIALE & INTELLIGENZA ARTIFICIALE",
    "title": "Codice Etico e Principi dell'Intelligenza Artificiale",
    "subtitle": "I principi etici fondamentali di JALUD Embedded per lo sviluppo di intelligenza artificiale acustica affidabile, trasparente e a tutela della vita umana.",
    "version": "Versione 2026.1 (In vigore dal 1° gennaio 2026)",
    "tocTitle": "Indice del Codice Etico",
    "companyDetails": "JALUD Embedded s.r.o., Nepomucká 1355/261, 326 00 Plzeň, Repubblica Ceca, IČO: 03056287",
    "preamble": "In JALUD Embedded s.r.o. crediamo fermamente che le tecnologie di intelligenza artificiale debbano essere concepite al servizio della sicurezza e della dignità umana. Il presente Codice Etico definisce gli impegni inderogabili che guidano la progettazione, l'addestramento dei modelli e la commercializzazione della tecnologia Sound Event Detector.",
    "sections": [
      {
        "id": "eth-1",
        "num": "1",
        "title": "Impegno per la Sicurezza Umana e l'Integrità Etica",
        "text": "Il nostro obiettivo primario è salvare vite umane consentendo interventi tempestivi in situazioni di pericolo estremo (spari, aggressioni violente, disastri). Rifiutiamo qualsiasi sviluppo tecnologico che metta a rischio i diritti civili o la riservatezza individuale."
      },
      {
        "id": "eth-2",
        "num": "2",
        "title": "IA Centrata sull'Umano e Supervisione Operativa (Human-in-the-Loop)",
        "text": "I sistemi di intelligenza artificiale JALUD sono progettati come strumenti assistivi per migliorare la consapevolezza della situazione degli operatori di sicurezza, e non come agenti decisionali autonomi. Qualsiasi azione coercitiva o intervento delle forze dell'ordine deve essere sempre valutato e autorizzato da un operatore umano qualificato."
      },
      {
        "id": "eth-3",
        "num": "3",
        "title": "Trasparenza, Spiegabilità e Limiti dell'AI Acustica",
        "text": "Comunichiamo chiaramente ai nostri clienti, partner e al pubblico le reali capacità e i limiti tecnici dei nostri sistemi. Rifiutiamo affermazioni commerciali ingannevoli o esagerate riguardo a percentuali assolute di rilevamento, ricordando la natura probabilistica dell'apprendimento automatico acustico."
      },
      {
        "id": "eth-4",
        "num": "4",
        "title": "Privacy by Design e Rifiuto della Sorveglianza Invasiva",
        "text": "La nostra tecnologia non ascolta le conversazioni umane, non le trascrive e non identifica gli individui. Rifiutiamo di sviluppare funzionalità volte all'intercettazione ambientale occulta o alla sorveglianza delle opinioni dei cittadini."
      },
      {
        "id": "eth-5",
        "num": "5",
        "title": "Equità, Non Discriminazione ed Eliminazione dei Bias",
        "text": "Curiamo con rigore la raccolta e la validazione dei dataset acustici di addestramento per prevenire distorsioni sistematiche. I modelli di riconoscimento vocale delle urla di panico sono addestrati su campioni sonori eterogenei per età, genere e timbro vocale senza alcun pregiudizio etnico o demografico."
      },
      {
        "id": "eth-6",
        "num": "6",
        "title": "Affidabilità Tecnica, Robustezza e Sicurezza Informatica",
        "text": "Sottoponiamo i nostri algoritmi e dispositivi a continui collaudi operativi in condizioni ambientali avverse e applichiamo standard rigorosi di sicurezza cyber (ISO 27001) per impedire manomissioni o attacchi informatici."
      },
      {
        "id": "eth-7",
        "num": "7",
        "title": "Responsabilità Sociale, Tracciabilità e Governance",
        "text": "Manteniamo registri completi dei processi di sviluppo, test e collaudo dei modelli AI. La nostra governance aziendale garantisce un controllo costante della conformità etica e normativa delle soluzioni offerte."
      },
      {
        "id": "eth-8",
        "num": "8",
        "title": "Divieto di Usi Dannosi, Militari Offensivi e Repressivi",
        "text": "JALUD vieta espressamente l'utilizzo del software e dei dispositivi SED per fini bellici offensivi, per la persecuzione politica o per la violazione dei diritti umani sanciti dalla Convenzione Europea dei Diritti dell'Uomo."
      },
      {
        "id": "eth-9",
        "num": "9",
        "title": "Conformità con l'AI Act dell'Unione Europea",
        "text": "I nostri processi di sviluppo e gestione del ciclo di vita dei modelli AI sono allineati ai requisiti di trasparenza, robustezza, documentazione tecnica e gestione del rischio previsti dal Regolamento Europeo sull'Intelligenza Artificiale (EU AI Act)."
      }
    ],
    "crossLinksTitle": "Documenti Legali Correlati",
    "crossLinks": [
      {
        "route": "product-privacy",
        "name": "Privacy del Prodotto",
        "desc": "Specifiche tecniche di salvaguardia della privacy nei dispositivi SED"
      },
      {
        "route": "policy-ims",
        "name": "Politica IMS (ISO 9001 e ISO 27001)",
        "desc": "Impegni aziendali di qualità e sicurezza delle informazioni"
      },
      {
        "route": "eula",
        "name": "Licenza Utente Finale (EULA)",
        "desc": "Condizioni vincolanti di utilizzo del software e responsabilità"
      },
      {
        "route": "privacy-policy",
        "name": "Informativa sulla Privacy",
        "desc": "Informativa sul trattamento dei dati personali aziendali"
      }
    ]
  }
};


export const imsData = {
  cs: {
    version: 'Verze 2026.1 (Účinnost od 1. ledna 2026)',
    eyebrow: 'KVALITA A BEZPEČNOST INFORMACÍ',
    title: 'Politika integrovaného systému řízení (IMS)',
    subtitle: 'Zahrnuje požadavky norem ISO 9001:2015 a ISO/IEC 27001:2022.',
    dateStr: 'Plzeň, 6. února 2025',
    pdfBtn: 'Zobrazit anglický originál PDF →',
    pdfUrl: '/docs/legal/EN_SM_26_Politika_ISMS.pdf',
    sections: [
      {
        num: '1',
        title: 'QMS – Systém managementu kvality',
        text: 'Jsme plně oddáni porozumění a naplňování potřeb a požadavků našich zákazníků a zajištění nejvyšší kvality. Neustále zlepšujeme naše procesy, produkty a služby, abychom zajistili spolehlivost, bezpečnost a soulad s nejvyššími standardy. Naším cílem je dosáhnout nulového výskytu neshod v procesech, produktech a službách prostřednictvím systematického zavádění preventivních opatření a podpory kultury neustálého zlepšování.'
      },
      {
        num: '2',
        title: 'ISMS – Systém řízení bezpečnosti informací',
        text: 'Jako společnost nakládající s citlivými informacemi a osobními údaji klademe na jejich ochranu nejvyšší prioritu. Identifikujeme a řídíme rizika bezpečnosti informací, dodržujeme zákonné požadavky včetně GDPR a směrnice NIS2 a pravidelně školíme zaměstnance v oblasti bezpečnosti a ochrany informací. Přístup k datům se řídí přísným principem „need-to-know“ a zásadou nejnižších nutných oprávnění. Naším cílem je dosáhnout nulového počtu bezpečnostních incidentů prostřednictvím účinné prevence, nepřetržitého monitorování a včasné reakce na potenciální hrozby.'
      },
      {
        num: '3',
        title: 'Společenská odpovědnost a udržitelnost',
        text: 'Uvědomujeme si svůj vliv na společnost a životní prostředí, a proto jednáme odpovědně a udržitelně ve všech aspektech našeho podnikání. Aktivně podporujeme iniciativy, které přispívají k ochraně života, majetku a zdraví, a současně minimalizujeme náš dopad na životní prostředí prostřednictvím opatření, jako je optimalizace spotřeby energie a zdrojů.'
      },
      {
        num: '4',
        title: 'Řízení rizik',
        text: 'Pravidelně provádíme analýzu rizik v rámci systémů ISMS i QMS a zavádíme opatření ke zmírnění identifikovaných hrozeb. Naším cílem je minimalizovat dopady rizik a snižovat pravděpodobnost vzniku incidentů.'
      },
      {
        num: '5',
        title: 'BCP – Plánování kontinuity provozu',
        text: 'Máme vytvořeny plány kontinuity činností a havarijní obnovy pro případ selhání systémů nebo kybernetických incidentů. Tyto plány jsou pravidelně testovány, aby byl zajištěn nepřetržitý provoz i během mimořádných událostí a minimalizován dopad krizových situací.'
      },
      {
        num: '6',
        title: 'Neustálé zlepšování',
        text: 'Pravidelně auditujeme a přezkoumáváme systémy ISMS a QMS, abychom zvyšovali jejich účinnost. Tím zajišťujeme soulad s normami ISO 9001 a ISO 27001 a neustále zvyšujeme úroveň řízení kvality a bezpečnosti.'
      },
      {
        num: '7',
        title: 'Zákonné požadavky',
        text: 'Důsledně dodržujeme platné právní předpisy a standardy v oblasti kvality a kybernetické bezpečnosti, čímž předcházíme právním a finančním důsledkům jejich případného neplnění.'
      },
      {
        num: '8',
        title: 'Rozvoj povědomí',
        text: 'Pravidelně provádíme školení v oblasti bezpečnosti informací a řízení kvality, abychom zvyšovali povědomí zaměstnanců o bezpečnostních a kvalitativních požadavcích, a tím omezili vliv lidského faktoru na vznik bezpečnostních a provozních incidentů.'
      },
      {
        num: '9',
        title: 'Závazek vedení společnosti',
        text: 'Vedení společnosti JALUD Embedded s.r.o. se zavazuje k aktivní podpoře ISMS a vyčlenění nezbytných zdrojů na jeho udržování. Naším cílem je zajistit odpovědné řízení bezpečnosti informací, snižovat bezpečnostní rizika a prosazovat kulturu bezpečnosti a kvality v celé společnosti.'
      }
    ]
  },
  de: {
    version: 'Version 2026.1 (Gültig ab 1. Januar 2026)',
    eyebrow: 'QUALITÄT UND INFORMATIONSSICHERHEIT',
    title: 'Politik des integrierten Managementsystems (IMS)',
    subtitle: 'Umfasst die Anforderungen der ISO 9001:2015 und der ISO/IEC 27001:2022.',
    dateStr: 'Plzeň, 6. Februar 2025',
    pdfBtn: 'Originaldokument als PDF anzeigen →',
    pdfUrl: '/docs/legal/Integrierte_Managementsystem_Politik_IMS.pdf',
    sections: [
      {
        num: '1',
        title: 'QMS – Qualitätsmanagementsystem',
        text: 'Wir verpflichten uns vollständig, die Bedürfnisse und Anforderungen unserer Kunden zu verstehen und zu erfüllen, um höchste Qualität sicherzustellen. Wir verbessern kontinuierlich unsere Prozesse, Produkte und Dienstleistungen, um Zuverlässigkeit, Sicherheit und die Einhaltung der höchsten Standards zu gewährleisten. Unser Ziel ist es, durch konsequente Umsetzung präventiver Maßnahmen und die Förderung einer Kultur der kontinuierlichen Verbesserung Null Prozess-, Produkt- und Dienstleistungsabweichungen zu erreichen.'
      },
      {
        num: '2',
        title: 'ISMS – Informationssicherheits-Managementsystem',
        text: 'Als Unternehmen, das sensible Informationen und personenbezogene Daten verarbeitet, hat der Schutz dieser Daten für uns höchste Priorität. Wir identifizieren und steuern Risiken in der Informationssicherheit, erfüllen gesetzliche Anforderungen einschließlich DSGVO und NIS2 und schulen unsere Mitarbeitenden regelmäßig in Sicherheit und Informationsschutz. Der Datenzugang folgt streng dem Need-to-know-Prinzip sowie dem Prinzip der geringsten Rechte. Unser Ziel ist es, durch wirksame Prävention, kontinuierliche Überwachung und rechtzeitige Reaktion auf potenzielle Bedrohungen Null Sicherheitsvorfälle zu erreichen.'
      },
      {
        num: '3',
        title: 'Soziale Verantwortung und Nachhaltigkeit',
        text: 'Wir sind uns unserer Auswirkungen auf Gesellschaft und Umwelt bewusst und handeln daher in allen Bereichen unseres Geschäfts verantwortungsbewusst und nachhaltig. Wir unterstützen aktiv Initiativen, die zum Schutz von Leben, Eigentum und Gesundheit beitragen, und minimieren gleichzeitig unsere Umweltbelastung, unter anderem durch Optimierung des Energie- und Ressourcenverbrauchs.'
      },
      {
        num: '4',
        title: 'Risikomanagement',
        text: 'Wir führen regelmäßige Risikoanalysen sowohl im ISMS als auch im QMS durch und setzen Maßnahmen zur Minderung identifizierter Risiken um. Unser Ziel ist es, die Auswirkungen potenzieller Risiken zu minimieren und die Wahrscheinlichkeit von Vorfällen zu reduzieren.'
      },
      {
        num: '5',
        title: 'BCP – Business Continuity Planning',
        text: 'Wir verfügen über Pläne zur Geschäftskontinuität und Wiederherstellung (Disaster Recovery) für den Fall von Systemausfällen oder Cybervorfällen. Diese Pläne werden regelmäßig getestet, um einen unterbrechungsfreien Betrieb bei Störungen sicherzustellen und die Auswirkungen von Krisensituationen zu minimieren.'
      },
      {
        num: '6',
        title: 'Kontinuierliche Verbesserung',
        text: 'Wir auditieren und überprüfen ISMS und QMS regelmäßig, um deren Wirksamkeit zu steigern. Dadurch gewährleisten wir die Einhaltung von ISO 9001 und ISO 27001 und verbessern kontinuierlich das Niveau unseres Qualitäts- und Sicherheitsmanagements.'
      },
      {
        num: '7',
        title: 'Gesetzliche Anforderungen',
        text: 'Wir halten alle relevanten gesetzlichen Vorgaben und Normen im Bereich Qualität und Cybersicherheit ein, um rechtliche und finanzielle Folgen bei Nichteinhaltung zu vermeiden.'
      },
      {
        num: '8',
        title: 'Bewusstseinsentwicklung',
        text: 'Wir führen regelmäßig Schulungen zur Informationssicherheit und zum Qualitätsmanagement durch, um das Bewusstsein der Mitarbeitenden für Sicherheits- und Qualitätsanforderungen zu stärken. Dadurch wird das Risiko menschlicher Fehler als Ursache von Sicherheits- und Qualitätsvorfällen reduziert.'
      },
      {
        num: '9',
        title: 'Engagement der Unternehmensleitung',
        text: 'Die Geschäftsleitung von JALUD Embedded s.r.o. verpflichtet sich, das ISMS aktiv zu unterstützen und die notwendigen Ressourcen für dessen Aufrechterhaltung bereitzustellen. Unser Ziel ist es, ein verantwortungsbewusstes Informationssicherheitsmanagement zu gewährleisten, Sicherheitsrisiken zu reduzieren und eine Kultur der Sicherheit und Qualität im Unternehmen zu fördern.'
      }
    ]
  },
  en: {
    version: 'Version 2026.1 (Effective January 1, 2026)',
    eyebrow: 'QUALITY AND INFORMATION SECURITY',
    title: 'Integrated Management System Policy (IMS)',
    subtitle: 'Includes the requirements of ISO 9001:2015 and ISO/IEC 27001:2022.',
    dateStr: 'Plzeň, 6 February 2025',
    pdfBtn: 'View the original PDF →',
    pdfUrl: '/docs/legal/EN_SM_26_Politika_ISMS.pdf',
    sections: [
      {
        num: '1',
        title: 'QMS – Quality Management System',
        text: 'We are fully committed to understanding and meeting our customers\' needs and requirements, ensuring the highest quality. We continuously improve our processes, products, and services to ensure reliability, security, and compliance with the highest standards. Our goal is to achieve zero process, product, and service nonconformities through systematic implementation of preventive measures and fostering a culture of continuous improvement.'
      },
      {
        num: '2',
        title: 'ISMS – Information Security Management System',
        text: 'As a company handling sensitive information and personal data, we prioritize their protection. We identify and manage information security risks, comply with legal requirements, including GDPR and NIS2, and regularly train employees in security and information protection. Data access follows the “need-to-know” principle and the principle of least privilege. Our goal is to achieve zero security incidents through effective prevention, continuous monitoring, and timely response to potential threats.'
      },
      {
        num: '3',
        title: 'Social Responsibility and Sustainability',
        text: 'We recognize our impact on society and the environment and therefore act responsibly and sustainably in all aspects of our business. We actively support initiatives that contribute to the protection of life, property, and health while minimizing our environmental impact through measures such as optimizing energy and resource consumption.'
      },
      {
        num: '4',
        title: 'Risk Management',
        text: 'We regularly conduct risk analysis in both ISMS and QMS, implementing measures to mitigate identified threats. Our objective is to minimize risk impact and reduce the likelihood of incidents.'
      },
      {
        num: '5',
        title: 'BCP – Business Continuity Planning',
        text: 'We have established business continuity and disaster recovery plans for system failures or cyber incidents. These plans are regularly tested to ensure uninterrupted operations during disruptions and to minimize the impact of crisis situations.'
      },
      {
        num: '6',
        title: 'Continuous Improvement',
        text: 'We regularly audit and review ISMS to enhance its effectiveness. This ensures compliance with ISO 9001 and ISO 27001, continuously improving the quality and security management levels.'
      },
      {
        num: '7',
        title: 'Legislation',
        text: 'We adhere to applicable laws and standards in quality and cybersecurity, preventing legal and financial consequences of non-compliance.'
      },
      {
        num: '8',
        title: 'Awareness Development',
        text: 'We regularly conduct training in information security and quality management to enhance employees’ awareness of security and quality requirements, thereby reducing human error as a factor in security and quality incidents.'
      },
      {
        num: '9',
        title: 'Management Commitment',
        text: 'The leadership of JALUD Embedded s.r.o. is committed to supporting ISMS and allocating the necessary resources to maintain it. Our goal is to ensure responsible information security management, reduce security risks, and promote a culture of security and quality within the company.'
      }
    ]
  },
  es: {
    version: 'Versión 2026.1 (Vigente a partir del 1 de enero de 2026)',
    eyebrow: 'CALIDAD Y SEGURIDAD DE LA INFORMACIÓN',
    title: 'Política del Sistema Integrado de Gestión (IMS)',
    subtitle: 'Incluye los requisitos de las normas ISO 9001:2015 e ISO/IEC 27001:2022.',
    dateStr: 'Plzeň, 6 de febrero de 2025',
    pdfBtn: 'Ver el documento original en inglés (PDF) →',
    pdfUrl: '/docs/legal/EN_SM_26_Politika_ISMS.pdf',
    sections: [
      {
        num: '1',
        title: 'QMS – Sistema de Gestión de la Calidad',
        text: 'Estamos plenamente comprometidos a comprender y satisfacer las necesidades y requisitos de nuestros clientes, garantizando la más alta calidad. Mejoramos continuamente nuestros procesos, productos y servicios para asegurar la fiabilidad, la seguridad y el cumplimiento de los estándares más exigentes. Nuestro objetivo es lograr cero no conformidades en procesos, productos y servicios mediante la aplicación sistemática de medidas preventivas y el fomento de una cultura de mejora continua.'
      },
      {
        num: '2',
        title: 'ISMS – Sistema de Gestión de Seguridad de la Información',
        text: 'Como empresa que maneja información confidencial y datos personales, priorizamos su estricta protección. Identificamos y gestionamos los riesgos de seguridad de la información, cumplimos los requisitos legales, incluidos el RGPD y la directiva NIS2, y capacitamos periódicamente a nuestros empleados en seguridad y protección de la información. El acceso a los datos sigue el principio de «necesidad de conocer» y el principio de mínimo privilegio. Nuestro objetivo es alcanzar cero incidentes de seguridad mediante la prevención eficaz, la supervisión continua y la respuesta oportuna ante posibles amenazas.'
      },
      {
        num: '3',
        title: 'Responsabilidad social y sostenibilidad',
        text: 'Reconocemos nuestro impacto en la sociedad y el medio ambiente y, por tanto, actuamos de manera responsable y sostenible en todos los aspectos de nuestro negocio. Apoyamos activamente iniciativas que contribuyen a la protección de la vida, la propiedad y la salud, minimizando al mismo tiempo nuestro impacto ambiental mediante medidas como la optimización del consumo de energía y recursos.'
      },
      {
        num: '4',
        title: 'Gestión de riesgos',
        text: 'Realizamos periódicamente análisis de riesgos tanto en el ISMS como en el QMS, aplicando medidas para mitigar las amenazas identificadas. Nuestro objetivo es minimizar el impacto de los riesgos y reducir la probabilidad de incidentes.'
      },
      {
        num: '5',
        title: 'BCP – Planificación de la continuidad del negocio',
        text: 'Hemos establecido planes de continuidad del negocio y de recuperación ante desastres para fallos del sistema o incidentes cibernéticos. Estos planes se prueban con regularidad para garantizar un funcionamiento ininterrumpido durante las incidencias y minimizar el impacto de situaciones de crisis.'
      },
      {
        num: '6',
        title: 'Mejora continua',
        text: 'Auditamos y revisamos periódicamente el ISMS para mejorar su eficacia. Esto garantiza el cumplimiento de las normas ISO 9001 e ISO 27001, perfeccionando continuamente los niveles de gestión de calidad y seguridad.'
      },
      {
        num: '7',
        title: 'Legislación',
        text: 'Cumplimos rigurosamente con las leyes y estándares aplicables en materia de calidad y ciberseguridad, previniendo las consecuencias legales y financieras del incumplimiento.'
      },
      {
        num: '8',
        title: 'Desarrollo de la concienciación',
        text: 'Llevamos a cabo periódicamente formaciones sobre seguridad de la información y gestión de la calidad para aumentar la concienciación de los empleados, reduciendo así el error humano como factor en incidentes de seguridad y calidad.'
      },
      {
        num: '9',
        title: 'Compromiso de la dirección',
        text: 'La dirección de JALUD Embedded s.r.o. se compromete a respaldar el ISMS y a asignar los recursos necesarios para su mantenimiento. Nuestro objetivo es garantizar una gestión responsable de la seguridad de la información, reducir los riesgos y promover una sólida cultura de seguridad y calidad en toda la empresa.'
      }
    ]
  },
  pt: {
    version: 'Versão 2026.1 (Em vigor desde 1 de janeiro de 2026)',
    eyebrow: 'QUALIDADE E SEGURANÇA DA INFORMAÇÃO',
    title: 'Política do Sistema Integrado de Gestão (IMS)',
    subtitle: 'Inclui os requisitos das normas ISO 9001:2015 e ISO/IEC 27001:2022.',
    dateStr: 'Plzeň, 6 de fevereiro de 2025',
    pdfBtn: 'Ver o documento original em inglês (PDF) →',
    pdfUrl: '/docs/legal/EN_SM_26_Politika_ISMS.pdf',
    sections: [
      {
        num: '1',
        title: 'QMS – Sistema de Gestão da Qualidade',
        text: 'Estamos totalmente empenhados em compreender e atender às necessidades e requisitos de nossos clientes, garantindo a mais alta qualidade. Melhoramos continuamente nossos processos, produtos e serviços para assegurar confiabilidade, segurança e conformidade com os mais altos padrões. Nossa meta é alcançar zero não conformidades em processos, produtos e serviços através da implementação sistemática de medidas preventivas e do fomento a uma cultura de melhoria contínua.'
      },
      {
        num: '2',
        title: 'ISMS – Sistema de Gestão da Segurança da Informação',
        text: 'Como empresa que lida com informações confidenciais e dados pessoais, priorizamos sua proteção rigorosa. Identificamos e gerenciamos riscos de segurança da informação, cumprimos os requisitos legais, incluindo GDPR e NIS2, e treinamos regularmente os colaboradores em segurança e proteção da informação. O acesso aos dados segue o princípio da «necessidade de saber» e o princípio do menor privilégio. Nossa meta é alcançar zero incidentes de segurança mediante prevenção eficaz, monitoramento contínuo e resposta oportuna a ameaças potenciais.'
      },
      {
        num: '3',
        title: 'Responsabilidade social e sustentabilidade',
        text: 'Reconhecemos nosso impacto na sociedade e no meio ambiente e, portanto, agimos de forma responsável e sustentável em todos os aspectos do nosso negócio. Apoiamos ativamente iniciativas que contribuem para a proteção da vida, do patrimônio e da saúde, enquanto minimizamos nosso impacto ambiental através de medidas como a otimização do consumo de energia e recursos.'
      },
      {
        num: '4',
        title: 'Gestão de riscos',
        text: 'Realizamos regularmente análises de riscos tanto no ISMS quanto no QMS, implementando medidas para mitigar ameaças identificadas. Nosso objetivo é minimizar o impacto dos riscos e reduzir a probabilidade de incidentes.'
      },
      {
        num: '5',
        title: 'BCP – Planejamento de Continuidade de Negócios',
        text: 'Estabelecemos planos de continuidade de negócios e recuperação de desastres para falhas de sistema ou incidentes cibernéticos. Esses planos são testados periodicamente para garantir operações ininterruptas durante perturbações e minimizar os impactos de situações de crise.'
      },
      {
        num: '6',
        title: 'Melhoria contínua',
        text: 'Auditamos e revisamos periodicamente o ISMS para aprimorar sua eficácia. Isso assegura a conformidade com as normas ISO 9001 e ISO 27001, elevando continuamente os níveis de gestão de qualidade e segurança.'
      },
      {
        num: '7',
        title: 'Legislação',
        text: 'Cumprimos rigorosamente as leis e normas aplicáveis em qualidade e cibersegurança, prevenindo consequências jurídicas e financeiras decorrentes do não cumprimento.'
      },
      {
        num: '8',
        title: 'Desenvolvimento da conscientização',
        text: 'Realizamos regularmente treinamentos em segurança da informação e gestão da qualidade para aumentar a conscientização dos funcionários quanto aos requisitos de segurança e qualidade, reduzindo o erro humano como fator de incidentes.'
      },
      {
        num: '9',
        title: 'Compromisso da liderança',
        text: 'A liderança da JALUD Embedded s.r.o. compromete-se a apoiar o ISMS e alocar os recursos necessários para a sua manutenção. Nosso objetivo é assegurar uma gestão responsável da segurança da informação, mitigar riscos e promover uma cultura de segurança e qualidade em toda a organização.'
      }
    ]
  },
  ar: {
    version: 'الإصدار 2026.1 (يسري اعتباراً من 1 يناير 2026)',
    eyebrow: 'الجودة وأمن المعلومات',
    title: 'سياسة نظام الإدارة المتكامل (IMS)',
    subtitle: 'تشمل متطلبات المعيارين ISO 9001:2015 وISO/IEC 27001:2022.',
    dateStr: 'بلزن، 6 فبراير 2025',
    pdfBtn: 'عرض المستند الأصلي باللغة الإنجليزية (PDF) ←',
    pdfUrl: '/docs/legal/EN_SM_26_Politika_ISMS.pdf',
    sections: [
      {
        num: '1',
        title: 'QMS – نظام إدارة الجودة',
        text: 'نحن ملتزمون تماماً بفهم وتلبية احتياجات ومتطلبات عملائنا، وضمان أعلى مستويات الجودة. ونعمل باستمرار على تحسين عملياتنا ومنتجاتنا وخدماتنا لضمان الموثوقية والأمان والامتثال لأعلى المعايير. هدفنا هو تحقيق صفر حالات عدم مطابقة في العمليات والمنتجات والخدمات من خلال التنفيذ المنهجي للتدابير الوقائية وتعزيز ثقافة التحسين المستمر.'
      },
      {
        num: '2',
        title: 'ISMS – نظام إدارة أمن المعلومات',
        text: 'بصفتنا شركة تتعامل مع معلومات حساسة وبيانات شخصية، فإننا نولي حمايتها الأولوية القصوى. نقوم بتحديد وإدارة مخاطر أمن المعلومات، والامتثال للمتطلبات القانونية بما في ذلك GDPR وتوجيه NIS2، وتدريب الموظفين بانتظام على الأمان وحماية المعلومات. ويخضع الوصول إلى البيانات لمبدأ «الحاجة إلى المعرفة» ومبدأ الامتياز الأدنى. هدفنا هو تحقيق صفر حوادث أمنية من خلال الوقاية الفعالة والمراقبة المستمرة والاستجابة السريعة للتهديدات المحتملة.'
      },
      {
        num: '3',
        title: 'المسؤولية الاجتماعية والاستدامة',
        text: 'ندرك تماماً أثر أعمالنا على المجتمع والبيئة، ولذلك نتصرف بمسؤولية واستدامة في جميع جوانب أعمالنا. نحن ندعم بنشاط المبادرات التي تسهم في حماية الأرواح والممتلكات والصحة مع تقليل بصمتنا البيئية إلى أدنى حد من خلال تحسين استهلاك الطاقة والموارد.'
      },
      {
        num: '4',
        title: 'إدارة المخاطر',
        text: 'نجري بانتظام تحليلاً شاملاً للمخاطر ضمن نظامي ISMS و QMS، ونطبق تدابير ملموسة للتخفيف من التهديدات المحددة. هدفنا هو تقليل آثار المخاطر واحتمالية وقوع الحوادث.'
      },
      {
        num: '5',
        title: 'BCP – التخطيط لاستمرارية الأعمال',
        text: 'وضعنا خططاً محكمة لاستمرارية الأعمال والتعافي من الكوارث في حالات أعطال الأنظمة أو الحوادث السيبرانية. ويتم اختبار هذه الخطط بانتظام لضمان استمرار العمليات دون انقطاع أثناء الاضطرابات وتقليل تأثير الأزمات.'
      },
      {
        num: '6',
        title: 'التحسين المستمر',
        text: 'نقوم بالتدقيق والمراجعة المنتظمة لنظام ISMS لتعزيز كفاءته وفعاليته. وهذا يضمن الامتثال لمعايير ISO 9001 و ISO 27001، مما يرفع باستمرار من مستويات إدارة الجودة والأمان.'
      },
      {
        num: '7',
        title: 'المتطلبات التشريعية والقانونية',
        text: 'نلتزم بالكامل بجميع القوانين واللوائح والمعايير المعمول بها في مجالات الجودة والأمن السيبراني، مما يحول دون حدوث تبعات قانونية أو مالية نتيجة عدم الامتثال.'
      },
      {
        num: '8',
        title: 'تطوير الوعي الأمني',
        text: 'نعقد دورات تدريبية منتظمة في أمن المعلومات وإدارة الجودة لتعزيز وعي الموظفين بالمتطلبات الأمنية والنوعية، مما يحد من الأخطاء البشرية كعامل مسبب للحوادث الأمنية والتشغيلية.'
      },
      {
        num: '9',
        title: 'التزام الإدارة العليا',
        text: 'تلتزم إدارة شركة JALUD Embedded s.r.o. بدعم نظام ISMS وتخصيص الموارد اللازمة للحفاظ عليه وتطويره. هدفنا هو ضمان إدارة مسؤولة لأمن المعلومات، والحد من المخاطر الأمنية، وترسيخ ثقافة راسخة للأمان والجودة داخل الشركة بأكملها.'
      }
    ]
  }
,
  it: {
    "eyebrow": "SISTEMA DI GESTIONE INTEGRATO & STANDARD ISO",
    "title": "Politica del Sistema di Gestione Integrato (IMS)",
    "subtitle": "Politica aziendale di JALUD Embedded s.r.o. per la gestione della qualità (ISO 9001:2015) e la sicurezza delle informazioni (ISO/IEC 27001:2022).",
    "version": "Versione 2026.1 (In vigore dal 1° gennaio 2026)",
    "tocTitle": "Indice della Politica IMS",
    "companyDetails": "JALUD Embedded s.r.o., Nepomucká 1355/261, 326 00 Plzeň, Repubblica Ceca, IČO: 03056287",
    "preamble": "L'Alta Direzione di JALUD Embedded s.r.o. definisce con il presente documento la Politica del Sistema di Gestione Integrato per la Qualità e la Sicurezza delle Informazioni. La presente politica esprime l'impegno strategico a garantire l'eccellenza tecnologica, la massima soddisfazione dei clienti e la protezione integrale del patrimonio informativo aziendale e dei dati dei clienti.",
    "sections": [
      {
        "id": "ims-1",
        "num": "1",
        "title": "Visione Aziendale e Impegno dell'Alta Direzione",
        "text": "L'Alta Direzione si impegna a fornire le risorse umane, finanziarie e tecnologiche necessarie per l'attuazione, il mantenimento e il miglioramento continuo del Sistema di Gestione Integrato secondo gli standard ISO 9001:2015 e ISO/IEC 27001:2022."
      },
      {
        "id": "ims-2",
        "num": "2",
        "title": "Ambito del Sistema di Gestione Integrato",
        "text": "L'ambito del sistema integrato comprende la ricerca, lo sviluppo software, l'integrazione hardware, la vendita e il supporto tecnico per i sistemi di rilevamento acustico intelligente delle minacce (Sound Event Detector)."
      },
      {
        "id": "ims-3",
        "num": "3",
        "title": "Orientamento al Cliente e Soddisfazione delle Aspettative",
        "text": "I requisiti dei clienti e degli utilizzatori finali sono costantemente monitorati e integrati nello sviluppo dei nostri prodotti. Perseguiamo l'elevata affidabilità, la facilità d'uso e l'interoperabilità con i principali sistemi di sicurezza globale."
      },
      {
        "id": "ims-4",
        "num": "4",
        "title": "Principi Fondamentali della Sicurezza delle Informazioni",
        "text": "Garantiamo la Riservatezza (accesso alle informazioni riservato al solo personale autorizzato), l'Integrità (salvaguardia dell'accuratezza e completezza di dati, codice sorgente e modelli neurali) e la Disponibilità (accesso affidabile e tempestivo a dati e servizi per i legittimi utilizzatori)."
      },
      {
        "id": "ims-5",
        "num": "5",
        "title": "Gestione del Rischio, Minacce Cyber e Continuità Operativa",
        "text": "Applichiamo una rigorosa metodologia di valutazione periodica dei rischi operativi e di sicurezza informatica, adottando contromisure proporzionate e piani di continuità aziendale per prevenire incidenti e ridurre al minimo gli impatti."
      },
      {
        "id": "ims-6",
        "num": "6",
        "title": "Conformità Legale, Normativa e Contrattuale",
        "text": "JALUD opera nel rigoroso rispetto di tutte le leggi vigenti nella Repubblica Ceca e nell'Unione Europea, comprese le direttive sulla sicurezza dei prodotti, il GDPR e i vincoli contrattuali concordati con i clienti."
      },
      {
        "id": "ims-7",
        "num": "7",
        "title": "Competenze, Formazione e Consapevolezza del Personale",
        "text": "Investiamo costantemente nello sviluppo professionale e nella formazione specialistica del nostro personale in materia di qualità, ingegneria acustica, intelligenza artificiale e sicurezza delle informazioni."
      },
      {
        "id": "ims-8",
        "num": "8",
        "title": "Miglioramento Continuo e Valutazione delle Prestazioni",
        "text": "Definiamo annualmente obiettivi misurabili di qualità e sicurezza, riesaminati regolarmente dall'Alta Direzione tramite audit interni, indicatori chiave di prestazione (KPI) e verifiche di conformità."
      },
      {
        "id": "ims-9",
        "num": "9",
        "title": "Diffusione, Revisione e Disponibilità Pubblica della Politica",
        "text": "La presente politica è comunicata a tutto il personale, è pubblicamente accessibile sul nostro sito web per clienti, partner e parti interessate, ed è soggetta a revisione annuale da parte dell'Alta Direzione."
      }
    ],
    "crossLinksTitle": "Documenti Legali Correlati",
    "crossLinks": [
      {
        "route": "code-of-ethics",
        "name": "Codice Etico e Principi dell'IA",
        "desc": "Principi etici nello sviluppo di intelligenza artificiale responsabile"
      },
      {
        "route": "support-and-maintenance",
        "name": "Supporto e Manutenzione",
        "desc": "Impegni di servizio e supporto tecnico certificato"
      },
      {
        "route": "terms-and-conditions",
        "name": "Termini e Condizioni Generali",
        "desc": "Condizioni contrattuali e garanzie di fornitura"
      },
      {
        "route": "product-privacy",
        "name": "Privacy del Prodotto",
        "desc": "Architettura di tutela della riservatezza e conformità tecnica"
      }
    ]
  }
};


export const cookiePolicyTranslations = {
  cs: {
    eyebrow: 'OCHRANA SOUKROMÍ A COOKIES',
    title: 'Zásady používání cookies',
    subtitle: 'Informace o používání souborů cookie, místního úložiště a externích technologií na webu jalud.eu.',
    sec1Title: 'Co jsou cookies a místní úložiště?',
    sec1P1: 'Soubory cookie jsou malé textové soubory, které webové stránky ukládají do vašeho prohlížeče při jejich návštěvě. Některé jsou nezbytné pro správné fungování webu, jiné nám po udělení vašeho souhlasu pomáhají vyhodnocovat návštěvnost nebo zobrazovat externí obsah.',
    sec1P2: 'Vedle cookies může web používat také místní úložiště prohlížeče (LocalStorage), například pro zapamatování zvoleného jazyka nebo nastavení cookies.',
    sec2Title: 'Jaké kategorie používáme?',
    catATitle: 'A. Nezbytné technologie',
    catADesc: 'Nezbytné cookies a místní úložiště slouží k základnímu fungování webu, uložení zvoleného jazyka a zapamatování vašeho nastavení ochrany soukromí. Tyto technologie není možné prostřednictvím cookie lišty vypnout, protože bez nich by některé části webu nemusely správně fungovat.',
    catBTitle: 'B. Analytické cookies',
    catBDesc: 'Po udělení souhlasu používáme službu Google Analytics 4 ke statistickému vyhodnocování návštěvnosti a způsobu používání webu. Měřicí značky jsou spravovány prostřednictvím Google Tag Manageru. Pokud analytické cookies odmítnete, analytické cookies se do vašeho zařízení neuloží. Google Consent Mode však může v závislosti na technickém nastavení odesílat omezená měření bez použití cookies.',
    catCTitle: 'C. Externí média',
    catCDesc: 'Web obsahuje videa poskytovaná službou YouTube. Externí obsah se načte až po udělení souhlasu s externími médii. Při načtení nebo přehrání videa může služba YouTube uložit cookies nebo získat informace o vašem zařízení a používání vloženého obsahu. Pokud externí média nepovolíte, zobrazí se místo videa pouze náhled s možností jeho dodatečného povolení.',
    sec3Title: 'Přehled používaných technologií',
    sec3Intro: 'Níže uvedená tabulka obsahuje přehled technologií ověřených technickým auditem webu:',
    thName: 'Název',
    thProvider: 'Poskytovatel',
    thStorageType: 'Typ úložiště',
    thPurpose: 'Účel',
    thCategory: 'Kategorie',
    thDuration: 'Doba platnosti',
    catBadgeNecessary: 'Nezbytné',
    catBadgeAnalytics: 'Analytické',
    catBadgeMedia: 'Externí média',
    consentStorageType: 'Místní úložiště prohlížeče (LocalStorage)',
    consentPurpose: 'Zapamatování nastavení souhlasu s cookies (sed_cookie_consent_v2)',
    consentDuration: 'Trvalé (do smazání v prohlížeči)',
    gaCookieType: 'HTTP Cookie',
    gaPurpose: 'Rozlišení unikátních uživatelů pro statistiky návštěvnosti webu',
    gaDuration: '2 roky (pouze po souhlasu)',
    ga4Purpose: 'Udržování stavu relace a agregace návštěvnosti v Google Analytics 4',
    ga4Duration: '2 roky (pouze po souhlasu)',
    hsCookieType: 'HTTP Cookie',
    hsPurpose: 'Měření návštěvnosti, vyhodnocování marketingových kampaní a relace návštěvníka (HubSpot CRM)',
    hsDuration: 'Relace až 13 měsíců (pouze po souhlasu)',
    ytCookieType: 'HTTP Cookie / LocalStorage',
    ytPurpose: 'Přehrávání vložených videí a ukládání preferencí přehrávače v režimu zvýšené ochrany soukromí',
    ytDuration: 'Relace až 2 roky (pouze po souhlasu)',
    sec4Title: 'Jak můžete své nastavení změnit?',
    sec4P1: 'Při první návštěvě webu můžete přijmout všechny volitelné technologie, odmítnout je nebo si nastavit jednotlivé kategorie.',
    sec4P2: 'Své rozhodnutí můžete kdykoliv změnit pomocí odkazu „Nastavení cookies“ v zápatí webu nebo kliknutím na tlačítko níže. Odvolání souhlasu nemá vliv na zpracování provedené před jeho odvoláním.',
    changeSettingsBtn: 'Otevřít nastavení cookies',
    sec4P3: 'Cookies a další uložená data můžete odstranit také prostřednictvím nastavení konkrétního webu ve svém internetovém prohlížeči.',
    sec5Title: 'Provozovatel webu a kontakt',
    sec5P1: 'Provozovatel webu a správce osobních údajů:',
    companyName: 'JALUD Embedded s.r.o.',
    companyAddress: 'Nepomucká 1355/261, Černice, 326 00 Plzeň, Česká republika',
    companyId: 'IČO: 03056287',
    contactEmail: 'E-mail: <span class="sed-obf-email" data-u="aW5mbw==" data-d="amFsdWQtZW1iZWRkZWQuY29t" data-t="aW5mb0BqYWx1ZC1lbWJlZGRlZC5jb20=" style="color: var(--navy-dark); font-weight: 700;"><span class="sed-obf-fallback">info [at] jalud-embedded.com</span></span>',
    privacyLinkText: 'Další informace o zpracování osobních údajů naleznete na stránce',
    privacyPageLink: 'Ochrana soukromí',
    googleLinksIntro: 'Informace třetích stran:',
    googlePrivacyLink: 'Zásady ochrany osobních údajů společnosti Google',
    googleCookieLink: 'Informace společnosti Google o používání cookies a dat'
  },
  en: {
    eyebrow: 'PRIVACY & COOKIES',
    title: 'Cookie Policy',
    subtitle: 'Information about the use of cookies, local storage, and external technologies on jalud.eu.',
    sec1Title: 'What Are Cookies and Local Storage?',
    sec1P1: 'Cookies are small text files placed in your browser when visiting websites. Some are strictly necessary for core functionality, while others help us evaluate site traffic or display external media upon receiving your consent.',
    sec1P2: 'In addition to cookies, the site may use browser local storage (LocalStorage), for instance to remember selected language preferences or cookie consent choices.',
    sec2Title: 'Which Categories Do We Use?',
    catATitle: 'A. Necessary Technologies',
    catADesc: 'Essential cookies and local storage are required for core website operations, remembering language preferences, and storing your privacy choices. These technologies cannot be disabled via the cookie banner because parts of the site cannot function properly without them.',
    catBTitle: 'B. Analytics Cookies',
    catBDesc: 'Upon receiving your consent, we use Google Analytics 4 for statistical evaluation of site traffic and user interactions. Tracking tags are managed through Google Tag Manager. If you decline analytics cookies, no tracking cookies are placed on your device. Depending on configuration, Google Consent Mode may transmit restricted pings without cookies.',
    catCTitle: 'C. External Media',
    catCDesc: 'Our website incorporates videos provided by YouTube. External media content is loaded only after your explicit consent. When loading or playing a video, YouTube may set cookies or collect device information. If external media is not consented to, a placeholder preview is shown with an option to grant consent.',
    sec3Title: 'Overview of Technologies Used',
    sec3Intro: 'The table below details all technologies verified through our technical website audit:',
    thName: 'Name',
    thProvider: 'Provider',
    thStorageType: 'Storage Type',
    thPurpose: 'Purpose',
    thCategory: 'Category',
    thDuration: 'Duration',
    catBadgeNecessary: 'Necessary',
    catBadgeAnalytics: 'Analytics',
    catBadgeMedia: 'External Media',
    consentStorageType: 'Browser Local Storage (LocalStorage)',
    consentPurpose: 'Stores user consent preferences (sed_cookie_consent_v2)',
    consentDuration: 'Persistent (until cleared in browser)',
    gaCookieType: 'HTTP Cookie',
    gaPurpose: 'Distinguishes unique visitors for aggregated traffic analytics',
    gaDuration: '2 years (only after consent)',
    ga4Purpose: 'Maintains session state and metrics in Google Analytics 4',
    ga4Duration: '2 years (only after consent)',
    hsCookieType: 'HTTP Cookie',
    hsPurpose: 'Measures website traffic, tracks marketing campaign performance and visitor sessions (HubSpot CRM)',
    hsDuration: 'Session up to 13 months (consent required)',
    ytCookieType: 'HTTP Cookie / LocalStorage',
    ytPurpose: 'Enables embedded video playback and player preferences in privacy-enhanced mode',
    ytDuration: 'Session up to 2 years (only after consent)',
    sec4Title: 'How Can You Manage Your Preferences?',
    sec4P1: 'On your first visit, you may accept all optional technologies, decline them, or configure category preferences individually.',
    sec4P2: 'You can change your consent at any time via the "Cookie Settings" link in the website footer or by clicking the button below. Consent revocation does not affect prior lawful processing.',
    changeSettingsBtn: 'Open Cookie Settings',
    sec4P3: 'You can also clear cookies and site data through your browser settings for this domain at any time.',
    sec5Title: 'Website Operator & Contact',
    sec5P1: 'Website Operator and Data Controller:',
    companyName: 'JALUD Embedded s.r.o.',
    companyAddress: 'Nepomucká 1355/261, Černice, 326 00 Pilsen, Czech Republic',
    companyId: 'Company ID (IČO): 03056287',
    contactEmail: 'Email: <span class="sed-obf-email" data-u="aW5mbw==" data-d="amFsdWQtZW1iZWRkZWQuY29t" data-t="aW5mb0BqYWx1ZC1lbWJlZGRlZC5jb20=" style="color: var(--navy-dark); font-weight: 700;"><span class="sed-obf-fallback">info [at] jalud-embedded.com</span></span>',
    privacyLinkText: 'For detailed information regarding personal data processing, please visit our',
    privacyPageLink: 'Privacy Policy',
    googleLinksIntro: 'Third-party information:',
    googlePrivacyLink: 'Google Privacy Policy',
    googleCookieLink: 'How Google Uses Cookies and Site Data'
  },
  de: {
    eyebrow: 'DATENSCHUTZ & COOKIES',
    title: 'Cookie-Richtlinie',
    subtitle: 'Informationen über die Verwendung von Cookies, lokalem Speicher und externen Technologien auf jalud.eu.',
    sec1Title: 'Was sind Cookies und lokaler Speicher?',
    sec1P1: 'Cookies sind kleine Textdateien, die beim Besuch von Websites im Browser gespeichert werden. Einige sind für den Betrieb unerlässlich, andere helfen uns mit Ihrer Einwilligung bei der Analyse oder der Einbindung externer Inhalte.',
    sec1P2: 'Neben Cookies kann die Website auch den lokalen Speicher des Browsers (LocalStorage) nutzen, beispielsweise zur Speicherung der Sprache oder der Cookie-Präferenzen.',
    sec2Title: 'Welche Kategorien verwenden wir?',
    catATitle: 'A. Notwendige Technologien',
    catADesc: 'Notwendige Cookies und Speicherdaten gewährleisten Kernfunktionen der Website, Sprachauswahl und die Speicherung Ihrer Datenschutzeinstellungen. Diese können nicht deaktiviert werden.',
    catBTitle: 'B. Analyse-Cookies',
    catBDesc: 'Mit Ihrer Einwilligung nutzen wir Google Analytics 4 zur statistischen Auswertung der Website-Nutzung. Die Tags werden über Google Tag Manager verwaltet. Bei Ablehnung werden keine Analyse-Cookies gesetzt.',
    catCTitle: 'C. Externe Medien',
    catCDesc: 'Die Website bindet Videos von YouTube ein. Externe Inhalte werden erst nach Einwilligung geladen. YouTube kann dabei Cookies speichern und Gerätedaten verarbeiten. Ohne Einwilligung wird eine Vorschau angezeigt.',
    sec3Title: 'Übersicht der verwendeten Technologien',
    sec3Intro: 'Die folgende Tabelle zeigt alle durch das technische Audit verifizierten Technologien:',
    thName: 'Name',
    thProvider: 'Anbieter',
    thStorageType: 'Speichertyp',
    thPurpose: 'Zweck',
    thCategory: 'Kategorie',
    thDuration: 'Gültigkeit',
    catBadgeNecessary: 'Notwendig',
    catBadgeAnalytics: 'Analyse',
    catBadgeMedia: 'Externe Medien',
    consentStorageType: 'Lokaler Browserspeicher (LocalStorage)',
    consentPurpose: 'Speichert Cookie-Einwilligungen (sed_cookie_consent_v2)',
    consentDuration: 'Dauerhaft (bis zum Löschen im Browser)',
    gaCookieType: 'HTTP-Cookie',
    gaPurpose: 'Unterscheidung einzelner Besucher für Zugriffsstatistiken',
    gaDuration: '2 Jahre (nur nach Einwilligung)',
    ga4Purpose: 'Sitzungsstatus und Metriken in Google Analytics 4',
    ga4Duration: '2 Jahre (nur nach Einwilligung)',
    hsCookieType: 'HTTP-Cookie',
    hsPurpose: 'Messung des Website-Traffics, Analyse von Marketingkampagnen und Besuchersitzungen (HubSpot CRM)',
    hsDuration: 'Sitzung bis zu 13 Monate (nur nach Einwilligung)',
    ytCookieType: 'HTTP-Cookie / LocalStorage',
    ytPurpose: 'Wiedergabe eingebetteter Videos im erweiterten Datenschutzmodus',
    ytDuration: 'Sitzung bis 2 Jahre (nur nach Einwilligung)',
    sec4Title: 'Wie können Sie Ihre Einstellungen ändern?',
    sec4P1: 'Beim ersten Besuch können Sie alle optionalen Technologien akzeptieren, ablehnen oder individuell anpassen.',
    sec4P2: 'Sie können Ihre Auswahl jederzeit über den Link „Cookie-Einstellungen“ in der Fußzeile oder über die Schaltfläche unten anpassen.',
    changeSettingsBtn: 'Cookie-Einstellungen öffnen',
    sec4P3: 'Sie können gespeicherte Cookies und Websitedaten auch direkt in den Einstellungen Ihres Browsers löschen.',
    sec5Title: 'Website-Betreiber und Kontakt',
    sec5P1: 'Betreiber und Verantwortlicher für die Datenverarbeitung:',
    companyName: 'JALUD Embedded s.r.o.',
    companyAddress: 'Nepomucká 1355/261, Černice, 326 00 Pilsen, Tschechische Republik',
    companyId: 'USt-IdNr. / IČO: 03056287',
    contactEmail: 'E-Mail: <span class="sed-obf-email" data-u="aW5mbw==" data-d="amFsdWQtZW1iZWRkZWQuY29t" data-t="aW5mb0BqYWx1ZC1lbWJlZGRlZC5jb20=" style="color: var(--navy-dark); font-weight: 700;"><span class="sed-obf-fallback">info [at] jalud-embedded.com</span></span>',
    privacyLinkText: 'Weitere Informationen zur Datenverarbeitung finden Sie in unserer',
    privacyPageLink: 'Datenschutzerklärung',
    googleLinksIntro: 'Drittanbieter-Informationen:',
    googlePrivacyLink: 'Google Datenschutzerklärung',
    googleCookieLink: 'Wie Google Cookies und Daten verwendet'
  },
  es: {
    eyebrow: 'PRIVACIDAD Y COOKIES',
    title: 'Política de cookies',
    subtitle: 'Información sobre el uso de cookies, almacenamiento local y tecnologías externas en jalud.eu.',
    sec1Title: '¿Qué son las cookies y el almacenamiento local?',
    sec1P1: 'Las cookies son pequeños archivos de texto que los sitios web guardan en su navegador. Algunas son estrictamente necesarias para el funcionamiento y otras nos ayudan a analizar el tráfico o mostrar contenido externo tras su consentimiento.',
    sec1P2: 'Además de cookies, el sitio web puede utilizar almacenamiento local (LocalStorage) para recordar el idioma elegido o su configuración de cookies.',
    sec2Title: '¿Qué categorías utilizamos?',
    catATitle: 'A. Tecnologías necesarias',
    catADesc: 'Las cookies y el almacenamiento necesario garantizan las funciones esenciales, la selección de idioma y el registro de sus preferencias de privacidad. No se pueden desactivar.',
    catBTitle: 'B. Cookies analíticas',
    catBDesc: 'Con su consentimiento, utilizamos Google Analytics 4 para evaluar estadísticas de tráfico y uso del sitio web, gestionadas mediante Google Tag Manager. Si las rechaza, no se guardan cookies analíticas.',
    catCTitle: 'C. Medios externos',
    catCDesc: 'El sitio web incluye vídeos de YouTube. El contenido externo sólo se carga tras su consentimiento. Si no lo autoriza, se muestra una vista previa con opción de activación voluntaria.',
    sec3Title: 'Resumen de tecnologías utilizadas',
    sec3Intro: 'La siguiente tabla detalla las tecnologías verificadas en la auditoría técnica del sitio:',
    thName: 'Nombre',
    thProvider: 'Proveedor',
    thStorageType: 'Tipo de almacenamiento',
    thPurpose: 'Propósito',
    thCategory: 'Categoría',
    thDuration: 'Duración',
    catBadgeNecessary: 'Necesarias',
    catBadgeAnalytics: 'Analíticas',
    catBadgeMedia: 'Medios externos',
    consentStorageType: 'Almacenamiento local del navegador (LocalStorage)',
    consentPurpose: 'Guarda preferencias de consentimiento (sed_cookie_consent_v2)',
    consentDuration: 'Persistente (hasta su eliminación en el navegador)',
    gaCookieType: 'Cookie HTTP',
    gaPurpose: 'Distingue usuarios únicos para estadísticas de visitas',
    gaDuration: '2 años (solo tras consentimiento)',
    ga4Purpose: 'Mantiene el estado de sesión y métricas en Google Analytics 4',
    ga4Duration: '2 años (solo tras consentimiento)',
    hsCookieType: 'Cookie HTTP',
    hsPurpose: 'Medición de tráfico, seguimiento del rendimiento de campañas de marketing y sesiones de usuario (HubSpot CRM)',
    hsDuration: 'Sesión hasta 13 meses (solo tras consentimiento)',
    ytCookieType: 'Cookie HTTP / LocalStorage',
    ytPurpose: 'Reproducción de vídeos integrados con modo de privacidad mejorada',
    ytDuration: 'Sesión hasta 2 años (solo tras consentimiento)',
    sec4Title: '¿Cómo puede modificar sus preferencias?',
    sec4P1: 'En su primera visita puede aceptar todas las tecnologías opcionales, rechazarlas o configurar cada categoría.',
    sec4P2: 'Puede modificar su decisión en cualquier momento mediante el enlace "Configuración de cookies" en el pie de página o mediante el siguiente botón.',
    changeSettingsBtn: 'Abrir configuración de cookies',
    sec4P3: 'También puede eliminar cookies y datos del sitio mediante la configuración de su navegador web.',
    sec5Title: 'Responsable del sitio web y contacto',
    sec5P1: 'Responsable del sitio y tratamiento de datos:',
    companyName: 'JALUD Embedded s.r.o.',
    companyAddress: 'Nepomucká 1355/261, Černice, 326 00 Pilsen, República Checa',
    companyId: 'NIF / IČO: 03056287',
    contactEmail: 'Correo electrónico: <span class="sed-obf-email" data-u="aW5mbw==" data-d="amFsdWQtZW1iZWRkZWQuY29t" data-t="aW5mb0BqYWx1ZC1lbWJlZGRlZC5jb20=" style="color: var(--navy-dark); font-weight: 700;"><span class="sed-obf-fallback">info [at] jalud-embedded.com</span></span>',
    privacyLinkText: 'Para más detalles sobre el tratamiento de datos personales, visite nuestra',
    privacyPageLink: 'Política de Privacidad',
    googleLinksIntro: 'Información de terceros:',
    googlePrivacyLink: 'Política de Privacidad de Google',
    googleCookieLink: 'Cómo utiliza Google las cookies y los datos'
  },
  pt: {
    eyebrow: 'PRIVACIDADE E COOKIES',
    title: 'Política de Cookies',
    subtitle: 'Informações sobre a utilização de cookies, armazenamento local e tecnologias externas no sítio jalud.eu.',
    sec1Title: 'O que são cookies e armazenamento local?',
    sec1P1: 'Cookies são pequenos ficheiros de texto guardados no seu navegador ao visitar páginas web. Alguns são estritamente necessários para o funcionamento e outros auxiliam na análise de tráfego e exibição de conteúdos com seu consentimento.',
    sec1P2: 'Além de cookies, o sítio web pode utilizar armazenamento local (LocalStorage), por exemplo para memorizar o idioma selecionado ou as preferências de privacidade.',
    sec2Title: 'Que categorias utilizamos?',
    catATitle: 'A. Tecnologias necessárias',
    catADesc: 'Garantem as funções fundamentais do sítio, memorização de idioma e opções de consentimento. Não podem ser desativadas no painel de cookies.',
    catBTitle: 'B. Cookies analíticos',
    catBDesc: 'Após o seu consentimento, utilizamos o Google Analytics 4 para avaliação estatística do tráfego através do Google Tag Manager. Se recusar, nenhuns cookies analíticos são armazenados.',
    catCTitle: 'C. Conteúdo multimédia externo',
    catCDesc: 'O sítio inclui vídeos alojados no YouTube. O conteúdo externo é carregado apenas após autorização. Caso não autorize, é apresentada uma pré-visualização estática com botão de ativação.',
    sec3Title: 'Visão geral das tecnologias utilizadas',
    sec3Intro: 'A tabela seguinte apresenta as tecnologias verificadas na auditoria técnica do sítio web:',
    thName: 'Nome',
    thProvider: 'Fornecedor',
    thStorageType: 'Tipo de armazenamento',
    thPurpose: 'Finalidade',
    thCategory: 'Categoria',
    thDuration: 'Validade',
    catBadgeNecessary: 'Necessário',
    catBadgeAnalytics: 'Analítico',
    catBadgeMedia: 'Média Externa',
    consentStorageType: 'Armazenamento local do navegador (LocalStorage)',
    consentPurpose: 'Memoriza as escolhas de consentimento (sed_cookie_consent_v2)',
    consentDuration: 'Persistente (até limpeza no navegador)',
    gaCookieType: 'Cookie HTTP',
    gaPurpose: 'Distingue utilizadores únicos para métricas de visita',
    gaDuration: '2 anos (apenas com consentimento)',
    ga4Purpose: 'Mantém o estado da sessão de navegação no Google Analytics 4',
    ga4Duration: '2 anos (apenas com consentimento)',
    hsCookieType: 'Cookie HTTP',
    hsPurpose: 'Medição de tráfego, acompanhamento do desempenho de campanhas de marketing e sessões de utilizadores (HubSpot CRM)',
    hsDuration: 'Sessão até 13 meses (apenas com consentimento)',
    ytCookieType: 'Cookie HTTP / LocalStorage',
    ytPurpose: 'Permite a reprodução de vídeos em modo de privacidade avançada',
    ytDuration: 'Sessão até 2 anos (apenas com consentimento)',
    sec4Title: 'Como pode alterar as suas preferências?',
    sec4P1: 'Na primeira visita pode aceitar todas as tecnologias opcionais, recusá-las ou configurá-las individualmente.',
    sec4P2: 'Pode alterar a sua escolha a qualquer momento através da ligação „Configurações de cookies“ no rodapé ou no botão abaixo.',
    changeSettingsBtn: 'Abrir configurações de cookies',
    sec4P3: 'Pode também eliminar cookies e dados do sítio através das opções de privacidade do seu navegador web.',
    sec5Title: 'Operador do sítio e contacto',
    sec5P1: 'Operador do sítio web e responsável pelo tratamento de dados:',
    companyName: 'JALUD Embedded s.r.o.',
    companyAddress: 'Nepomucká 1355/261, Černice, 326 00 Plzeň, República Checa',
    companyId: 'NIF / IČO: 03056287',
    contactEmail: 'E-mail: <span class="sed-obf-email" data-u="aW5mbw==" data-d="amFsdWQtZW1iZWRkZWQuY29t" data-t="aW5mb0BqYWx1ZC1lbWJlZGRlZC5jb20=" style="color: var(--navy-dark); font-weight: 700;"><span class="sed-obf-fallback">info [at] jalud-embedded.com</span></span>',
    privacyLinkText: 'Para mais informações sobre o tratamento de dados pessoais, consulte a nossa',
    privacyPageLink: 'Política de Privacidade',
    googleLinksIntro: 'Informações de terceiros:',
    googlePrivacyLink: 'Política de Privacidade da Google',
    googleCookieLink: 'Como a Google utiliza cookies e dados'
  },
  ar: {
    eyebrow: 'الخصوصية وملفات تعريف الارتباط',
    title: 'سياسة ملفات تعريف الارتباط',
    subtitle: 'معلومات حول استخدام ملفات تعريف الارتباط والتخزين المحلي والوسائط الخارجية على موقع jalud.eu.',
    sec1Title: 'ما هي ملفات تعريف الارتباط والتخزين المحلي؟',
    sec1P1: 'ملفات تعريف الارتباط هي ملفات نصية صغيرة يخزنها المتصفح عند زيارة المواقع الإلكترونية. بعضها ضروري لتشغيل الموقع، والبعض الآخر يساعد في قياس حركة المرور أو عرض الوسائط الخارجية بعد موافقتك.',
    sec1P2: 'بالإضافة إلى ملفات تعريف الارتباط، قد يستخدم الموقع التخزين المحلي للمتصفح (LocalStorage)، على سبيل المثال لتذكر اللغة المحددة أو تفضيلات الخصوصية.',
    sec2Title: 'ما هي الفئات التي نستخدمها؟',
    catATitle: 'أ. التقنيات الضرورية',
    catADesc: 'تخدم ملفات تعريف الارتباط الضرورية والتخزين المحلي التشغيل الأساسي للموقع وتذكر تفضيلات اللغة وحفظ إعدادات الخصوصية. لا يمكن تعطيل هذه التقنيات لأن أجزاء من الموقع لن تعمل بشكل صحيح بدونها.',
    catBTitle: 'ب. ملفات تعريف الارتباط التحليلية',
    catBDesc: 'بعد الحصول على موافقتك، نستخدم Google Analytics 4 للتقييم الإحصائي لحركة المرور واستخدام الموقع من خلال Google Tag Manager. إذا رفضتها، فلن يتم تخزين أي ملفات تحليلية.',
    catCTitle: 'ج. الوسائط الخارجية',
    catCDesc: 'يحتوي الموقع على مقاطع فيديو مقدمة من خدمة YouTube. لا يتم تحميل المحتوى الخارجي إلا بعد موافقتك. إذا لم توافق، يظهر للمستخدم معاينة بديلة مع خيار التمكين.',
    sec3Title: 'نظرة عامة على التقنيات المستخدمة',
    sec3Intro: 'يوضح الجدول التالي التقنيات التي تم التحقق منها عبر التدقيق التقني الفعلي للموقع:',
    thName: 'الاسم',
    thProvider: 'المزود',
    thStorageType: 'نوع التخزين',
    thPurpose: 'الغرض',
    thCategory: 'الفئة',
    thDuration: 'مدة الصلاحية',
    catBadgeNecessary: 'ضرورية',
    catBadgeAnalytics: 'تحليلية',
    catBadgeMedia: 'وسائط خارجية',
    consentStorageType: 'التخزين المحلي للمتصفح (LocalStorage)',
    consentPurpose: 'تذكر تفضيلات الموافقة على ملفات تعريف الارتباط (sed_cookie_consent_v2)',
    consentDuration: 'دائم (حتى الحذف من المتصفح)',
    gaCookieType: 'HTTP Cookie',
    gaPurpose: 'تمييز الزوار الفريدين لإحصاءات حركة المرور',
    gaDuration: 'سنتان (فقط بعد الموافقة)',
    ga4Purpose: 'الحفاظ على حالة الجلسة وتجميع المقاييس في Google Analytics 4',
    ga4Duration: 'سنتان (فقط بعد الموافقة)',
    hsCookieType: 'HTTP Cookie',
    hsPurpose: 'قياس حركة المرور للموقع، تتبع أداء الحملات التسويقية وجلسات الزوار (HubSpot CRM)',
    hsDuration: 'جلسة حتى 13 شهراً (فقط بعد الموافقة)',
    ytCookieType: 'HTTP Cookie / LocalStorage',
    ytPurpose: 'تشغيل مقاطع الفيديو المضمنة في وضع الخصوصية المحسنة وحفظ تفضيلات المشغل',
    ytDuration: 'جلسة حتى سنتين (فقط بعد الموافقة)',
    sec4Title: 'كيف يمكنك تغيير إعداداتك؟',
    sec4P1: 'عند زيارتك الأولى للموقع، يمكنك قبول جميع التقنيات الاختيارية أو رفضها أو ضبط كل فئة على حدة.',
    sec4P2: 'يمكنك تغيير قرارك في أي وقت عبر رابط "إعدادات ملفات تعريف الارتباط" في أسفل الموقع أو بالنقر على الزر أدناه.',
    changeSettingsBtn: 'فتح إعدادات ملفات تعريف الارتباط',
    sec4P3: 'يمكنك أيضاً حذف ملفات تعريف الارتباط وبيانات الموقع عبر إعدادات متصفحك في أي وقت.',
    sec5Title: 'مشغل الموقع ومعلومات الاتصال',
    sec5P1: 'مشغل الموقع والمسؤول عن معالجة البيانات الشخصية:',
    companyName: 'JALUD Embedded s.r.o.',
    companyAddress: 'Nepomucká 1355/261, Černice, 326 00 Plzeň, جمهورية التشيك',
    companyId: 'رقم التسجيل (IČO): 03056287',
    contactEmail: 'البريد الإلكتروني: <span class="sed-obf-email" data-u="aW5mbw==" data-d="amFsdWQtZW1iZWRkZWQuY29t" data-t="aW5mb0BqYWx1ZC1lbWJlZGRlZC5jb20=" style="color: var(--navy-dark); font-weight: 700;"><span class="sed-obf-fallback">info [at] jalud-embedded.com</span></span>',
    privacyLinkText: 'لمزيد من المعلومات حول معالجة البيانات الشخصية، يرجى زيارة صفحة',
    privacyPageLink: 'سياسة الخصوصية',
    googleLinksIntro: 'معلومات الأطراف الثالثة:',
    googlePrivacyLink: 'سياسة خصوصية Google',
    googleCookieLink: 'كيفية استخدام Google لملفات تعريف الارتباط والبيانات'
  }
,
  it: {
    "eyebrow": "PRIVACY E COOKIE",
    "title": "Informativa sui Cookie",
    "subtitle": "Informazioni sull'uso di cookie, archiviazione locale (LocalStorage) e tecnologie esterne sul sito web jalud.eu.",
    "sec1Title": "Cosa Sono i Cookie e l'Archiviazione Locale?",
    "sec1P1": "I cookie sono piccoli file di testo memorizzati nel browser dell'utente durante la navigazione web. Alcuni sono strettamente necessari per il funzionamento tecnico del sito, mentre altri ci consentono di analizzare il traffico o riprodurre contenuti multimediali previo consenso.",
    "sec1P2": "Oltre ai cookie, il sito può utilizzare la memoria locale del browser (LocalStorage), ad esempio per salvare la preferenza della lingua o le scelte effettuate nel banner di consenso privacy.",
    "sec2Title": "Quali Categorie di Cookie Utilizziamo?",
    "catATitle": "A. Tecnologie Necessarie (Essenziali)",
    "catADesc": "Garantiscono le funzionalità di base del sito, la memorizzazione della lingua e il salvataggio delle scelte sul consenso privacy. Queste tecnologie non possono essere disattivate nel pannello di controllo in quanto il sito non potrebbe funzionare correttamente.",
    "catBTitle": "B. Cookie Analitici e Statistici",
    "catBDesc": "Previo esplicito consenso dell'utente, utilizziamo Google Analytics 4 tramite Google Tag Manager per analizzare in forma aggregata e anonima le visite e migliorare la qualità della navigazione. In caso di rifiuto, nessun cookie statistico viene memorizzato sul dispositivo.",
    "catCTitle": "C. Contenuti Multimediali Esterni",
    "catCDesc": "Il nostro sito web include video informativi ospitati su YouTube. I contenuti multimediali esterni vengono caricati solo dopo l'autorizzazione dell'utente. Se non si concede il consenso, viene visualizzata un'anteprima statica con il pulsante per attivare il video.",
    "sec3Title": "Panoramica Dettagliata delle Tecnologie Utilizzate",
    "sec3Intro": "La tabella seguente riporta tutte le tecnologie identificate e verificate durante l'audit tecnico del nostro sito:",
    "thName": "Nome",
    "thProvider": "Fornitore",
    "thStorageType": "Tipo di Archiviazione",
    "thPurpose": "Finalità",
    "thCategory": "Categoria",
    "thDuration": "Durata",
    "catBadgeNecessary": "Necessario",
    "catBadgeAnalytics": "Analitico",
    "catBadgeMedia": "Media Esterni",
    "consentStorageType": "Memoria Locale del Browser (LocalStorage)",
    "consentPurpose": "Salva le preferenze di consenso privacy dell'utente (sed_cookie_consent_v2)",
    "consentDuration": "Persistente (fino a cancellazione manuale nel browser)",
    "gaCookieType": "Cookie HTTP",
    "gaPurpose": "Distingue gli utenti unici per statistiche aggregate di visita",
    "gaDuration": "2 anni (solo previo consenso)",
    "ga4Purpose": "Mantiene lo stato della sessione e le metriche in Google Analytics 4",
    "ga4Duration": "2 anni (solo previo consenso)",
    "hsCookieType": "Cookie HTTP",
    "hsPurpose": "Misurazione del traffico del sito, monitoraggio delle prestazioni delle campagne di marketing e delle sessioni utente (HubSpot CRM)",
    "hsDuration": "Dalla sessione fino a 13 mesi (solo previo consenso)",
    "ytCookieType": "Cookie HTTP / LocalStorage",
    "ytPurpose": "Riproduzione di video integrati e preferenze del lettore in modalità di privacy avanzata",
    "ytDuration": "Dalla sessione fino a 2 anni (solo previo consenso)",
    "sec4Title": "Come Modificare le Proprie Preferenze?",
    "sec4P1": "Alla prima visita del sito, l'utente può accettare tutti i cookie opzionali, rifiutarli o configurare ciascuna categoria singolarmente.",
    "sec4P2": "È possibile modificare la scelta in qualsiasi momento cliccando sul link \"Impostazioni cookie\" presente nel footer del sito web o premendo il pulsante sottostante.",
    "changeSettingsBtn": "Apri Impostazioni Cookie",
    "sec4P3": "L'utente può inoltre eliminare i cookie e i dati del sito dalle impostazioni del proprio browser web in qualsiasi momento.",
    "sec5Title": "Titolare del Sito Web e Recapiti",
    "sec5P1": "Titolare del sito web e del trattamento dei dati:",
    "companyName": "JALUD Embedded s.r.o.",
    "companyAddress": "Nepomucká 1355/261, Černice, 326 00 Plzeň, Repubblica Ceca",
    "companyId": "IČO: 03056287",
    "contactEmail": "E-mail: <span class=\"sed-obf-email\" data-u=\"aW5mbw==\" data-d=\"amFsdWQtZW1iZWRkZWQuY29t\" data-t=\"aW5mb0BqYWx1ZC1lbWJlZGRlZC5jb20=\" style=\"color: var(--navy-dark); font-weight: 700;\"><span class=\"sed-obf-fallback\">info [at] jalud-embedded.com</span></span>",
    "privacyLinkText": "Per ulteriori dettagli sul trattamento dei dati personali, consulta la nostra",
    "privacyPageLink": "Informativa sulla Privacy",
    "googleLinksIntro": "Link informativi di terze parti:",
    "googlePrivacyLink": "Informativa sulla Privacy di Google",
    "googleCookieLink": "Modalità di utilizzo dei cookie e dei dati da parte di Google"
  }
};



export const legalTranslations = {
  eula: eulaData,
  terms: termsData,
  privacy: privacyData,
  productPrivacy: productPrivacyData,
  dpa: dpaData,
  support: supportData,
  ethics: ethicsData,
  ims: imsData,
  cookiePolicy: cookiePolicyTranslations
};
